(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './androidx-compose-runtime-runtime.js', './compose-multiplatform-core-compose-ui-ui-unit.js', './kotlinx-coroutines-core.js', './compose-multiplatform-core-compose-ui-ui-geometry.js', './androidx-collection-collection.js', './compose-multiplatform-core-compose-ui-ui-graphics.js', './compose-multiplatform-core-compose-ui-ui.js', './kotlinx-atomicfu.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./androidx-compose-runtime-runtime.js'), require('./compose-multiplatform-core-compose-ui-ui-unit.js'), require('./kotlinx-coroutines-core.js'), require('./compose-multiplatform-core-compose-ui-ui-geometry.js'), require('./androidx-collection-collection.js'), require('./compose-multiplatform-core-compose-ui-ui-graphics.js'), require('./compose-multiplatform-core-compose-ui-ui.js'), require('./kotlinx-atomicfu.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-animation-animation-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'compose-multiplatform-core-compose-animation-animation-core'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-animation-animation-core'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'compose-multiplatform-core-compose-animation-animation-core'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-unit'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-animation-animation-core'. Its dependency 'compose-multiplatform-core-compose-ui-ui-unit' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-unit' is loaded prior to 'compose-multiplatform-core-compose-animation-animation-core'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-animation-animation-core'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'compose-multiplatform-core-compose-animation-animation-core'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-geometry'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-animation-animation-core'. Its dependency 'compose-multiplatform-core-compose-ui-ui-geometry' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-geometry' is loaded prior to 'compose-multiplatform-core-compose-animation-animation-core'.");
    }
    if (typeof globalThis['androidx-collection-collection'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-animation-animation-core'. Its dependency 'androidx-collection-collection' was not found. Please, check whether 'androidx-collection-collection' is loaded prior to 'compose-multiplatform-core-compose-animation-animation-core'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-graphics'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-animation-animation-core'. Its dependency 'compose-multiplatform-core-compose-ui-ui-graphics' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-graphics' is loaded prior to 'compose-multiplatform-core-compose-animation-animation-core'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-animation-animation-core'. Its dependency 'compose-multiplatform-core-compose-ui-ui' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui' is loaded prior to 'compose-multiplatform-core-compose-animation-animation-core'.");
    }
    if (typeof globalThis['kotlinx-atomicfu'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-animation-animation-core'. Its dependency 'kotlinx-atomicfu' was not found. Please, check whether 'kotlinx-atomicfu' is loaded prior to 'compose-multiplatform-core-compose-animation-animation-core'.");
    }
    globalThis['compose-multiplatform-core-compose-animation-animation-core'] = factory(typeof globalThis['compose-multiplatform-core-compose-animation-animation-core'] === 'undefined' ? {} : globalThis['compose-multiplatform-core-compose-animation-animation-core'], globalThis['kotlin-kotlin-stdlib'], globalThis['androidx-compose-runtime-runtime'], globalThis['compose-multiplatform-core-compose-ui-ui-unit'], globalThis['kotlinx-coroutines-core'], globalThis['compose-multiplatform-core-compose-ui-ui-geometry'], globalThis['androidx-collection-collection'], globalThis['compose-multiplatform-core-compose-ui-ui-graphics'], globalThis['compose-multiplatform-core-compose-ui-ui'], globalThis['kotlinx-atomicfu']);
  }
}(function (_, kotlin_kotlin, kotlin_androidx_compose_runtime_runtime, kotlin_org_jetbrains_compose_ui_ui_unit, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_org_jetbrains_compose_ui_ui_geometry, kotlin_androidx_collection_collection, kotlin_org_jetbrains_compose_ui_ui_graphics, kotlin_org_jetbrains_compose_ui_ui, kotlin_org_jetbrains_kotlinx_atomicfu) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var hypot = Math.hypot;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var equals = kotlin_kotlin.$_$.sf;
  var KMutableProperty1 = kotlin_kotlin.$_$.wi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var VOID = kotlin_kotlin.$_$.d;
  var coerceIn = kotlin_kotlin.$_$.di;
  var Long = kotlin_kotlin.$_$.kn;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var protoOf = kotlin_kotlin.$_$.eh;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var CancellationException = kotlin_kotlin.$_$.fd;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var mutableStateOf = kotlin_androidx_compose_runtime_runtime.$_$.b2;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.v2;
  var Companion_getInstance = kotlin_androidx_compose_runtime_runtime.$_$.w2;
  var Companion_getInstance_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b4;
  var Dp = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.p;
  var rememberUpdatedState = kotlin_androidx_compose_runtime_runtime.$_$.g2;
  var Channel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h1;
  var SideEffect = kotlin_androidx_compose_runtime_runtime.$_$.d1;
  var LaunchedEffect = kotlin_androidx_compose_runtime_runtime.$_$.r;
  var KProperty0 = kotlin_kotlin.$_$.xi;
  var getLocalDelegateReference = kotlin_kotlin.$_$.wf;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y2;
  var isInterface = kotlin_kotlin.$_$.rg;
  var ChannelResult__getOrNull_impl_f5e07h = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.a;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q3;
  var Companion_getInstance_1 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.n1;
  var Size = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.j;
  var Companion_getInstance_2 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.l1;
  var Offset = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.c;
  var Companion_getInstance_3 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.m1;
  var IntCompanionObject_instance = kotlin_kotlin.$_$.w2;
  var Companion_getInstance_4 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.e4;
  var IntOffset = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.r;
  var Companion_getInstance_5 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.g4;
  var IntSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.t;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var isNaN_0 = kotlin_kotlin.$_$.qo;
  var toString = kotlin_kotlin.$_$.hh;
  var compare = kotlin_kotlin.$_$.je;
  var toString_0 = kotlin_kotlin.$_$.hp;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var divide = kotlin_kotlin.$_$.ne;
  var Enum = kotlin_kotlin.$_$.en;
  var hashCode = kotlin_kotlin.$_$.bg;
  var getNumberHashCode = kotlin_kotlin.$_$.xf;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var add = kotlin_kotlin.$_$.fe;
  var subtract = kotlin_kotlin.$_$.af;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var MutableIntList = kotlin_androidx_collection_collection.$_$.f;
  var MutableIntObjectMap = kotlin_androidx_collection_collection.$_$.g;
  var invert = kotlin_kotlin.$_$.qe;
  var shiftLeft = kotlin_kotlin.$_$.xe;
  var bitwiseAnd = kotlin_kotlin.$_$.ge;
  var shiftRight = kotlin_kotlin.$_$.ze;
  var fromInt = kotlin_kotlin.$_$.pe;
  var mutableIntObjectMapOf = kotlin_androidx_collection_collection.$_$.b1;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var numberToInt = kotlin_kotlin.$_$.ch;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.ce;
  var computeCubicVerticalBounds = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.b2;
  var _FloatFloatPair___get_packedValue__impl__5lczxp = kotlin_androidx_collection_collection.$_$.o1;
  var convertToInt = kotlin_kotlin.$_$.le;
  var floatFromBits = kotlin_kotlin.$_$.uf;
  var findFirstCubicRoot = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.f2;
  var evaluateCubic = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.e2;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var numberToLong = kotlin_kotlin.$_$.we;
  var multiply = kotlin_kotlin.$_$.ue;
  var toNumber = kotlin_kotlin.$_$.bf;
  var withFrameNanos = kotlin_androidx_compose_runtime_runtime.$_$.z2;
  var Key_instance = kotlin_org_jetbrains_compose_ui_ui.$_$.xb;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var isArray = kotlin_kotlin.$_$.jg;
  var snapshotFlow = kotlin_androidx_compose_runtime_runtime.$_$.h2;
  var first = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.s;
  var updateChangedFlags = kotlin_androidx_compose_runtime_runtime.$_$.q2;
  var MutableVector = kotlin_androidx_compose_runtime_runtime.$_$.a;
  var DisposableEffect = kotlin_androidx_compose_runtime_runtime.$_$.q;
  var CancellationException_init_$Create$ = kotlin_kotlin.$_$.q4;
  var Key_instance_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var Mutex = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o2;
  var coroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
  var captureStack = kotlin_kotlin.$_$.gf;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var toRawBits = kotlin_kotlin.$_$.gp;
  var isNaN_1 = kotlin_kotlin.$_$.ro;
  var toRawBits_0 = kotlin_kotlin.$_$.fp;
  var bitwiseOr = kotlin_kotlin.$_$.he;
  var Key_instance_1 = kotlin_org_jetbrains_compose_ui_ui.$_$.fc;
  var mutableFloatStateOf = kotlin_androidx_compose_runtime_runtime.$_$.v1;
  var mutableLongStateOf = kotlin_androidx_compose_runtime_runtime.$_$.x1;
  var roundToLong = kotlin_kotlin.$_$.lh;
  var EmptyCoroutineContext_getInstance = kotlin_kotlin.$_$.q2;
  var get_isActive = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o3;
  var CoroutineStart_UNDISPATCHED_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o;
  var mutableStateListOf = kotlin_androidx_compose_runtime_runtime.$_$.z1;
  var derivedStateOf = kotlin_androidx_compose_runtime_runtime.$_$.p1;
  var KProperty1 = kotlin_kotlin.$_$.yi;
  var createCompositionCoroutineScope = kotlin_androidx_compose_runtime_runtime.$_$.k1;
  var DisposableEffect_0 = kotlin_androidx_compose_runtime_runtime.$_$.p;
  var until = kotlin_kotlin.$_$.mi;
  var fill = kotlin_kotlin.$_$.i9;
  var intercepted = kotlin_kotlin.$_$.jd;
  var CancellableContinuationImpl = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q2;
  var returnIfSuspended = kotlin_kotlin.$_$.w3;
  var MutableObjectList = kotlin_androidx_collection_collection.$_$.m;
  var Companion_instance = kotlin_androidx_compose_runtime_runtime.$_$.u2;
  var LaunchedEffect_0 = kotlin_androidx_compose_runtime_runtime.$_$.s;
  var SnapshotStateObserver = kotlin_androidx_compose_runtime_runtime.$_$.e;
  var Companion_instance_0 = kotlin_kotlin.$_$.j3;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z;
  var _Dp___get_value__impl__geb1vb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.l2;
  var _Dp___init__impl__ms3zkb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.h2;
  var _DpOffset___get_x__impl__uauqb5 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.p2;
  var _DpOffset___get_y__impl__1h898y = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.q2;
  var _DpOffset___init__impl__yq36wy = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.m2;
  var DpOffset = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.m;
  var _Size___get_packedValue__impl__7rlt1o = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.g1;
  var _Size___init__impl__aywn0g = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.c1;
  var _Offset___get_packedValue__impl__xh2k8q = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.y;
  var _Offset___init__impl__c168vi = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.r;
  var _IntOffset___get_x__impl__qiqr5o = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b3;
  var _IntOffset___get_y__impl__2avpwj = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c3;
  var roundToInt = kotlin_kotlin.$_$.kh;
  var _IntOffset___init__impl__rq8h7b = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.v2;
  var _IntSize___get_packedValue__impl__uho7jf = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.f3;
  var _IntSize___init__impl__emcjft = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d3;
  var Rect = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.f;
  var modulo = kotlin_kotlin.$_$.te;
  var to = kotlin_kotlin.$_$.ip;
  var Companion_getInstance_6 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c4;
  var mapOf = kotlin_kotlin.$_$.wa;
  var compareTo = kotlin_kotlin.$_$.nf;
  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.a6;
  var atomic$ref$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.d;
  var CancellationException_init_$Init$ = kotlin_kotlin.$_$.p4;
  //endregion
  //region block: pre-declaration
  initMetadataForLambda(Animatable$runAnimation$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(Animatable$snapTo$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(Animatable$stop$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForClass(Animatable, 'Animatable', VOID, VOID, VOID, [4, 3, 1, 0]);
  initMetadataForClass(AnimationResult, 'AnimationResult');
  initMetadataForLambda(animateValueAsState$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(animateValueAsState$slambda, CoroutineImpl, VOID, [1]);
  function isFinishedFromNanos(playTimeNanos) {
    return compare(playTimeNanos, this.jee()) >= 0;
  }
  initMetadataForInterface(Animation, 'Animation');
  initMetadataForClass(TargetBasedAnimation, 'TargetBasedAnimation', VOID, VOID, [Animation]);
  initMetadataForClass(DecayAnimation, 'DecayAnimation', VOID, VOID, [Animation]);
  initMetadataForClass(AnimationEndReason, 'AnimationEndReason', VOID, Enum);
  initMetadataForInterface(FiniteAnimationSpec, 'FiniteAnimationSpec');
  initMetadataForClass(SpringSpec, 'SpringSpec', SpringSpec, VOID, [FiniteAnimationSpec]);
  initMetadataForClass(TweenSpec, 'TweenSpec', TweenSpec, VOID, [FiniteAnimationSpec]);
  initMetadataForClass(SnapSpec, 'SnapSpec', SnapSpec, VOID, [FiniteAnimationSpec]);
  initMetadataForClass(StartDelayAnimationSpec, 'StartDelayAnimationSpec');
  function getEndVelocity(initialValue, targetValue, initialVelocity) {
    return this.mee(this.kee(initialValue, targetValue, initialVelocity), initialValue, targetValue, initialVelocity);
  }
  initMetadataForInterface(VectorizedAnimationSpec, 'VectorizedAnimationSpec');
  initMetadataForClass(StartDelayVectorizedAnimationSpec, 'StartDelayVectorizedAnimationSpec', VOID, VOID, [VectorizedAnimationSpec]);
  initMetadataForClass(InfiniteRepeatableSpec, 'InfiniteRepeatableSpec');
  initMetadataForClass(RepeatMode, 'RepeatMode', VOID, Enum);
  initMetadataForClass(ArcAnimationSpec, 'ArcAnimationSpec', VOID, VOID, [FiniteAnimationSpec]);
  initMetadataForClass(KeyframesSpecBaseConfig, 'KeyframesSpecBaseConfig');
  initMetadataForClass(KeyframesSpecConfig, 'KeyframesSpecConfig', KeyframesSpecConfig, KeyframesSpecBaseConfig);
  initMetadataForClass(KeyframeBaseEntity, 'KeyframeBaseEntity');
  initMetadataForClass(KeyframeEntity, 'KeyframeEntity', VOID, KeyframeBaseEntity);
  initMetadataForClass(KeyframesSpec, 'KeyframesSpec', VOID, VOID, [FiniteAnimationSpec]);
  initMetadataForClass(KeyframesWithSplineSpec, 'KeyframesWithSplineSpec', VOID, VOID, [FiniteAnimationSpec]);
  initMetadataForCompanion(Companion);
  initMetadataForClass(AnimationState, 'AnimationState');
  initMetadataForClass(AnimationScope, 'AnimationScope');
  initMetadataForClass(AnimationVector_3, 'AnimationVector');
  initMetadataForClass(AnimationVector4D, 'AnimationVector4D', VOID, AnimationVector_3);
  initMetadataForClass(AnimationVector1D, 'AnimationVector1D', VOID, AnimationVector_3);
  initMetadataForClass(AnimationVector2D, 'AnimationVector2D', VOID, AnimationVector_3);
  initMetadataForClass(AnimationVector3D, 'AnimationVector3D', VOID, AnimationVector_3);
  initMetadataForClass(Arc, 'Arc');
  initMetadataForClass(ArcSpline, 'ArcSpline');
  initMetadataForClass(DecayAnimationSpecImpl, 'DecayAnimationSpecImpl');
  initMetadataForClass(VectorizedFloatDecaySpec, 'VectorizedFloatDecaySpec');
  initMetadataForInterface(Easing, 'Easing');
  initMetadataForClass(CubicBezierEasing, 'CubicBezierEasing', VOID, VOID, [Easing]);
  initMetadataForClass(sam$androidx_compose_animation_core_Easing$0, 'sam$androidx_compose_animation_core_Easing$0', VOID, VOID, [Easing, FunctionAdapter]);
  function getEndVelocity_0(initialValue, targetValue, initialVelocity) {
    return this.zei(this.yei(initialValue, targetValue, initialVelocity), initialValue, targetValue, initialVelocity);
  }
  function vectorize(converter) {
    return VectorizedFloatAnimationSpec_init_$Create$(this);
  }
  initMetadataForInterface(FloatAnimationSpec, 'FloatAnimationSpec');
  initMetadataForClass(FloatTweenSpec, 'FloatTweenSpec', FloatTweenSpec, VOID, [FloatAnimationSpec]);
  initMetadataForClass(FloatSpringSpec, 'FloatSpringSpec', FloatSpringSpec, VOID, [FloatAnimationSpec]);
  initMetadataForClass(FloatExponentialDecaySpec, 'FloatExponentialDecaySpec', FloatExponentialDecaySpec);
  initMetadataForLambda(withInfiniteAnimationFrameNanos$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForCoroutine($withInfiniteAnimationFrameNanosCOROUTINE$, CoroutineImpl);
  initMetadataForLambda(InfiniteTransition$run$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(TransitionAnimationState, 'TransitionAnimationState');
  initMetadataForLambda(InfiniteTransition$run$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(InfiniteTransition, 'InfiniteTransition');
  initMetadataForClass(animateValue$$inlined$cache$2$1);
  initMetadataForClass(Mutator, 'Mutator');
  initMetadataForLambda(MutatorMutex$mutate$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(MutatorMutex, 'MutatorMutex', MutatorMutex, VOID, VOID, [2, 3]);
  initMetadataForClass(MutatePriority, 'MutatePriority', VOID, Enum);
  initMetadataForClass(PlatformOptimizedCancellationException, 'PlatformOptimizedCancellationException', VOID, CancellationException);
  initMetadataForClass(MutationInterruptedException, 'MutationInterruptedException', MutationInterruptedException, PlatformOptimizedCancellationException);
  initMetadataForClass(SpringSimulation, 'SpringSimulation');
  initMetadataForCoroutine($animateCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($callWithFrameNanosCOROUTINE$, CoroutineImpl);
  initMetadataForClass(DeferredAnimationData, 'DeferredAnimationData');
  initMetadataForClass(TransitionAnimationState_0, 'TransitionAnimationState');
  function isTransitioningTo(_this__u8e3s4, targetState) {
    return equals(_this__u8e3s4, this.rep()) && equals(targetState, this.o70());
  }
  initMetadataForInterface(Segment, 'Segment');
  initMetadataForClass(SegmentImpl, 'SegmentImpl', VOID, VOID, [Segment]);
  initMetadataForClass(DeferredAnimation, 'DeferredAnimation');
  initMetadataForLambda(Transition$animateTo$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(Transition$animateTo$$inlined$cache$1$2);
  initMetadataForClass(Transition, 'Transition');
  initMetadataForLambda(SeekableTransitionState$seekTo$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(SeekableTransitionState$seekTo$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(SeekableTransitionState$animateTo$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(SeekingAnimationState, 'SeekingAnimationState', SeekingAnimationState);
  initMetadataForCompanion(Companion_0);
  initMetadataForLambda(SeekableTransitionState$snapTo$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(SeekableTransitionState$seekTo$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(SeekableTransitionState$animateTo$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForCoroutine($runAnimationsCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($doOneFrameCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($animateOneFrameCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($waitForCompositionAfterTargetStateChangeCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($waitForCompositionCOROUTINE$, CoroutineImpl);
  initMetadataForClass(TransitionState, 'TransitionState');
  initMetadataForClass(SeekableTransitionState, 'SeekableTransitionState', VOID, TransitionState, VOID, [0, 1, 2]);
  initMetadataForClass(MutableTransitionState, 'MutableTransitionState', VOID, TransitionState);
  initMetadataForClass(updateTransition$$inlined$cache$1$1);
  initMetadataForClass(createTransitionAnimation$$inlined$cache$1$1);
  initMetadataForClass(createDeferredAnimation$$inlined$cache$1$1);
  initMetadataForLambda(rememberTransition$lambda$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(rememberTransition$$inlined$cache$1$2);
  initMetadataForLambda(rememberTransition$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(rememberTransition$$inlined$cache$3$1);
  initMetadataForClass(createChildTransitionInternal$$inlined$cache$1$1);
  initMetadataForClass(TwoWayConverterImpl, 'TwoWayConverterImpl');
  function get_isInfinite() {
    return false;
  }
  initMetadataForInterface(VectorizedFiniteAnimationSpec, 'VectorizedFiniteAnimationSpec', VOID, VOID, [VectorizedAnimationSpec]);
  initMetadataForClass(VectorizedSpringSpec, 'VectorizedSpringSpec', VectorizedSpringSpec_init_$Create$, VOID, [VectorizedFiniteAnimationSpec]);
  function getDurationNanos(initialValue, targetValue, initialVelocity) {
    return multiply(numberToLong(this.df0() + this.cf0() | 0), new Long(1000000, 0));
  }
  initMetadataForInterface(VectorizedDurationBasedAnimationSpec, 'VectorizedDurationBasedAnimationSpec', VOID, VOID, [VectorizedFiniteAnimationSpec]);
  initMetadataForClass(VectorizedTweenSpec, 'VectorizedTweenSpec', VectorizedTweenSpec, VOID, [VectorizedDurationBasedAnimationSpec]);
  initMetadataForClass(VectorizedSnapSpec, 'VectorizedSnapSpec', VectorizedSnapSpec, VOID, [VectorizedDurationBasedAnimationSpec]);
  initMetadataForClass(VectorizedFloatAnimationSpec$1);
  initMetadataForClass(VectorizedFloatAnimationSpec, 'VectorizedFloatAnimationSpec', VOID, VOID, [VectorizedFiniteAnimationSpec]);
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(ArcMode, 'ArcMode');
  initMetadataForClass(VectorizedInfiniteRepeatableSpec, 'VectorizedInfiniteRepeatableSpec', VOID, VOID, [VectorizedAnimationSpec]);
  initMetadataForClass(VectorizedKeyframesSpec, 'VectorizedKeyframesSpec', VOID, VOID, [VectorizedDurationBasedAnimationSpec]);
  initMetadataForClass(VectorizedKeyframeSpecElementInfo, 'VectorizedKeyframeSpecElementInfo');
  initMetadataForClass(createSpringAnimations$1);
  initMetadataForClass(createSpringAnimations$2);
  initMetadataForClass(AtomicReference, 'AtomicReference');
  //endregion
  function get_positiveInfinityBounds1D() {
    _init_properties_Animatable_kt__f2hc5e();
    return positiveInfinityBounds1D;
  }
  var positiveInfinityBounds1D;
  function get_positiveInfinityBounds2D() {
    _init_properties_Animatable_kt__f2hc5e();
    return positiveInfinityBounds2D;
  }
  var positiveInfinityBounds2D;
  function get_positiveInfinityBounds3D() {
    _init_properties_Animatable_kt__f2hc5e();
    return positiveInfinityBounds3D;
  }
  var positiveInfinityBounds3D;
  function get_positiveInfinityBounds4D() {
    _init_properties_Animatable_kt__f2hc5e();
    return positiveInfinityBounds4D;
  }
  var positiveInfinityBounds4D;
  function get_negativeInfinityBounds1D() {
    _init_properties_Animatable_kt__f2hc5e();
    return negativeInfinityBounds1D;
  }
  var negativeInfinityBounds1D;
  function get_negativeInfinityBounds2D() {
    _init_properties_Animatable_kt__f2hc5e();
    return negativeInfinityBounds2D;
  }
  var negativeInfinityBounds2D;
  function get_negativeInfinityBounds3D() {
    _init_properties_Animatable_kt__f2hc5e();
    return negativeInfinityBounds3D;
  }
  var negativeInfinityBounds3D;
  function get_negativeInfinityBounds4D() {
    _init_properties_Animatable_kt__f2hc5e();
    return negativeInfinityBounds4D;
  }
  var negativeInfinityBounds4D;
  var androidx_compose_animation_core_Animatable$stable;
  var androidx_compose_animation_core_AnimationResult$stable;
  function Animatable$runAnimation$slambda$lambda(this$0, $endState, $block, $clampingNeeded) {
    return function ($this$animate) {
      updateState($this$animate, this$0.ge9_1);
      var clamped = clampToBounds(this$0, $this$animate.u1());
      if (!equals(clamped, $this$animate.u1())) {
        this$0.ge9_1.gea(clamped);
        $endState.gea(clamped);
        var tmp0_safe_receiver = $block;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver(this$0);
        $this$animate.hea();
        $clampingNeeded._v = true;
      } else {
        var tmp1_safe_receiver = $block;
        if (tmp1_safe_receiver == null)
          null;
        else
          tmp1_safe_receiver(this$0);
      }
      return Unit_instance;
    };
  }
  function _set_isRunning__kpbg34($this, _set____db54di) {
    var tmp0 = $this.he9_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Animatable$_get_isRunning_$ref_121fnp();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('isRunning', 1, tmp, tmp_0, Animatable$_set_isRunning_$ref_g9sy61());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _set_targetValue__aqsk0r($this, _set____db54di) {
    var tmp0 = $this.ie9_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Animatable$_get_targetValue_$ref_gosum2();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('targetValue', 1, tmp, tmp_0, Animatable$_set_targetValue_$ref_6l2n3i());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function runAnimation($this, animation, initialVelocity, block, $completion) {
    var startTime = $this.ge9_1.dea_1;
    return $this.le9_1.kea(VOID, Animatable$runAnimation$slambda_0($this, initialVelocity, animation, startTime, block, null), $completion);
  }
  function clampToBounds($this, value) {
    if (equals($this.pe9_1, $this.ne9_1) && equals($this.qe9_1, $this.oe9_1)) {
      return value;
    }
    var valueVector = $this.de9_1.lea()(value);
    var clamped = false;
    var inductionVariable = 0;
    var last = valueVector.mea();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (valueVector.nea(i) < $this.pe9_1.nea(i) || valueVector.nea(i) > $this.qe9_1.nea(i)) {
          clamped = true;
          valueVector.oea(i, coerceIn(valueVector.nea(i), $this.pe9_1.nea(i), $this.qe9_1.nea(i)));
        }
      }
       while (inductionVariable < last);
    if (clamped) {
      return $this.de9_1.pea()(valueVector);
    } else {
      return value;
    }
  }
  function endAnimation($this) {
    // Inline function 'kotlin.apply' call
    var this_0 = $this.ge9_1;
    this_0.cea_1.qea();
    this_0.dea_1 = new Long(0, -2147483648);
    _set_isRunning__kpbg34($this, false);
  }
  function Animatable$_get_isRunning_$ref_121fnp() {
    return constructCallableReference(function (p0) {
      return p0.rea();
    }, 1, 0, 173);
  }
  function Animatable$_set_isRunning_$ref_g9sy61() {
    return constructCallableReference(function (p0, p1) {
      _set_isRunning__kpbg34(p0, p1);
      return Unit_instance;
    }, 2, 0, 174);
  }
  function Animatable$_get_targetValue_$ref_gosum2() {
    return constructCallableReference(function (p0) {
      return p0.sea();
    }, 1, 0, 175);
  }
  function Animatable$_set_targetValue_$ref_6l2n3i() {
    return constructCallableReference(function (p0, p1) {
      _set_targetValue__aqsk0r(p0, p1);
      return Unit_instance;
    }, 2, 0, 176);
  }
  function Animatable$runAnimation$slambda(this$0, $initialVelocity, $animation, $startTime, $block, resultContinuation) {
    this.beb_1 = this$0;
    this.ceb_1 = $initialVelocity;
    this.deb_1 = $animation;
    this.eeb_1 = $startTime;
    this.feb_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Animatable$runAnimation$slambda).jeb = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(Animatable$runAnimation$slambda).ia = function ($completion) {
    return this.jeb($completion);
  };
  protoOf(Animatable$runAnimation$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            this.beb_1.ge9_1.cea_1 = this.beb_1.de9_1.lea()(this.ceb_1);
            _set_targetValue__aqsk0r(this.beb_1, this.deb_1.sea());
            _set_isRunning__kpbg34(this.beb_1, true);
            this.heb_1 = copy(this.beb_1.ge9_1, VOID, VOID, VOID, new Long(0, -2147483648));
            this.ieb_1 = {_v: false};
            this.n9_1 = 1;
            suspendResult = animate_0(this.heb_1, this.deb_1, this.eeb_1, Animatable$runAnimation$slambda$lambda(this.beb_1, this.heb_1, this.feb_1, this.ieb_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var endReason = this.ieb_1._v ? AnimationEndReason_BoundReached_getInstance() : AnimationEndReason_Finished_getInstance();
            endAnimation(this.beb_1);
            this.geb_1 = new AnimationResult(this.heb_1, endReason);
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof CancellationException) {
              var e = this.q9_1;
              var tmp_1 = this;
              endAnimation(this.beb_1);
              throw e;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return this.geb_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 3) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(Animatable$runAnimation$slambda).s2b = function (completion) {
    return new Animatable$runAnimation$slambda(this.beb_1, this.ceb_1, this.deb_1, this.eeb_1, this.feb_1, completion);
  };
  function Animatable$runAnimation$slambda_0(this$0, $initialVelocity, $animation, $startTime, $block, resultContinuation) {
    var i = new Animatable$runAnimation$slambda(this$0, $initialVelocity, $animation, $startTime, $block, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.jeb($completion);
    }, 0);
  }
  function Animatable$snapTo$slambda(this$0, $targetValue, resultContinuation) {
    this.seb_1 = this$0;
    this.teb_1 = $targetValue;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Animatable$snapTo$slambda).r2b = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(Animatable$snapTo$slambda).ia = function ($completion) {
    return this.r2b($completion);
  };
  protoOf(Animatable$snapTo$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          endAnimation(this.seb_1);
          var clampedValue = clampToBounds(this.seb_1, this.teb_1);
          this.seb_1.ge9_1.gea(clampedValue);
          _set_targetValue__aqsk0r(this.seb_1, clampedValue);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(Animatable$snapTo$slambda).s2b = function (completion) {
    return new Animatable$snapTo$slambda(this.seb_1, this.teb_1, completion);
  };
  function Animatable$snapTo$slambda_0(this$0, $targetValue, resultContinuation) {
    var i = new Animatable$snapTo$slambda(this$0, $targetValue, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.r2b($completion);
    }, 0);
  }
  function Animatable$stop$slambda(this$0, resultContinuation) {
    this.cec_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Animatable$stop$slambda).r2b = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(Animatable$stop$slambda).ia = function ($completion) {
    return this.r2b($completion);
  };
  protoOf(Animatable$stop$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          endAnimation(this.cec_1);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(Animatable$stop$slambda).s2b = function (completion) {
    return new Animatable$stop$slambda(this.cec_1, completion);
  };
  function Animatable$stop$slambda_0(this$0, resultContinuation) {
    var i = new Animatable$stop$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.r2b($completion);
    }, 0);
  }
  function Animatable(initialValue, typeConverter, visibilityThreshold, label) {
    visibilityThreshold = visibilityThreshold === VOID ? null : visibilityThreshold;
    label = label === VOID ? 'Animatable' : label;
    this.de9_1 = typeConverter;
    this.ee9_1 = visibilityThreshold;
    this.fe9_1 = label;
    this.ge9_1 = new AnimationState(this.de9_1, initialValue);
    this.he9_1 = mutableStateOf(false);
    this.ie9_1 = mutableStateOf(initialValue);
    this.je9_1 = null;
    this.ke9_1 = null;
    this.le9_1 = new MutatorMutex();
    this.me9_1 = new SpringSpec(VOID, VOID, this.ee9_1);
    var tmp = this;
    var tmp0_subject = this.dec();
    var tmp_0;
    if (tmp0_subject instanceof AnimationVector1D) {
      tmp_0 = get_negativeInfinityBounds1D();
    } else {
      if (tmp0_subject instanceof AnimationVector2D) {
        tmp_0 = get_negativeInfinityBounds2D();
      } else {
        if (tmp0_subject instanceof AnimationVector3D) {
          tmp_0 = get_negativeInfinityBounds3D();
        } else {
          tmp_0 = get_negativeInfinityBounds4D();
        }
      }
    }
    var tmp_1 = tmp_0;
    tmp.ne9_1 = tmp_1 instanceof AnimationVector_3 ? tmp_1 : THROW_CCE();
    var tmp_2 = this;
    var tmp0_subject_0 = this.dec();
    var tmp_3;
    if (tmp0_subject_0 instanceof AnimationVector1D) {
      tmp_3 = get_positiveInfinityBounds1D();
    } else {
      if (tmp0_subject_0 instanceof AnimationVector2D) {
        tmp_3 = get_positiveInfinityBounds2D();
      } else {
        if (tmp0_subject_0 instanceof AnimationVector3D) {
          tmp_3 = get_positiveInfinityBounds3D();
        } else {
          tmp_3 = get_positiveInfinityBounds4D();
        }
      }
    }
    var tmp_4 = tmp_3;
    tmp_2.oe9_1 = tmp_4 instanceof AnimationVector_3 ? tmp_4 : THROW_CCE();
    this.pe9_1 = this.ne9_1;
    this.qe9_1 = this.oe9_1;
  }
  protoOf(Animatable).u1 = function () {
    return this.ge9_1.u1();
  };
  protoOf(Animatable).dec = function () {
    return this.ge9_1.cea_1;
  };
  protoOf(Animatable).eec = function () {
    return this.de9_1.pea()(this.dec());
  };
  protoOf(Animatable).rea = function () {
    var tmp0 = this.he9_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Animatable$_get_isRunning_$ref_121fnp();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('isRunning', 1, tmp, tmp_0, Animatable$_set_isRunning_$ref_g9sy61());
    return tmp0.u1();
  };
  protoOf(Animatable).sea = function () {
    var tmp0 = this.ie9_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Animatable$_get_targetValue_$ref_gosum2();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('targetValue', 1, tmp, tmp_0, Animatable$_set_targetValue_$ref_6l2n3i());
    return tmp0.u1();
  };
  protoOf(Animatable).fec = function (targetValue, animationSpec, initialVelocity, block, $completion) {
    var tmp0_initialValue = this.u1();
    var tmp1_typeConverter = this.de9_1;
    var anim = TargetBasedAnimation_0(animationSpec, tmp1_typeConverter, tmp0_initialValue, targetValue, initialVelocity);
    return runAnimation(this, anim, initialVelocity, block, $completion);
  };
  protoOf(Animatable).gec = function (targetValue, animationSpec, initialVelocity, block, $completion, $super) {
    animationSpec = animationSpec === VOID ? this.me9_1 : animationSpec;
    initialVelocity = initialVelocity === VOID ? this.eec() : initialVelocity;
    block = block === VOID ? null : block;
    return $super === VOID ? this.fec(targetValue, animationSpec, initialVelocity, block, $completion) : $super.fec.call(this, targetValue, animationSpec, initialVelocity, block, $completion);
  };
  protoOf(Animatable).hec = function (targetValue, $completion) {
    return this.le9_1.kea(VOID, Animatable$snapTo$slambda_0(this, targetValue, null), $completion);
  };
  protoOf(Animatable).iec = function ($completion) {
    return this.le9_1.kea(VOID, Animatable$stop$slambda_0(this, null), $completion);
  };
  protoOf(Animatable).jec = function () {
    return this.ge9_1;
  };
  function Animatable_0(initialValue, visibilityThreshold) {
    visibilityThreshold = visibilityThreshold === VOID ? 0.01 : visibilityThreshold;
    _init_properties_Animatable_kt__f2hc5e();
    return new Animatable(initialValue, get_VectorConverter(FloatCompanionObject_instance), visibilityThreshold);
  }
  function AnimationResult(endState, endReason) {
    this.kec_1 = endState;
    this.lec_1 = endReason;
  }
  protoOf(AnimationResult).toString = function () {
    return 'AnimationResult(endReason=' + this.lec_1.toString() + ', endState=' + this.kec_1.toString() + ')';
  };
  function androidx_compose_animation_core_Animatable$stableprop_getter() {
    return androidx_compose_animation_core_Animatable$stable;
  }
  var properties_initialized_Animatable_kt_s5cd7k;
  function _init_properties_Animatable_kt__f2hc5e() {
    if (!properties_initialized_Animatable_kt_s5cd7k) {
      properties_initialized_Animatable_kt_s5cd7k = true;
      positiveInfinityBounds1D = AnimationVector(Infinity);
      positiveInfinityBounds2D = AnimationVector_0(Infinity, Infinity);
      positiveInfinityBounds3D = AnimationVector_1(Infinity, Infinity, Infinity);
      positiveInfinityBounds4D = AnimationVector_2(Infinity, Infinity, Infinity, Infinity);
      negativeInfinityBounds1D = AnimationVector(-Infinity);
      negativeInfinityBounds2D = AnimationVector_0(-Infinity, -Infinity);
      negativeInfinityBounds3D = AnimationVector_1(-Infinity, -Infinity, -Infinity);
      negativeInfinityBounds4D = AnimationVector_2(-Infinity, -Infinity, -Infinity, -Infinity);
      androidx_compose_animation_core_Animatable$stable = 8;
      androidx_compose_animation_core_AnimationResult$stable = 0;
    }
  }
  function get_defaultAnimation() {
    _init_properties_AnimateAsState_kt__7h7b9a();
    return defaultAnimation;
  }
  var defaultAnimation;
  function get_dpDefaultSpring() {
    _init_properties_AnimateAsState_kt__7h7b9a();
    return dpDefaultSpring;
  }
  var dpDefaultSpring;
  var sizeDefaultSpring;
  var offsetDefaultSpring;
  var rectDefaultSpring;
  var intDefaultSpring;
  var intOffsetDefaultSpring;
  var intSizeDefaultSpring;
  function animateFloatAsState(targetValue, animationSpec, visibilityThreshold, label, finishedListener, $composer, $changed, $default) {
    _init_properties_AnimateAsState_kt__7h7b9a();
    var animationSpec_0 = animationSpec;
    var visibilityThreshold_0 = visibilityThreshold;
    var label_0 = label;
    var finishedListener_0 = finishedListener;
    var $composer_0 = $composer;
    if (!(($default & 2) === 0))
      animationSpec_0 = get_defaultAnimation();
    if (!(($default & 4) === 0))
      visibilityThreshold_0 = 0.01;
    if (!(($default & 8) === 0))
      label_0 = 'FloatAnimation';
    if (!(($default & 16) === 0))
      finishedListener_0 = null;
    var tmp;
    if (animationSpec_0 === get_defaultAnimation()) {
      $composer_0.m30(1144115775);
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($changed & 896 ^ 384) > 256 && $composer_0.n31(visibilityThreshold_0) || ($changed & 384) === 256;
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp_0;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = spring(VOID, VOID, visibilityThreshold_0);
        $composer_0.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var tmp1_group = tmp_0;
      $composer_0.n30();
      tmp = tmp1_group;
    } else {
      $composer_0.m30(1144225701);
      $composer_0.n30();
      tmp = animationSpec_0;
    }
    var resolvedAnimSpec = tmp;
    return animateValueAsState(targetValue, get_VectorConverter(FloatCompanionObject_instance), resolvedAnimSpec, visibilityThreshold_0 === 0.01 ? null : visibilityThreshold_0, label_0, finishedListener_0, $composer_0, 14 & $changed | 57344 & $changed << 3 | 458752 & $changed << 3, 0);
  }
  function animateDpAsState(targetValue, animationSpec, label, finishedListener, $composer, $changed, $default) {
    _init_properties_AnimateAsState_kt__7h7b9a();
    var animationSpec_0 = animationSpec;
    var label_0 = label;
    var finishedListener_0 = finishedListener;
    var $composer_0 = $composer;
    if (!(($default & 2) === 0))
      animationSpec_0 = get_dpDefaultSpring();
    if (!(($default & 4) === 0))
      label_0 = 'DpAnimation';
    if (!(($default & 8) === 0))
      finishedListener_0 = null;
    var tmp = get_VectorConverter_0(Companion_getInstance_0());
    var tmp_0 = animationSpec_0;
    return animateValueAsState(new Dp(targetValue), tmp, tmp_0, null, label_0, finishedListener_0, $composer_0, 14 & $changed | 896 & $changed << 3 | 57344 & $changed << 6 | 458752 & $changed << 6, 8);
  }
  function animateValueAsState(targetValue, typeConverter, animationSpec, visibilityThreshold, label, finishedListener, $composer, $changed, $default) {
    _init_properties_AnimateAsState_kt__7h7b9a();
    var animationSpec_0 = animationSpec;
    var visibilityThreshold_0 = visibilityThreshold;
    var label_0 = label;
    var finishedListener_0 = finishedListener;
    var $composer_0 = $composer;
    if (!(($default & 4) === 0)) {
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp;
      if (false || it === Companion_getInstance().f30_1) {
        var value = spring();
        $composer_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      animationSpec_0 = tmp;
    }
    if (!(($default & 8) === 0))
      visibilityThreshold_0 = null;
    if (!(($default & 16) === 0))
      label_0 = 'ValueAnimation';
    if (!(($default & 32) === 0))
      finishedListener_0 = null;
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_0;
    if (false || it_0 === Companion_getInstance().f30_1) {
      var value_0 = mutableStateOf(null);
      $composer_0.j31(value_0);
      tmp_0 = value_0;
    } else {
      tmp_0 = it_0;
    }
    var toolingOverride = tmp_0;
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it_1 = $composer_0.i31();
    var tmp_1;
    if (false || it_1 === Companion_getInstance().f30_1) {
      var value_1 = new Animatable(targetValue, typeConverter, visibilityThreshold_0, label_0);
      $composer_0.j31(value_1);
      tmp_1 = value_1;
    } else {
      tmp_1 = it_1;
    }
    var animatable = tmp_1;
    var listener$delegate = rememberUpdatedState(finishedListener_0, $composer_0, 14 & $changed >> 15);
    // Inline function 'kotlin.run' call
    var $this$run = animationSpec_0;
    var tmp_2;
    var tmp_3;
    var tmp_4;
    if (!(visibilityThreshold_0 == null)) {
      tmp_4 = $this$run instanceof SpringSpec;
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = !equals($this$run.oec_1, visibilityThreshold_0);
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = spring($this$run.mec_1, $this$run.nec_1, visibilityThreshold_0);
    } else {
      tmp_2 = $this$run;
    }
    var tmp$ret$12 = tmp_2;
    var animSpec$delegate = rememberUpdatedState(tmp$ret$12, $composer_0, 0);
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it_2 = $composer_0.i31();
    var tmp_5;
    if (false || it_2 === Companion_getInstance().f30_1) {
      var value_2 = Channel(-1);
      $composer_0.j31(value_2);
      tmp_5 = value_2;
    } else {
      tmp_5 = it_2;
    }
    var channel = tmp_5;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!($composer_0.q31(channel) | (($changed & 14 ^ 6) > 4 && $composer_0.q31(targetValue) || ($changed & 6) === 4));
    // Inline function 'kotlin.let' call
    var it_3 = $composer_0.i31();
    var tmp_6;
    if (invalid || it_3 === Companion_getInstance().f30_1) {
      var value_3 = animateValueAsState$lambda_1(channel, targetValue);
      $composer_0.j31(value_3);
      tmp_6 = value_3;
    } else {
      tmp_6 = it_3;
    }
    var tmp$ret$18 = tmp_6;
    SideEffect(tmp$ret$18, $composer_0, 0);
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid_0 = !!(!!(!!($composer_0.q31(channel) | $composer_0.q31(animatable)) | $composer_0.k31(animSpec$delegate)) | $composer_0.k31(listener$delegate));
    // Inline function 'kotlin.let' call
    var it_4 = $composer_0.i31();
    var tmp_7;
    if (invalid_0 || it_4 === Companion_getInstance().f30_1) {
      var value_4 = animateValueAsState$slambda_0(channel, animatable, animSpec$delegate, listener$delegate, null);
      $composer_0.j31(value_4);
      tmp_7 = value_4;
    } else {
      tmp_7 = it_4;
    }
    var tmp$ret$22 = tmp_7;
    LaunchedEffect(channel, tmp$ret$22, $composer_0, 0);
    var tmp0_elvis_lhs = toolingOverride.u1();
    return tmp0_elvis_lhs == null ? animatable.jec() : tmp0_elvis_lhs;
  }
  function animateValueAsState$lambda($listener$delegate) {
    _init_properties_AnimateAsState_kt__7h7b9a();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('listener', KProperty0, false);
    return $listener$delegate.u1();
  }
  function animateValueAsState$lambda_0($animSpec$delegate) {
    _init_properties_AnimateAsState_kt__7h7b9a();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('animSpec', KProperty0, false);
    return $animSpec$delegate.u1();
  }
  function animateValueAsState$lambda_1($channel, $targetValue) {
    return function () {
      $channel.s1s($targetValue);
      return Unit_instance;
    };
  }
  function animateValueAsState$slambda$slambda($newTarget, $animatable, $animSpec$delegate, $listener$delegate, resultContinuation) {
    this.xec_1 = $newTarget;
    this.yec_1 = $animatable;
    this.zec_1 = $animSpec$delegate;
    this.aed_1 = $listener$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(animateValueAsState$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(animateValueAsState$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(animateValueAsState$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (!equals(this.xec_1, this.yec_1.sea())) {
              this.n9_1 = 1;
              suspendResult = this.yec_1.gec(this.xec_1, animateValueAsState$lambda_0(this.zec_1), VOID, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            var tmp0_safe_receiver = animateValueAsState$lambda(this.aed_1);
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(this.yec_1.u1());
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(animateValueAsState$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new animateValueAsState$slambda$slambda(this.xec_1, this.yec_1, this.zec_1, this.aed_1, completion);
    i.bed_1 = $this$launch;
    return i;
  };
  function animateValueAsState$slambda$slambda_0($newTarget, $animatable, $animSpec$delegate, $listener$delegate, resultContinuation) {
    var i = new animateValueAsState$slambda$slambda($newTarget, $animatable, $animSpec$delegate, $listener$delegate, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function animateValueAsState$slambda($channel, $animatable, $animSpec$delegate, $listener$delegate, resultContinuation) {
    this.ked_1 = $channel;
    this.led_1 = $animatable;
    this.med_1 = $animSpec$delegate;
    this.ned_1 = $listener$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(animateValueAsState$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(animateValueAsState$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(animateValueAsState$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.ped_1 = this.ked_1.t();
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.ped_1.d1q(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            if (!suspendResult) {
              this.n9_1 = 3;
              continue $sm;
            }

            var target = this.ped_1.v();
            var tmp0_elvis_lhs = ChannelResult__getOrNull_impl_f5e07h(this.ked_1.w1s());
            var newTarget = tmp0_elvis_lhs == null ? target : tmp0_elvis_lhs;
            launch(this.oed_1, VOID, VOID, animateValueAsState$slambda$slambda_0(newTarget, this.led_1, this.med_1, this.ned_1, null));
            this.n9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(animateValueAsState$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new animateValueAsState$slambda(this.ked_1, this.led_1, this.med_1, this.ned_1, completion);
    i.oed_1 = $this$LaunchedEffect;
    return i;
  };
  function animateValueAsState$slambda_0($channel, $animatable, $animSpec$delegate, $listener$delegate, resultContinuation) {
    var i = new animateValueAsState$slambda($channel, $animatable, $animSpec$delegate, $listener$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  var properties_initialized_AnimateAsState_kt_bq3rmo;
  function _init_properties_AnimateAsState_kt__7h7b9a() {
    if (!properties_initialized_AnimateAsState_kt_bq3rmo) {
      properties_initialized_AnimateAsState_kt_bq3rmo = true;
      defaultAnimation = spring();
      dpDefaultSpring = spring(VOID, VOID, new Dp(get_VisibilityThreshold(Companion_getInstance_0())));
      sizeDefaultSpring = spring(VOID, VOID, new Size(get_VisibilityThreshold_0(Companion_getInstance_1())));
      offsetDefaultSpring = spring(VOID, VOID, new Offset(get_VisibilityThreshold_1(Companion_getInstance_2())));
      rectDefaultSpring = spring(VOID, VOID, get_VisibilityThreshold_2(Companion_getInstance_3()));
      intDefaultSpring = spring(VOID, VOID, get_VisibilityThreshold_3(IntCompanionObject_instance));
      intOffsetDefaultSpring = spring(VOID, VOID, new IntOffset(get_VisibilityThreshold_4(Companion_getInstance_4())));
      intSizeDefaultSpring = spring(VOID, VOID, new IntSize(get_VisibilityThreshold_5(Companion_getInstance_5())));
    }
  }
  var androidx_compose_animation_core_TargetBasedAnimation$stable;
  var androidx_compose_animation_core_DecayAnimation$stable;
  function TargetBasedAnimation_init_$Init$(animationSpec, typeConverter, initialValue, targetValue, initialVelocityVector, $this) {
    initialVelocityVector = initialVelocityVector === VOID ? null : initialVelocityVector;
    TargetBasedAnimation.call($this, animationSpec.qed(typeConverter), typeConverter, initialValue, targetValue, initialVelocityVector);
    return $this;
  }
  function TargetBasedAnimation_init_$Create$(animationSpec, typeConverter, initialValue, targetValue, initialVelocityVector) {
    return TargetBasedAnimation_init_$Init$(animationSpec, typeConverter, initialValue, targetValue, initialVelocityVector, objectCreate(protoOf(TargetBasedAnimation)));
  }
  function _get_endVelocity__lqkp53($this) {
    var tmp0_elvis_lhs = $this.zed_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = $this.red_1.aee($this.ved_1, $this.wed_1, $this.xed_1);
      $this.zed_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function TargetBasedAnimation(animationSpec, typeConverter, initialValue, targetValue, initialVelocityVector) {
    initialVelocityVector = initialVelocityVector === VOID ? null : initialVelocityVector;
    this.red_1 = animationSpec;
    this.sed_1 = typeConverter;
    this.ted_1 = targetValue;
    this.ued_1 = initialValue;
    this.ved_1 = this.sed_1.lea()(initialValue);
    this.wed_1 = this.sed_1.lea()(targetValue);
    var tmp = this;
    var tmp1_elvis_lhs = initialVelocityVector == null ? null : copy_1(initialVelocityVector);
    tmp.xed_1 = tmp1_elvis_lhs == null ? newInstance(this.sed_1.lea()(initialValue)) : tmp1_elvis_lhs;
    this.yed_1 = new Long(-1, -1);
    this.zed_1 = null;
  }
  protoOf(TargetBasedAnimation).bee = function () {
    return this.sed_1;
  };
  protoOf(TargetBasedAnimation).cee = function (value) {
    if (!equals(this.ted_1, value)) {
      this.ted_1 = value;
      this.wed_1 = this.sed_1.lea()(value);
      this.zed_1 = null;
      this.yed_1 = new Long(-1, -1);
    }
  };
  protoOf(TargetBasedAnimation).dee = function (value) {
    if (!equals(value, this.ued_1)) {
      this.ued_1 = value;
      this.ved_1 = this.sed_1.lea()(value);
      this.zed_1 = null;
      this.yed_1 = new Long(-1, -1);
    }
  };
  protoOf(TargetBasedAnimation).eee = function () {
    return this.ued_1;
  };
  protoOf(TargetBasedAnimation).sea = function () {
    return this.ted_1;
  };
  protoOf(TargetBasedAnimation).fee = function () {
    return this.red_1.fee();
  };
  protoOf(TargetBasedAnimation).gee = function (playTimeNanos) {
    var tmp;
    if (!this.iee(playTimeNanos)) {
      // Inline function 'kotlin.let' call
      var it = this.red_1.hee(playTimeNanos, this.ved_1, this.wed_1, this.xed_1);
      var inductionVariable = 0;
      var last = it.mea();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'androidx.compose.animation.core.checkPrecondition' call
          if (!!isNaN_0(it.nea(i))) {
            var tmp$ret$3 = 'AnimationVector cannot contain a NaN. ' + toString(it) + '. Animation: ' + this.toString() + ',' + (' playTimeNanos: ' + playTimeNanos.toString());
            throwIllegalStateException(tmp$ret$3);
          }
        }
         while (inductionVariable < last);
      tmp = this.sed_1.pea()(it);
    } else {
      tmp = this.sea();
    }
    return tmp;
  };
  protoOf(TargetBasedAnimation).jee = function () {
    if (compare(this.yed_1, new Long(0, 0)) < 0) {
      this.yed_1 = this.red_1.kee(this.ved_1, this.wed_1, this.xed_1);
    }
    return this.yed_1;
  };
  protoOf(TargetBasedAnimation).lee = function (playTimeNanos) {
    var tmp;
    if (!this.iee(playTimeNanos)) {
      tmp = this.red_1.mee(playTimeNanos, this.ved_1, this.wed_1, this.xed_1);
    } else {
      tmp = _get_endVelocity__lqkp53(this);
    }
    return tmp;
  };
  protoOf(TargetBasedAnimation).toString = function () {
    return 'TargetBasedAnimation: ' + toString_0(this.eee()) + ' -> ' + toString_0(this.sea()) + ',' + ('initial velocity: ' + toString(this.xed_1) + ', duration: ' + get_durationMillis(this).toString() + ' ms,') + ('animationSpec: ' + toString(this.red_1));
  };
  function TargetBasedAnimation_0(animationSpec, typeConverter, initialValue, targetValue, initialVelocity) {
    return TargetBasedAnimation_init_$Create$(animationSpec, typeConverter, initialValue, targetValue, typeConverter.lea()(initialVelocity));
  }
  function DecayAnimation_init_$Init$(animationSpec, typeConverter, initialValue, initialVelocityVector, $this) {
    DecayAnimation.call($this, animationSpec.qed(typeConverter), typeConverter, initialValue, initialVelocityVector);
    return $this;
  }
  function DecayAnimation_init_$Create$(animationSpec, typeConverter, initialValue, initialVelocityVector) {
    return DecayAnimation_init_$Init$(animationSpec, typeConverter, initialValue, initialVelocityVector, objectCreate(protoOf(DecayAnimation)));
  }
  function DecayAnimation(animationSpec, typeConverter, initialValue, initialVelocityVector) {
    this.nee_1 = animationSpec;
    this.oee_1 = typeConverter;
    this.pee_1 = initialValue;
    this.qee_1 = this.oee_1.lea()(this.pee_1);
    this.ree_1 = copy_1(initialVelocityVector);
    this.tee_1 = this.oee_1.pea()(this.nee_1.wee(this.qee_1, initialVelocityVector));
    this.vee_1 = false;
    this.uee_1 = this.nee_1.xee(this.qee_1, initialVelocityVector);
    this.see_1 = copy_1(this.nee_1.yee(this.uee_1, this.qee_1, initialVelocityVector));
    var inductionVariable = 0;
    var last = this.see_1.mea();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.see_1.oea(i, coerceIn(this.see_1.nea(i), -this.nee_1.zee(), this.nee_1.zee()));
      }
       while (inductionVariable < last);
  }
  protoOf(DecayAnimation).bee = function () {
    return this.oee_1;
  };
  protoOf(DecayAnimation).sea = function () {
    return this.tee_1;
  };
  protoOf(DecayAnimation).jee = function () {
    return this.uee_1;
  };
  protoOf(DecayAnimation).fee = function () {
    return this.vee_1;
  };
  protoOf(DecayAnimation).gee = function (playTimeNanos) {
    if (!this.iee(playTimeNanos)) {
      return this.oee_1.pea()(this.nee_1.aef(playTimeNanos, this.qee_1, this.ree_1));
    } else {
      return this.tee_1;
    }
  };
  protoOf(DecayAnimation).lee = function (playTimeNanos) {
    if (!this.iee(playTimeNanos)) {
      return this.nee_1.yee(playTimeNanos, this.qee_1, this.ree_1);
    } else {
      return this.see_1;
    }
  };
  function Animation() {
  }
  function get_durationMillis(_this__u8e3s4) {
    return divide(_this__u8e3s4.jee(), new Long(1000000, 0));
  }
  var AnimationEndReason_BoundReached_instance;
  var AnimationEndReason_Finished_instance;
  var AnimationEndReason_entriesInitialized;
  function AnimationEndReason_initEntries() {
    if (AnimationEndReason_entriesInitialized)
      return Unit_instance;
    AnimationEndReason_entriesInitialized = true;
    AnimationEndReason_BoundReached_instance = new AnimationEndReason('BoundReached', 0);
    AnimationEndReason_Finished_instance = new AnimationEndReason('Finished', 1);
  }
  function AnimationEndReason(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function AnimationEndReason_BoundReached_getInstance() {
    AnimationEndReason_initEntries();
    return AnimationEndReason_BoundReached_instance;
  }
  function AnimationEndReason_Finished_getInstance() {
    AnimationEndReason_initEntries();
    return AnimationEndReason_Finished_instance;
  }
  var androidx_compose_animation_core_AnimationConstants$stable;
  var androidx_compose_animation_core_TweenSpec$stable;
  var androidx_compose_animation_core_SpringSpec$stable;
  var androidx_compose_animation_core_ArcAnimationSpec$stable;
  var androidx_compose_animation_core_RepeatableSpec$stable;
  var androidx_compose_animation_core_InfiniteRepeatableSpec$stable;
  var androidx_compose_animation_core_SnapSpec$stable;
  var androidx_compose_animation_core_KeyframesSpecBaseConfig$stable;
  var androidx_compose_animation_core_KeyframeBaseEntity$stable;
  var androidx_compose_animation_core_KeyframesSpec_KeyframesSpecConfig$stable;
  var androidx_compose_animation_core_KeyframesSpec_KeyframeEntity$stable;
  var androidx_compose_animation_core_KeyframesSpec$stable;
  var androidx_compose_animation_core_KeyframesWithSplineSpec_KeyframesWithSplineSpecConfig$stable;
  var androidx_compose_animation_core_KeyframesWithSplineSpec$stable;
  function SpringSpec(dampingRatio, stiffness, visibilityThreshold) {
    dampingRatio = dampingRatio === VOID ? 1.0 : dampingRatio;
    stiffness = stiffness === VOID ? 1500.0 : stiffness;
    visibilityThreshold = visibilityThreshold === VOID ? null : visibilityThreshold;
    this.mec_1 = dampingRatio;
    this.nec_1 = stiffness;
    this.oec_1 = visibilityThreshold;
  }
  protoOf(SpringSpec).qed = function (converter) {
    return VectorizedSpringSpec_init_$Create$(this.mec_1, this.nec_1, convert(converter, this.oec_1));
  };
  protoOf(SpringSpec).equals = function (other) {
    var tmp;
    if (other instanceof SpringSpec) {
      tmp = (other.mec_1 === this.mec_1 && other.nec_1 === this.nec_1 && equals(other.oec_1, this.oec_1));
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SpringSpec).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.oec_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    return imul(imul(tmp$ret$0, 31) + getNumberHashCode(this.mec_1) | 0, 31) + getNumberHashCode(this.nec_1) | 0;
  };
  function spring(dampingRatio, stiffness, visibilityThreshold) {
    dampingRatio = dampingRatio === VOID ? 1.0 : dampingRatio;
    stiffness = stiffness === VOID ? 1500.0 : stiffness;
    visibilityThreshold = visibilityThreshold === VOID ? null : visibilityThreshold;
    return new SpringSpec(dampingRatio, stiffness, visibilityThreshold);
  }
  function FiniteAnimationSpec() {
  }
  function TweenSpec(durationMillis, delay, easing) {
    durationMillis = durationMillis === VOID ? 300 : durationMillis;
    delay = delay === VOID ? 0 : delay;
    easing = easing === VOID ? get_FastOutSlowInEasing() : easing;
    this.bef_1 = durationMillis;
    this.cef_1 = delay;
    this.def_1 = easing;
  }
  protoOf(TweenSpec).qed = function (converter) {
    return new VectorizedTweenSpec(this.bef_1, this.cef_1, this.def_1);
  };
  protoOf(TweenSpec).equals = function (other) {
    var tmp;
    if (other instanceof TweenSpec) {
      tmp = (other.bef_1 === this.bef_1 && other.cef_1 === this.cef_1 && equals(other.def_1, this.def_1));
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(TweenSpec).hashCode = function () {
    return imul(imul(this.bef_1, 31) + hashCode(this.def_1) | 0, 31) + this.cef_1 | 0;
  };
  function tween(durationMillis, delayMillis, easing) {
    durationMillis = durationMillis === VOID ? 300 : durationMillis;
    delayMillis = delayMillis === VOID ? 0 : delayMillis;
    easing = easing === VOID ? get_FastOutSlowInEasing() : easing;
    return new TweenSpec(durationMillis, delayMillis, easing);
  }
  function SnapSpec(delay) {
    delay = delay === VOID ? 0 : delay;
    this.eef_1 = delay;
  }
  protoOf(SnapSpec).qed = function (converter) {
    return new VectorizedSnapSpec(this.eef_1);
  };
  protoOf(SnapSpec).equals = function (other) {
    var tmp;
    if (other instanceof SnapSpec) {
      tmp = other.eef_1 === this.eef_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SnapSpec).hashCode = function () {
    return this.eef_1;
  };
  function snap(delayMillis) {
    delayMillis = delayMillis === VOID ? 0 : delayMillis;
    return new SnapSpec(delayMillis);
  }
  function convert(_this__u8e3s4, data) {
    if (data == null) {
      return null;
    } else {
      return _this__u8e3s4.lea()(data);
    }
  }
  function delayed(animationSpec, startDelayNanos) {
    return new StartDelayAnimationSpec(animationSpec, startDelayNanos);
  }
  function StartDelayAnimationSpec(animationSpec, startDelayNanos) {
    this.fef_1 = animationSpec;
    this.gef_1 = startDelayNanos;
  }
  protoOf(StartDelayAnimationSpec).qed = function (converter) {
    var vecSpec = this.fef_1.qed(converter);
    return new StartDelayVectorizedAnimationSpec(vecSpec, this.gef_1);
  };
  protoOf(StartDelayAnimationSpec).hashCode = function () {
    return imul(31, hashCode(this.fef_1)) + this.gef_1.hashCode() | 0;
  };
  protoOf(StartDelayAnimationSpec).equals = function (other) {
    if (!(other instanceof StartDelayAnimationSpec)) {
      return false;
    }
    return equalsLong(other.gef_1, this.gef_1) && equals(other.fef_1, this.fef_1);
  };
  function StartDelayVectorizedAnimationSpec(vectorizedAnimationSpec, startDelayNanos) {
    this.hef_1 = vectorizedAnimationSpec;
    this.ief_1 = startDelayNanos;
  }
  protoOf(StartDelayVectorizedAnimationSpec).fee = function () {
    return this.hef_1.fee();
  };
  protoOf(StartDelayVectorizedAnimationSpec).kee = function (initialValue, targetValue, initialVelocity) {
    return add(this.hef_1.kee(initialValue, targetValue, initialVelocity), this.ief_1);
  };
  protoOf(StartDelayVectorizedAnimationSpec).mee = function (playTimeNanos, initialValue, targetValue, initialVelocity) {
    var tmp;
    if (compare(playTimeNanos, this.ief_1) < 0) {
      tmp = initialVelocity;
    } else {
      tmp = this.hef_1.mee(subtract(playTimeNanos, this.ief_1), initialValue, targetValue, initialVelocity);
    }
    return tmp;
  };
  protoOf(StartDelayVectorizedAnimationSpec).hee = function (playTimeNanos, initialValue, targetValue, initialVelocity) {
    var tmp;
    if (compare(playTimeNanos, this.ief_1) < 0) {
      tmp = initialValue;
    } else {
      tmp = this.hef_1.hee(subtract(playTimeNanos, this.ief_1), initialValue, targetValue, initialVelocity);
    }
    return tmp;
  };
  protoOf(StartDelayVectorizedAnimationSpec).hashCode = function () {
    return imul(31, hashCode(this.hef_1)) + this.ief_1.hashCode() | 0;
  };
  protoOf(StartDelayVectorizedAnimationSpec).equals = function (other) {
    if (!(other instanceof StartDelayVectorizedAnimationSpec)) {
      return false;
    }
    return equalsLong(other.ief_1, this.ief_1) && equals(other.hef_1, this.hef_1);
  };
  function InfiniteRepeatableSpec(animation, repeatMode, initialStartOffset) {
    repeatMode = repeatMode === VOID ? RepeatMode_Restart_getInstance() : repeatMode;
    initialStartOffset = initialStartOffset === VOID ? _StartOffset___init__impl__615djw_0(0) : initialStartOffset;
    this.jef_1 = animation;
    this.kef_1 = repeatMode;
    this.lef_1 = initialStartOffset;
    var tmp0_subject = this.jef_1;
    var tmp;
    if (tmp0_subject instanceof TweenSpec) {
      tmp = (this.jef_1.bef_1 === 0 && this.jef_1.cef_1 === 0);
    } else {
      if (tmp0_subject instanceof SnapSpec) {
        tmp = this.jef_1.eef_1 === 0;
      } else {
        if (tmp0_subject instanceof KeyframesSpec) {
          tmp = (this.jef_1.sef_1.oef_1 === 0 && this.jef_1.sef_1.pef_1 === 0);
        } else {
          if (tmp0_subject instanceof KeyframesWithSplineSpec) {
            tmp = (this.jef_1.ref_1.oef_1 === 0 && this.jef_1.ref_1.pef_1 === 0);
          } else {
            if (tmp0_subject instanceof ArcAnimationSpec) {
              tmp = (this.jef_1.mef_1 === 0 && this.jef_1.nef_1 === 0);
            } else {
              tmp = false;
            }
          }
        }
      }
    }
    var isZeroDuration = tmp;
    if (isZeroDuration) {
      throw IllegalArgumentException_init_$Create$('Animation to be infinitely repeated cannot have a 0-duration');
    }
  }
  protoOf(InfiniteRepeatableSpec).qed = function (converter) {
    return new VectorizedInfiniteRepeatableSpec(this.jef_1.qed(converter), this.kef_1, this.lef_1);
  };
  protoOf(InfiniteRepeatableSpec).equals = function (other) {
    var tmp;
    if (other instanceof InfiniteRepeatableSpec) {
      tmp = (equals(other.jef_1, this.jef_1) && other.kef_1.equals(this.kef_1) && equals(other.lef_1, this.lef_1));
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(InfiniteRepeatableSpec).hashCode = function () {
    return imul(imul(hashCode(this.jef_1), 31) + this.kef_1.hashCode() | 0, 31) + StartOffset__hashCode_impl_ith3z7(this.lef_1) | 0;
  };
  function infiniteRepeatable(animation, repeatMode, initialStartOffset) {
    repeatMode = repeatMode === VOID ? RepeatMode_Restart_getInstance() : repeatMode;
    initialStartOffset = initialStartOffset === VOID ? _StartOffset___init__impl__615djw_0(0) : initialStartOffset;
    return new InfiniteRepeatableSpec(animation, repeatMode, initialStartOffset);
  }
  var RepeatMode_Restart_instance;
  var RepeatMode_Reverse_instance;
  var RepeatMode_entriesInitialized;
  function RepeatMode_initEntries() {
    if (RepeatMode_entriesInitialized)
      return Unit_instance;
    RepeatMode_entriesInitialized = true;
    RepeatMode_Restart_instance = new RepeatMode('Restart', 0);
    RepeatMode_Reverse_instance = new RepeatMode('Reverse', 1);
  }
  function RepeatMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ArcAnimationSpec() {
  }
  function androidx_compose_animation_core_InfiniteRepeatableSpec$stableprop_getter() {
    return androidx_compose_animation_core_InfiniteRepeatableSpec$stable;
  }
  function KeyframesSpecConfig() {
    KeyframesSpecBaseConfig.call(this);
  }
  protoOf(KeyframesSpecConfig).wef = function (_this__u8e3s4, timeStamp) {
    // Inline function 'kotlin.also' call
    var this_0 = new KeyframeEntity(_this__u8e3s4);
    this.qef_1.ew(timeStamp, this_0);
    return this_0;
  };
  function KeyframeEntity(value, easing, arcMode) {
    easing = easing === VOID ? get_LinearEasing() : easing;
    arcMode = arcMode === VOID ? Companion_getInstance_9().aeg_1 : arcMode;
    KeyframeBaseEntity.call(this, value, easing);
    this.deg_1 = arcMode;
  }
  protoOf(KeyframeEntity).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof KeyframeEntity))
      return false;
    return equals(other.eeg_1, this.eeg_1) && equals(other.feg_1, this.feg_1) && other.deg_1 === this.deg_1;
  };
  protoOf(KeyframeEntity).hashCode = function () {
    var tmp0_safe_receiver = this.eeg_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    result = imul(31, result) + ArcMode__hashCode_impl_ghaz31(this.deg_1) | 0;
    result = imul(31, result) + hashCode(this.feg_1) | 0;
    return result;
  };
  function KeyframesSpec(config) {
    this.sef_1 = config;
  }
  protoOf(KeyframesSpec).qed = function (converter) {
    var timestamps = new MutableIntList(this.sef_1.qef_1.n1() + 2 | 0);
    var timeToInfoMap = new MutableIntObjectMap(this.sef_1.qef_1.n1());
    // Inline function 'androidx.collection.IntObjectMap.forEach' call
    var this_0 = this.sef_1.qef_1;
    var k = this_0.uv_1;
    var v = this_0.vv_1;
    $l$block: {
      // Inline function 'androidx.collection.IntObjectMap.forEachIndexed' call
      var m = this_0.tv_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var tmp0 = k[index];
                  var value_0 = v[index];
                  timestamps.pv(tmp0);
                  timeToInfoMap.ew(tmp0, new VectorizedKeyframeSpecElementInfo(converter.lea()(value_0.eeg_1), value_0.feg_1, value_0.deg_1));
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
    // Inline function 'androidx.collection.IntObjectMap.contains' call
    if (!this.sef_1.qef_1.hv(0)) {
      timestamps.qv(0, 0);
    }
    var tmp0_0 = this.sef_1.qef_1;
    // Inline function 'androidx.collection.IntObjectMap.contains' call
    var key = this.sef_1.oef_1;
    if (!tmp0_0.hv(key)) {
      timestamps.pv(this.sef_1.oef_1);
    }
    timestamps.sv();
    return new VectorizedKeyframesSpec(timestamps, timeToInfoMap, this.sef_1.oef_1, this.sef_1.pef_1, get_LinearEasing(), Companion_getInstance_9().aeg_1);
  };
  function keyframes(init) {
    // Inline function 'kotlin.apply' call
    var this_0 = new KeyframesSpecConfig();
    init(this_0);
    return new KeyframesSpec(this_0);
  }
  function _StartOffset___init__impl__615djw(value) {
    return value;
  }
  function _StartOffset___get_value__impl__8sikig($this) {
    return $this;
  }
  function _StartOffset___init__impl__615djw_0(offsetMillis, offsetType) {
    offsetType = offsetType === VOID ? Companion_getInstance_7().geg_1 : offsetType;
    return _StartOffset___init__impl__615djw(fromInt(imul(offsetMillis, _StartOffsetType___get_value__impl__i1pfem(offsetType))));
  }
  function StartOffset__hashCode_impl_ith3z7($this) {
    return $this.hashCode();
  }
  function KeyframesWithSplineSpec() {
  }
  function KeyframesSpecBaseConfig() {
    this.oef_1 = 300;
    this.pef_1 = 0;
    this.qef_1 = mutableIntObjectMapOf();
  }
  protoOf(KeyframesSpecBaseConfig).xef = function (_this__u8e3s4, easing) {
    _this__u8e3s4.feg_1 = easing;
    return _this__u8e3s4;
  };
  function KeyframeBaseEntity(value, easing) {
    this.eeg_1 = value;
    this.feg_1 = easing;
  }
  function _StartOffsetType___init__impl__g1ur7a(value) {
    return value;
  }
  function _StartOffsetType___get_value__impl__i1pfem($this) {
    return $this;
  }
  function Companion() {
    Companion_instance_1 = this;
    this.geg_1 = _StartOffsetType___init__impl__g1ur7a(-1);
    this.heg_1 = _StartOffsetType___init__impl__g1ur7a(1);
  }
  var Companion_instance_1;
  function Companion_getInstance_7() {
    if (Companion_instance_1 == null)
      new Companion();
    return Companion_instance_1;
  }
  function RepeatMode_Restart_getInstance() {
    RepeatMode_initEntries();
    return RepeatMode_Restart_instance;
  }
  var androidx_compose_animation_core_AnimationState$stable;
  var androidx_compose_animation_core_AnimationScope$stable;
  function AnimationState$_get_value_$ref_fgr73c() {
    return constructCallableReference(function (p0) {
      return p0.u1();
    }, 1, 0, 177);
  }
  function AnimationState$_set_value_$ref_q9ieh8() {
    return constructCallableReference(function (p0, p1) {
      p0.gea(p1);
      return Unit_instance;
    }, 2, 0, 178);
  }
  function AnimationState(typeConverter, initialValue, initialVelocityVector, lastFrameTimeNanos, finishedTimeNanos, isRunning) {
    initialVelocityVector = initialVelocityVector === VOID ? null : initialVelocityVector;
    lastFrameTimeNanos = lastFrameTimeNanos === VOID ? new Long(0, -2147483648) : lastFrameTimeNanos;
    finishedTimeNanos = finishedTimeNanos === VOID ? new Long(0, -2147483648) : finishedTimeNanos;
    isRunning = isRunning === VOID ? false : isRunning;
    this.aea_1 = typeConverter;
    this.bea_1 = mutableStateOf(initialValue);
    var tmp = this;
    var tmp1_elvis_lhs = initialVelocityVector == null ? null : copy_1(initialVelocityVector);
    tmp.cea_1 = tmp1_elvis_lhs == null ? createZeroVectorFrom(this.aea_1, initialValue) : tmp1_elvis_lhs;
    this.dea_1 = lastFrameTimeNanos;
    this.eea_1 = finishedTimeNanos;
    this.fea_1 = isRunning;
  }
  protoOf(AnimationState).gea = function (_set____db54di) {
    var tmp0 = this.bea_1;
    var tmp = KMutableProperty1;
    var tmp_0 = AnimationState$_get_value_$ref_fgr73c();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('value', 1, tmp, tmp_0, AnimationState$_set_value_$ref_q9ieh8());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(AnimationState).u1 = function () {
    var tmp0 = this.bea_1;
    var tmp = KMutableProperty1;
    var tmp_0 = AnimationState$_get_value_$ref_fgr73c();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('value', 1, tmp, tmp_0, AnimationState$_set_value_$ref_q9ieh8());
    return tmp0.u1();
  };
  protoOf(AnimationState).eec = function () {
    return this.aea_1.pea()(this.cea_1);
  };
  protoOf(AnimationState).toString = function () {
    return 'AnimationState(' + ('value=' + toString_0(this.u1()) + ', ') + ('velocity=' + toString_0(this.eec()) + ', ') + ('isRunning=' + this.fea_1 + ', ') + ('lastFrameTimeNanos=' + this.dea_1.toString() + ', ') + ('finishedTimeNanos=' + this.eea_1.toString()) + ')';
  };
  function AnimationState_0(initialValue, initialVelocity, lastFrameTimeNanos, finishedTimeNanos, isRunning) {
    initialVelocity = initialVelocity === VOID ? 0.0 : initialVelocity;
    lastFrameTimeNanos = lastFrameTimeNanos === VOID ? new Long(0, -2147483648) : lastFrameTimeNanos;
    finishedTimeNanos = finishedTimeNanos === VOID ? new Long(0, -2147483648) : finishedTimeNanos;
    isRunning = isRunning === VOID ? false : isRunning;
    return new AnimationState(get_VectorConverter(FloatCompanionObject_instance), initialValue, AnimationVector(initialVelocity), lastFrameTimeNanos, finishedTimeNanos, isRunning);
  }
  function AnimationScope$_get_value_$ref_u38x5x() {
    return constructCallableReference(function (p0) {
      return p0.u1();
    }, 1, 0, 179);
  }
  function AnimationScope$_set_value_$ref_bn0oen() {
    return constructCallableReference(function (p0, p1) {
      p0.gea(p1);
      return Unit_instance;
    }, 2, 0, 180);
  }
  function AnimationScope$_get_isRunning_$ref_gxcmg9() {
    return constructCallableReference(function (p0) {
      return p0.rea();
    }, 1, 0, 181);
  }
  function AnimationScope$_set_isRunning_$ref_1pl3xx() {
    return constructCallableReference(function (p0, p1) {
      p0.ieg(p1);
      return Unit_instance;
    }, 2, 0, 182);
  }
  function AnimationScope(initialValue, typeConverter, initialVelocityVector, lastFrameTimeNanos, targetValue, startTimeNanos, isRunning, onCancel) {
    this.re9_1 = typeConverter;
    this.se9_1 = targetValue;
    this.te9_1 = startTimeNanos;
    this.ue9_1 = onCancel;
    this.ve9_1 = mutableStateOf(initialValue);
    this.we9_1 = copy_1(initialVelocityVector);
    this.xe9_1 = lastFrameTimeNanos;
    this.ye9_1 = new Long(0, -2147483648);
    this.ze9_1 = mutableStateOf(isRunning);
  }
  protoOf(AnimationScope).gea = function (_set____db54di) {
    var tmp0 = this.ve9_1;
    var tmp = KMutableProperty1;
    var tmp_0 = AnimationScope$_get_value_$ref_u38x5x();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('value', 1, tmp, tmp_0, AnimationScope$_set_value_$ref_bn0oen());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(AnimationScope).u1 = function () {
    var tmp0 = this.ve9_1;
    var tmp = KMutableProperty1;
    var tmp_0 = AnimationScope$_get_value_$ref_u38x5x();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('value', 1, tmp, tmp_0, AnimationScope$_set_value_$ref_bn0oen());
    return tmp0.u1();
  };
  protoOf(AnimationScope).ieg = function (_set____db54di) {
    var tmp0 = this.ze9_1;
    var tmp = KMutableProperty1;
    var tmp_0 = AnimationScope$_get_isRunning_$ref_gxcmg9();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('isRunning', 1, tmp, tmp_0, AnimationScope$_set_isRunning_$ref_1pl3xx());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(AnimationScope).rea = function () {
    var tmp0 = this.ze9_1;
    var tmp = KMutableProperty1;
    var tmp_0 = AnimationScope$_get_isRunning_$ref_gxcmg9();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('isRunning', 1, tmp, tmp_0, AnimationScope$_set_isRunning_$ref_1pl3xx());
    return tmp0.u1();
  };
  protoOf(AnimationScope).eec = function () {
    return this.re9_1.pea()(this.we9_1);
  };
  protoOf(AnimationScope).hea = function () {
    this.ieg(false);
    this.ue9_1();
  };
  function copy(_this__u8e3s4, value, velocityVector, lastFrameTimeNanos, finishedTimeNanos, isRunning) {
    value = value === VOID ? _this__u8e3s4.u1() : value;
    velocityVector = velocityVector === VOID ? copy_1(_this__u8e3s4.cea_1) : velocityVector;
    lastFrameTimeNanos = lastFrameTimeNanos === VOID ? _this__u8e3s4.dea_1 : lastFrameTimeNanos;
    finishedTimeNanos = finishedTimeNanos === VOID ? _this__u8e3s4.eea_1 : finishedTimeNanos;
    isRunning = isRunning === VOID ? _this__u8e3s4.fea_1 : isRunning;
    return new AnimationState(_this__u8e3s4.aea_1, value, velocityVector, lastFrameTimeNanos, finishedTimeNanos, isRunning);
  }
  function createZeroVectorFrom(_this__u8e3s4, value) {
    // Inline function 'kotlin.also' call
    var this_0 = _this__u8e3s4.lea()(value);
    this_0.qea();
    return this_0;
  }
  function copy_0(_this__u8e3s4, value, velocity, lastFrameTimeNanos, finishedTimeNanos, isRunning) {
    value = value === VOID ? _this__u8e3s4.u1() : value;
    velocity = velocity === VOID ? _this__u8e3s4.cea_1.jeg_1 : velocity;
    lastFrameTimeNanos = lastFrameTimeNanos === VOID ? _this__u8e3s4.dea_1 : lastFrameTimeNanos;
    finishedTimeNanos = finishedTimeNanos === VOID ? _this__u8e3s4.eea_1 : finishedTimeNanos;
    isRunning = isRunning === VOID ? _this__u8e3s4.fea_1 : isRunning;
    return new AnimationState(_this__u8e3s4.aea_1, value, AnimationVector(velocity), lastFrameTimeNanos, finishedTimeNanos, isRunning);
  }
  function AnimationState_1(typeConverter, initialValue, initialVelocity, lastFrameTimeNanos, finishedTimeNanos, isRunning) {
    lastFrameTimeNanos = lastFrameTimeNanos === VOID ? new Long(0, -2147483648) : lastFrameTimeNanos;
    finishedTimeNanos = finishedTimeNanos === VOID ? new Long(0, -2147483648) : finishedTimeNanos;
    isRunning = isRunning === VOID ? false : isRunning;
    return new AnimationState(typeConverter, initialValue, typeConverter.lea()(initialVelocity), lastFrameTimeNanos, finishedTimeNanos, isRunning);
  }
  var androidx_compose_animation_core_AnimationVector$stable;
  var androidx_compose_animation_core_AnimationVector1D$stable;
  var androidx_compose_animation_core_AnimationVector2D$stable;
  var androidx_compose_animation_core_AnimationVector3D$stable;
  var androidx_compose_animation_core_AnimationVector4D$stable;
  function AnimationVector4D(v1, v2, v3, v4) {
    AnimationVector_3.call(this);
    this.leg_1 = v1;
    this.meg_1 = v2;
    this.neg_1 = v3;
    this.oeg_1 = v4;
    this.peg_1 = 4;
  }
  protoOf(AnimationVector4D).qea = function () {
    this.leg_1 = 0.0;
    this.meg_1 = 0.0;
    this.neg_1 = 0.0;
    this.oeg_1 = 0.0;
  };
  protoOf(AnimationVector4D).qeg = function () {
    return new AnimationVector4D(0.0, 0.0, 0.0, 0.0);
  };
  protoOf(AnimationVector4D).nea = function (index) {
    switch (index) {
      case 0:
        return this.leg_1;
      case 1:
        return this.meg_1;
      case 2:
        return this.neg_1;
      case 3:
        return this.oeg_1;
      default:
        return 0.0;
    }
  };
  protoOf(AnimationVector4D).oea = function (index, value) {
    switch (index) {
      case 0:
        this.leg_1 = value;
        break;
      case 1:
        this.meg_1 = value;
        break;
      case 2:
        this.neg_1 = value;
        break;
      case 3:
        this.oeg_1 = value;
        break;
    }
  };
  protoOf(AnimationVector4D).mea = function () {
    return this.peg_1;
  };
  protoOf(AnimationVector4D).toString = function () {
    return 'AnimationVector4D: v1 = ' + this.leg_1 + ', v2 = ' + this.meg_1 + ', v3 = ' + this.neg_1 + ', v4 = ' + this.oeg_1;
  };
  protoOf(AnimationVector4D).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof AnimationVector4D) {
      tmp_2 = other.leg_1 === this.leg_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = other.meg_1 === this.meg_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = other.neg_1 === this.neg_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = other.oeg_1 === this.oeg_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(AnimationVector4D).hashCode = function () {
    return imul(imul(imul(getNumberHashCode(this.leg_1), 31) + getNumberHashCode(this.meg_1) | 0, 31) + getNumberHashCode(this.neg_1) | 0, 31) + getNumberHashCode(this.oeg_1) | 0;
  };
  function AnimationVector1D(initVal) {
    AnimationVector_3.call(this);
    this.jeg_1 = initVal;
    this.keg_1 = 1;
  }
  protoOf(AnimationVector1D).qea = function () {
    this.jeg_1 = 0.0;
  };
  protoOf(AnimationVector1D).qeg = function () {
    return new AnimationVector1D(0.0);
  };
  protoOf(AnimationVector1D).nea = function (index) {
    if (index === 0) {
      return this.jeg_1;
    } else {
      return 0.0;
    }
  };
  protoOf(AnimationVector1D).oea = function (index, value) {
    if (index === 0) {
      this.jeg_1 = value;
    }
  };
  protoOf(AnimationVector1D).mea = function () {
    return this.keg_1;
  };
  protoOf(AnimationVector1D).toString = function () {
    return 'AnimationVector1D: value = ' + this.jeg_1;
  };
  protoOf(AnimationVector1D).equals = function (other) {
    var tmp;
    if (other instanceof AnimationVector1D) {
      tmp = other.jeg_1 === this.jeg_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(AnimationVector1D).hashCode = function () {
    return getNumberHashCode(this.jeg_1);
  };
  function AnimationVector(v1) {
    return new AnimationVector1D(v1);
  }
  function AnimationVector2D(v1, v2) {
    AnimationVector_3.call(this);
    this.reg_1 = v1;
    this.seg_1 = v2;
    this.teg_1 = 2;
  }
  protoOf(AnimationVector2D).qea = function () {
    this.reg_1 = 0.0;
    this.seg_1 = 0.0;
  };
  protoOf(AnimationVector2D).qeg = function () {
    return new AnimationVector2D(0.0, 0.0);
  };
  protoOf(AnimationVector2D).nea = function (index) {
    switch (index) {
      case 0:
        return this.reg_1;
      case 1:
        return this.seg_1;
      default:
        return 0.0;
    }
  };
  protoOf(AnimationVector2D).oea = function (index, value) {
    if (index === 0)
      this.reg_1 = value;
    else if (index === 1)
      this.seg_1 = value;
  };
  protoOf(AnimationVector2D).mea = function () {
    return this.teg_1;
  };
  protoOf(AnimationVector2D).toString = function () {
    return 'AnimationVector2D: v1 = ' + this.reg_1 + ', v2 = ' + this.seg_1;
  };
  protoOf(AnimationVector2D).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof AnimationVector2D) {
      tmp_0 = other.reg_1 === this.reg_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = other.seg_1 === this.seg_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(AnimationVector2D).hashCode = function () {
    return imul(getNumberHashCode(this.reg_1), 31) + getNumberHashCode(this.seg_1) | 0;
  };
  function AnimationVector_0(v1, v2) {
    return new AnimationVector2D(v1, v2);
  }
  function AnimationVector3D(v1, v2, v3) {
    AnimationVector_3.call(this);
    this.ueg_1 = v1;
    this.veg_1 = v2;
    this.weg_1 = v3;
    this.xeg_1 = 3;
  }
  protoOf(AnimationVector3D).qea = function () {
    this.ueg_1 = 0.0;
    this.veg_1 = 0.0;
    this.weg_1 = 0.0;
  };
  protoOf(AnimationVector3D).qeg = function () {
    return new AnimationVector3D(0.0, 0.0, 0.0);
  };
  protoOf(AnimationVector3D).nea = function (index) {
    switch (index) {
      case 0:
        return this.ueg_1;
      case 1:
        return this.veg_1;
      case 2:
        return this.weg_1;
      default:
        return 0.0;
    }
  };
  protoOf(AnimationVector3D).oea = function (index, value) {
    switch (index) {
      case 0:
        this.ueg_1 = value;
        break;
      case 1:
        this.veg_1 = value;
        break;
      case 2:
        this.weg_1 = value;
        break;
    }
  };
  protoOf(AnimationVector3D).mea = function () {
    return this.xeg_1;
  };
  protoOf(AnimationVector3D).toString = function () {
    return 'AnimationVector3D: v1 = ' + this.ueg_1 + ', v2 = ' + this.veg_1 + ', v3 = ' + this.weg_1;
  };
  protoOf(AnimationVector3D).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof AnimationVector3D) {
      tmp_1 = other.ueg_1 === this.ueg_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = other.veg_1 === this.veg_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = other.weg_1 === this.weg_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(AnimationVector3D).hashCode = function () {
    return imul(imul(getNumberHashCode(this.ueg_1), 31) + getNumberHashCode(this.veg_1) | 0, 31) + getNumberHashCode(this.weg_1) | 0;
  };
  function AnimationVector_1(v1, v2, v3) {
    return new AnimationVector3D(v1, v2, v3);
  }
  function AnimationVector_2(v1, v2, v3, v4) {
    return new AnimationVector4D(v1, v2, v3, v4);
  }
  function AnimationVector_3() {
  }
  function copy_1(_this__u8e3s4) {
    var newVector = newInstance(_this__u8e3s4);
    var inductionVariable = 0;
    var last = newVector.mea();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        newVector.oea(i, _this__u8e3s4.nea(i));
      }
       while (inductionVariable < last);
    return newVector;
  }
  function newInstance(_this__u8e3s4) {
    var tmp = _this__u8e3s4.qeg();
    return tmp instanceof AnimationVector_3 ? tmp : THROW_CCE();
  }
  function copyFrom(_this__u8e3s4, source) {
    var inductionVariable = 0;
    var last = _this__u8e3s4.mea();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        _this__u8e3s4.oea(i, source.nea(i));
      }
       while (inductionVariable < last);
  }
  function get_OurPercentCache() {
    _init_properties_ArcSpline_kt__f15lqp();
    return OurPercentCache;
  }
  var OurPercentCache;
  var androidx_compose_animation_core_ArcSpline_Arc$stable;
  var androidx_compose_animation_core_ArcSpline$stable;
  function lookup($this, v) {
    if (v <= 0) {
      return 0.0;
    }
    if (v >= 1) {
      return 1.0;
    }
    var pos = v * 100;
    var iv = numberToInt(pos);
    var off = pos - numberToInt(pos);
    return $this.heh_1[iv] + off * ($this.heh_1[iv + 1 | 0] - $this.heh_1[iv]);
  }
  function access$_get_tmpSinAngle__itfxbz($this) {
    return $this.feh_1;
  }
  function access$_get_tmpCosAngle__x3tzou($this) {
    return $this.geh_1;
  }
  function Arc(mode, time1, time2, x1, y1, x2, y2) {
    this.yeg_1 = time1;
    this.zeg_1 = time2;
    this.aeh_1 = x1;
    this.beh_1 = y1;
    this.ceh_1 = x2;
    this.deh_1 = y2;
    this.eeh_1 = 0.0;
    this.feh_1 = 0.0;
    this.geh_1 = 0.0;
    var dx = this.ceh_1 - this.aeh_1;
    var dy = this.deh_1 - this.beh_1;
    var isVertical;
    switch (mode) {
      case 1:
        isVertical = true;
        break;
      case 5:
        isVertical = dy < 0;
        break;
      case 4:
        isVertical = dy > 0;
        break;
      default:
        isVertical = false;
        break;
    }
    this.keh_1 = isVertical ? -1.0 : 1.0;
    this.ieh_1 = 1 / (this.zeg_1 - this.yeg_1);
    this.heh_1 = new Float32Array(101);
    var isLinear = mode === 3;
    var tmp;
    var tmp_0;
    if (isLinear) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.math.abs' call
      tmp_0 = Math.abs(dx) < 0.001;
    }
    if (tmp_0) {
      tmp = true;
    } else {
      // Inline function 'kotlin.math.abs' call
      tmp = Math.abs(dy) < 0.001;
    }
    if (tmp) {
      isLinear = true;
      var tmp_1 = this;
      // Inline function 'kotlin.math.hypot' call
      tmp_1.eeh_1 = hypot(dy, dx);
      this.jeh_1 = this.eeh_1 * this.ieh_1;
      this.oeh_1 = dx * this.ieh_1;
      this.peh_1 = dy * this.ieh_1;
      this.leh_1 = NaN;
      this.meh_1 = NaN;
    } else {
      this.leh_1 = dx * this.keh_1;
      this.meh_1 = dy * -this.keh_1;
      this.oeh_1 = isVertical ? this.ceh_1 : this.aeh_1;
      this.peh_1 = isVertical ? this.beh_1 : this.deh_1;
      this.qeh(this.aeh_1, this.beh_1, this.ceh_1, this.deh_1);
      this.jeh_1 = this.eeh_1 * this.ieh_1;
    }
    this.neh_1 = isLinear;
  }
  protoOf(Arc).reh = function (time) {
    // Inline function 'androidx.compose.animation.core.Arc.calcAngle' call
    var percent = (this.keh_1 === -1.0 ? this.zeg_1 - time : time - this.yeg_1) * this.ieh_1;
    var angle = 1.5707964 * lookup(this, percent);
    var tmp = this;
    // Inline function 'kotlin.math.sin' call
    tmp.feh_1 = Math.sin(angle);
    var tmp_0 = this;
    // Inline function 'kotlin.math.cos' call
    tmp_0.geh_1 = Math.cos(angle);
  };
  protoOf(Arc).seh = function () {
    var vx = this.leh_1 * this.geh_1;
    var vy = -this.meh_1 * this.feh_1;
    // Inline function 'kotlin.math.hypot' call
    var tmp$ret$0 = hypot(vx, vy);
    var norm = this.jeh_1 / tmp$ret$0;
    return vx * this.keh_1 * norm;
  };
  protoOf(Arc).teh = function () {
    var vx = this.leh_1 * this.geh_1;
    var vy = -this.meh_1 * this.feh_1;
    // Inline function 'kotlin.math.hypot' call
    var tmp$ret$0 = hypot(vx, vy);
    var norm = this.jeh_1 / tmp$ret$0;
    return vy * this.keh_1 * norm;
  };
  protoOf(Arc).ueh = function (time) {
    var t = time;
    t = (t - this.yeg_1) * this.ieh_1;
    return this.aeh_1 + t * (this.ceh_1 - this.aeh_1);
  };
  protoOf(Arc).veh = function (time) {
    var t = time;
    t = (t - this.yeg_1) * this.ieh_1;
    return this.beh_1 + t * (this.deh_1 - this.beh_1);
  };
  protoOf(Arc).qeh = function (x1, y1, x2, y2) {
    var a = x2 - x1;
    var b = y1 - y2;
    var lx = 0.0;
    var ly = b;
    var dist = 0.0;
    var ourPercent = get_OurPercentCache();
    var lastIndex = ourPercent.length - 1 | 0;
    var lastIndexFloat = lastIndex;
    var lut = this.heh_1;
    var inductionVariable = 1;
    if (inductionVariable <= lastIndex)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'androidx.compose.animation.core.toRadians' call
        var angle = 90.0 * i / lastIndex * (3.141592653589793 / 180.0);
        // Inline function 'kotlin.math.sin' call
        var s = Math.sin(angle);
        // Inline function 'kotlin.math.cos' call
        var c = Math.cos(angle);
        var px = a * s;
        var py = b * c;
        var tmp = dist;
        var tmp0 = px - lx;
        // Inline function 'kotlin.math.hypot' call
        var y = py - ly;
        dist = tmp + hypot(tmp0, y);
        ourPercent[i] = dist;
        lx = px;
        ly = py;
      }
       while (!(i === lastIndex));
    this.eeh_1 = dist;
    var inductionVariable_0 = 1;
    if (inductionVariable_0 <= lastIndex)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var _index_0__fvwizt = i_0;
        ourPercent[_index_0__fvwizt] = ourPercent[_index_0__fvwizt] / dist;
      }
       while (!(i_0 === lastIndex));
    var lutLastIndex = 100;
    var inductionVariable_1 = 0;
    var last = lut.length - 1 | 0;
    if (inductionVariable_1 <= last)
      do {
        var i_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var pos = i_1 / lutLastIndex;
        // Inline function 'androidx.compose.animation.core.binarySearch' call
        var index = binarySearch(ourPercent, pos);
        if (index >= 0) {
          lut[i_1] = index / lastIndexFloat;
        } else if (index === -1) {
          lut[i_1] = 0.0;
        } else {
          var p1 = (-index | 0) - 2 | 0;
          var p2 = (-index | 0) - 1 | 0;
          var ans = (p1 + (pos - ourPercent[p1]) / (ourPercent[p2] - ourPercent[p1])) / lastIndexFloat;
          lut[i_1] = ans;
        }
      }
       while (inductionVariable_1 <= last);
  };
  function ArcSpline(arcModes, timePoints, y) {
    this.xeh_1 = true;
    var mode = {_v: 1};
    var last = {_v: 1};
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = timePoints.length - 1 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = Array(tmp_1);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      switch (arcModes[tmp_3]) {
        case 1:
          mode._v = 1;
          last._v = mode._v;
          break;
        case 2:
          mode._v = 2;
          last._v = mode._v;
          break;
        case 3:
          mode._v = last._v === 1 ? 2 : 1;
          last._v = mode._v;
          break;
        case 0:
          mode._v = 3;
          break;
        case 5:
          mode._v = 5;
          break;
        case 4:
          mode._v = 4;
          break;
      }
      var yArray = y[tmp_3];
      var yArray1 = y[tmp_3 + 1 | 0];
      var timeArray = timePoints[tmp_3];
      var timeArray1 = timePoints[tmp_3 + 1 | 0];
      var dim = (yArray.length / 2 | 0) + (yArray.length % 2 | 0) | 0;
      var tmp_4 = 0;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_5 = Array(dim);
      while (tmp_4 < dim) {
        var tmp_6 = tmp_4;
        var k = imul(tmp_6, 2);
        tmp_5[tmp_6] = new Arc(mode._v, timeArray, timeArray1, yArray[k], yArray[k + 1 | 0], yArray1[k], yArray1[k + 1 | 0]);
        tmp_4 = tmp_4 + 1 | 0;
      }
      tmp_2[tmp_3] = tmp_5;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.weh_1 = tmp_2;
  }
  protoOf(ArcSpline).yeh = function (time, v) {
    var t = time;
    var arcs = this.weh_1;
    var lastIndex = arcs.length - 1 | 0;
    var start = arcs[0][0].yeg_1;
    var end = arcs[lastIndex][0].zeg_1;
    var size = v.length;
    if (this.xeh_1) {
      if (t < start || t > end) {
        var p;
        var t0;
        if (t > end) {
          p = lastIndex;
          t0 = end;
        } else {
          p = 0;
          t0 = start;
        }
        var dt = t - t0;
        var i = 0;
        var j = 0;
        while (i < (size - 1 | 0)) {
          var arc = arcs[p][j];
          if (arc.neh_1) {
            var tmp = i;
            var tmp_0 = arc.ueh(t0);
            // Inline function 'androidx.compose.animation.core.Arc.linearDX' call
            v[tmp] = tmp_0 + dt * arc.oeh_1;
            var tmp_1 = i + 1 | 0;
            var tmp_2 = arc.veh(t0);
            // Inline function 'androidx.compose.animation.core.Arc.linearDY' call
            v[tmp_1] = tmp_2 + dt * arc.peh_1;
          } else {
            arc.reh(t0);
            var tmp_3 = i;
            // Inline function 'androidx.compose.animation.core.Arc.calcX' call
            v[tmp_3] = arc.oeh_1 + arc.leh_1 * access$_get_tmpSinAngle__itfxbz(arc) + dt * arc.seh();
            var tmp_4 = i + 1 | 0;
            // Inline function 'androidx.compose.animation.core.Arc.calcY' call
            v[tmp_4] = arc.peh_1 + arc.meh_1 * access$_get_tmpCosAngle__x3tzou(arc) + dt * arc.teh();
          }
          i = i + 2 | 0;
          j = j + 1 | 0;
        }
        return Unit_instance;
      }
    } else {
      // Inline function 'kotlin.math.max' call
      var a = t;
      t = Math.max(a, start);
      // Inline function 'kotlin.math.min' call
      var a_0 = t;
      t = Math.min(a_0, end);
    }
    var populated = false;
    var inductionVariable = 0;
    var last = arcs.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var k = 0;
        var j_0 = 0;
        while (j_0 < (size - 1 | 0)) {
          var arc_0 = arcs[i_0][k];
          if (t <= arc_0.zeg_1) {
            if (arc_0.neh_1) {
              v[j_0] = arc_0.ueh(t);
              v[j_0 + 1 | 0] = arc_0.veh(t);
            } else {
              arc_0.reh(t);
              var tmp_5 = j_0;
              // Inline function 'androidx.compose.animation.core.Arc.calcX' call
              v[tmp_5] = arc_0.oeh_1 + arc_0.leh_1 * access$_get_tmpSinAngle__itfxbz(arc_0);
              var tmp_6 = j_0 + 1 | 0;
              // Inline function 'androidx.compose.animation.core.Arc.calcY' call
              v[tmp_6] = arc_0.peh_1 + arc_0.meh_1 * access$_get_tmpCosAngle__x3tzou(arc_0);
            }
            populated = true;
          }
          j_0 = j_0 + 2 | 0;
          k = k + 1 | 0;
        }
        if (populated) {
          return Unit_instance;
        }
      }
       while (inductionVariable <= last);
  };
  protoOf(ArcSpline).zeh = function (time, v) {
    var arcs = this.weh_1;
    var tmp2 = arcs[0][0].yeg_1;
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    var maximumValue = arcs[arcs.length - 1 | 0][0].zeg_1;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_0 = time < tmp2 ? tmp2 : time;
    var t = this_0 > maximumValue ? maximumValue : this_0;
    var size = v.length;
    var populated = false;
    var inductionVariable = 0;
    var last = arcs.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var j = 0;
        var k = 0;
        while (j < (size - 1 | 0)) {
          var arc = arcs[i][k];
          if (t <= arc.zeg_1) {
            if (arc.neh_1) {
              var tmp = j;
              // Inline function 'androidx.compose.animation.core.Arc.linearDX' call
              v[tmp] = arc.oeh_1;
              var tmp_0 = j + 1 | 0;
              // Inline function 'androidx.compose.animation.core.Arc.linearDY' call
              v[tmp_0] = arc.peh_1;
            } else {
              arc.reh(t);
              v[j] = arc.seh();
              v[j + 1 | 0] = arc.teh();
            }
            populated = true;
          }
          j = j + 2 | 0;
          k = k + 1 | 0;
        }
        if (populated) {
          return Unit_instance;
        }
      }
       while (inductionVariable <= last);
  };
  var properties_initialized_ArcSpline_kt_jqay4z;
  function _init_properties_ArcSpline_kt__f15lqp() {
    if (!properties_initialized_ArcSpline_kt_jqay4z) {
      properties_initialized_ArcSpline_kt_jqay4z = true;
      OurPercentCache = new Float32Array(91);
      androidx_compose_animation_core_ArcSpline_Arc$stable = 8;
      androidx_compose_animation_core_ArcSpline$stable = 8;
    }
  }
  function generateDecayAnimationSpec(_this__u8e3s4) {
    return new DecayAnimationSpecImpl(_this__u8e3s4);
  }
  function exponentialDecay(frictionMultiplier, absVelocityThreshold) {
    frictionMultiplier = frictionMultiplier === VOID ? 1.0 : frictionMultiplier;
    absVelocityThreshold = absVelocityThreshold === VOID ? 0.1 : absVelocityThreshold;
    return generateDecayAnimationSpec(new FloatExponentialDecaySpec(frictionMultiplier, absVelocityThreshold));
  }
  function DecayAnimationSpecImpl(floatDecaySpec) {
    this.aei_1 = floatDecaySpec;
  }
  protoOf(DecayAnimationSpecImpl).qed = function (typeConverter) {
    return new VectorizedFloatDecaySpec(this.aei_1);
  };
  function _get_valueVector__r10idf($this) {
    var tmp = $this.cei_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('valueVector');
    }
  }
  function _get_velocityVector__dvxlkl($this) {
    var tmp = $this.dei_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('velocityVector');
    }
  }
  function _get_targetVector__vn6c89($this) {
    var tmp = $this.eei_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('targetVector');
    }
  }
  function VectorizedFloatDecaySpec(floatDecaySpec) {
    this.bei_1 = floatDecaySpec;
    this.fei_1 = this.bei_1.zee();
  }
  protoOf(VectorizedFloatDecaySpec).zee = function () {
    return this.fei_1;
  };
  protoOf(VectorizedFloatDecaySpec).aef = function (playTimeNanos, initialValue, initialVelocity) {
    if (!!(this.cei_1 == null)) {
      this.cei_1 = newInstance(initialValue);
    }
    var inductionVariable = 0;
    var last = _get_valueVector__r10idf(this).mea();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        _get_valueVector__r10idf(this).oea(i, this.bei_1.gei(playTimeNanos, initialValue.nea(i), initialVelocity.nea(i)));
      }
       while (inductionVariable < last);
    return _get_valueVector__r10idf(this);
  };
  protoOf(VectorizedFloatDecaySpec).xee = function (initialValue, initialVelocity) {
    var maxDuration = new Long(0, 0);
    if (!!(this.dei_1 == null)) {
      this.dei_1 = newInstance(initialValue);
    }
    var inductionVariable = 0;
    var last = _get_velocityVector__dvxlkl(this).mea();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0 = maxDuration;
        // Inline function 'kotlin.comparisons.maxOf' call
        var b = this.bei_1.hei(initialValue.nea(i), initialVelocity.nea(i));
        maxDuration = compare(tmp0, b) >= 0 ? tmp0 : b;
      }
       while (inductionVariable < last);
    return maxDuration;
  };
  protoOf(VectorizedFloatDecaySpec).yee = function (playTimeNanos, initialValue, initialVelocity) {
    if (!!(this.dei_1 == null)) {
      this.dei_1 = newInstance(initialValue);
    }
    var inductionVariable = 0;
    var last = _get_velocityVector__dvxlkl(this).mea();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        _get_velocityVector__dvxlkl(this).oea(i, this.bei_1.iei(playTimeNanos, initialValue.nea(i), initialVelocity.nea(i)));
      }
       while (inductionVariable < last);
    return _get_velocityVector__dvxlkl(this);
  };
  protoOf(VectorizedFloatDecaySpec).wee = function (initialValue, initialVelocity) {
    if (!!(this.eei_1 == null)) {
      this.eei_1 = newInstance(initialValue);
    }
    var inductionVariable = 0;
    var last = _get_targetVector__vn6c89(this).mea();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        _get_targetVector__vn6c89(this).oea(i, this.bei_1.jei(initialValue.nea(i), initialVelocity.nea(i)));
      }
       while (inductionVariable < last);
    return _get_targetVector__vn6c89(this);
  };
  function calculateTargetValue(_this__u8e3s4, initialValue, initialVelocity) {
    var vectorizedSpec = _this__u8e3s4.qed(get_VectorConverter(FloatCompanionObject_instance));
    var targetVector = vectorizedSpec.wee(AnimationVector(initialValue), AnimationVector(initialVelocity));
    return targetVector.jeg_1;
  }
  var androidx_compose_animation_core_DeferredTargetAnimation$stable;
  function get_FastOutSlowInEasing() {
    _init_properties_Easing_kt__v6fq45();
    return FastOutSlowInEasing;
  }
  var FastOutSlowInEasing;
  var LinearOutSlowInEasing;
  function get_FastOutLinearInEasing() {
    _init_properties_Easing_kt__v6fq45();
    return FastOutLinearInEasing;
  }
  var FastOutLinearInEasing;
  function get_LinearEasing() {
    _init_properties_Easing_kt__v6fq45();
    return LinearEasing;
  }
  var LinearEasing;
  var androidx_compose_animation_core_CubicBezierEasing$stable;
  function Easing() {
  }
  function throwNoSolution($this, fraction) {
    throw IllegalArgumentException_init_$Create$('The cubic curve with parameters (' + $this.lei_1 + ', ' + $this.mei_1 + ', ' + $this.nei_1 + ', ' + $this.oei_1 + ') has no solution at ' + fraction);
  }
  function CubicBezierEasing(a, b, c, d) {
    this.lei_1 = a;
    this.mei_1 = b;
    this.nei_1 = c;
    this.oei_1 = d;
    // Inline function 'androidx.compose.animation.core.requirePrecondition' call
    if (!(!isNaN_0(this.lei_1) && !isNaN_0(this.mei_1) && !isNaN_0(this.nei_1) && !isNaN_0(this.oei_1))) {
      var tmp$ret$1 = 'Parameters to CubicBezierEasing cannot be NaN. Actual parameters are: ' + this.lei_1 + ', ' + this.mei_1 + ', ' + this.nei_1 + ', ' + this.oei_1 + '.';
      throwIllegalArgumentException(tmp$ret$1);
    }
    var roots = new Float32Array(5);
    var extrema = computeCubicVerticalBounds(0.0, this.mei_1, this.oei_1, 1.0, roots, 0);
    var tmp = this;
    // Inline function 'androidx.collection.FloatFloatPair.first' call
    // Inline function 'androidx.collection.internal.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(_FloatFloatPair___get_packedValue__impl__5lczxp(extrema), 32));
    tmp.pei_1 = floatFromBits(bits);
    var tmp_0 = this;
    // Inline function 'androidx.collection.FloatFloatPair.second' call
    // Inline function 'androidx.collection.internal.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(_FloatFloatPair___get_packedValue__impl__5lczxp(extrema), new Long(-1, 0)));
    tmp_0.qei_1 = floatFromBits(bits_0);
  }
  protoOf(CubicBezierEasing).kei = function (fraction) {
    var tmp;
    if (fraction > 0.0 && fraction < 1.0) {
      // Inline function 'kotlin.math.max' call
      var b = 1.1920929E-7;
      var f = Math.max(fraction, b);
      var t = findFirstCubicRoot(0.0 - f, this.lei_1 - f, this.nei_1 - f, 1.0 - f);
      if (isNaN_0(t)) {
        throwNoSolution(this, fraction);
      }
      var tmp0 = evaluateCubic(this.mei_1, this.oei_1, t);
      var tmp2 = this.pei_1;
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      var maximumValue = this.qei_1;
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_0 = tmp0 < tmp2 ? tmp2 : tmp0;
      tmp = this_0 > maximumValue ? maximumValue : this_0;
    } else {
      tmp = fraction;
    }
    return tmp;
  };
  protoOf(CubicBezierEasing).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof CubicBezierEasing) {
      tmp_2 = this.lei_1 === other.lei_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.mei_1 === other.mei_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.nei_1 === other.nei_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.oei_1 === other.oei_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(CubicBezierEasing).hashCode = function () {
    return imul(imul(imul(getNumberHashCode(this.lei_1), 31) + getNumberHashCode(this.mei_1) | 0, 31) + getNumberHashCode(this.nei_1) | 0, 31) + getNumberHashCode(this.oei_1) | 0;
  };
  protoOf(CubicBezierEasing).toString = function () {
    return 'CubicBezierEasing(a=' + this.lei_1 + ', b=' + this.mei_1 + ', c=' + this.nei_1 + ', d=' + this.oei_1 + ')';
  };
  function sam$androidx_compose_animation_core_Easing$0(function_0) {
    this.rei_1 = function_0;
  }
  protoOf(sam$androidx_compose_animation_core_Easing$0).kei = function (fraction) {
    return this.rei_1(fraction);
  };
  protoOf(sam$androidx_compose_animation_core_Easing$0).q3 = function () {
    return this.rei_1;
  };
  protoOf(sam$androidx_compose_animation_core_Easing$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Easing) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_animation_core_Easing$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function LinearEasing$lambda(fraction) {
    _init_properties_Easing_kt__v6fq45();
    return fraction;
  }
  var properties_initialized_Easing_kt_af4f4d;
  function _init_properties_Easing_kt__v6fq45() {
    if (!properties_initialized_Easing_kt_af4f4d) {
      properties_initialized_Easing_kt_af4f4d = true;
      FastOutSlowInEasing = new CubicBezierEasing(0.4, 0.0, 0.2, 1.0);
      LinearOutSlowInEasing = new CubicBezierEasing(0.0, 0.0, 0.2, 1.0);
      FastOutLinearInEasing = new CubicBezierEasing(0.4, 0.0, 1.0, 1.0);
      var tmp = LinearEasing$lambda;
      LinearEasing = new sam$androidx_compose_animation_core_Easing$0(tmp);
      androidx_compose_animation_core_CubicBezierEasing$stable = 0;
    }
  }
  var androidx_compose_animation_core_FloatSpringSpec$stable;
  var androidx_compose_animation_core_FloatTweenSpec$stable;
  function FloatTweenSpec(duration, delay, easing) {
    duration = duration === VOID ? 300 : duration;
    delay = delay === VOID ? 0 : delay;
    easing = easing === VOID ? get_FastOutSlowInEasing() : easing;
    this.sei_1 = duration;
    this.tei_1 = delay;
    this.uei_1 = easing;
    this.vei_1 = multiply(numberToLong(this.sei_1), new Long(1000000, 0));
    this.wei_1 = multiply(numberToLong(this.tei_1), new Long(1000000, 0));
  }
  protoOf(FloatTweenSpec).xei = function (playTimeNanos, initialValue, targetValue, initialVelocity) {
    // Inline function 'androidx.compose.animation.core.FloatTweenSpec.clampPlayTimeNanos' call
    var tmp0 = subtract(playTimeNanos, this.wei_1);
    var tmp2 = new Long(0, 0);
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    var maximumValue = this.vei_1;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_0 = compare(tmp0, tmp2) < 0 ? tmp2 : tmp0;
    var clampedPlayTimeNanos = compare(this_0, maximumValue) > 0 ? maximumValue : this_0;
    var tmp;
    if (this.sei_1 === 0) {
      tmp = 1.0;
    } else {
      // Inline function 'kotlin.Long.div' call
      var other = toNumber(this.vei_1);
      tmp = toNumber(clampedPlayTimeNanos) / other;
    }
    var rawFraction = tmp;
    var fraction = this.uei_1.kei(rawFraction);
    // Inline function 'androidx.compose.animation.core.lerp' call
    return initialValue * (1 - fraction) + targetValue * fraction;
  };
  protoOf(FloatTweenSpec).yei = function (initialValue, targetValue, initialVelocity) {
    return add(this.wei_1, this.vei_1);
  };
  protoOf(FloatTweenSpec).zei = function (playTimeNanos, initialValue, targetValue, initialVelocity) {
    // Inline function 'androidx.compose.animation.core.FloatTweenSpec.clampPlayTimeNanos' call
    var tmp0 = subtract(playTimeNanos, this.wei_1);
    var tmp2 = new Long(0, 0);
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    var maximumValue = this.vei_1;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_0 = compare(tmp0, tmp2) < 0 ? tmp2 : tmp0;
    var clampedPlayTimeNanos = compare(this_0, maximumValue) > 0 ? maximumValue : this_0;
    if (equalsLong(clampedPlayTimeNanos, new Long(0, 0))) {
      return initialVelocity;
    }
    var startNum = this.xei(subtract(clampedPlayTimeNanos, new Long(1000000, 0)), initialValue, targetValue, initialVelocity);
    var endNum = this.xei(clampedPlayTimeNanos, initialValue, targetValue, initialVelocity);
    return (endNum - startNum) * 1000.0;
  };
  protoOf(FloatTweenSpec).qed = function (converter) {
    return this.bej(converter);
  };
  function FloatAnimationSpec() {
  }
  function FloatSpringSpec(dampingRatio, stiffness, visibilityThreshold) {
    dampingRatio = dampingRatio === VOID ? 1.0 : dampingRatio;
    stiffness = stiffness === VOID ? 1500.0 : stiffness;
    visibilityThreshold = visibilityThreshold === VOID ? 0.01 : visibilityThreshold;
    this.cej_1 = dampingRatio;
    this.dej_1 = stiffness;
    this.eej_1 = visibilityThreshold;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new SpringSimulation(1.0);
    this_0.jej(this.cej_1);
    this_0.kej(this.dej_1);
    tmp.fej_1 = this_0;
  }
  protoOf(FloatSpringSpec).xei = function (playTimeNanos, initialValue, targetValue, initialVelocity) {
    var playTimeMillis = divide(playTimeNanos, new Long(1000000, 0));
    this.fej_1.gej_1 = targetValue;
    // Inline function 'androidx.compose.animation.core.Motion.value' call
    var this_0 = this.fej_1.lej(initialValue, initialVelocity, playTimeMillis);
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Motion___get_packedValue__impl__qymh4n(this_0);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    return floatFromBits(bits);
  };
  protoOf(FloatSpringSpec).zei = function (playTimeNanos, initialValue, targetValue, initialVelocity) {
    var playTimeMillis = divide(playTimeNanos, new Long(1000000, 0));
    this.fej_1.gej_1 = targetValue;
    // Inline function 'androidx.compose.animation.core.Motion.velocity' call
    var this_0 = this.fej_1.lej(initialValue, initialVelocity, playTimeMillis);
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value = _Motion___get_packedValue__impl__qymh4n(this_0);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
    return floatFromBits(bits);
  };
  protoOf(FloatSpringSpec).aej = function (initialValue, targetValue, initialVelocity) {
    return 0.0;
  };
  protoOf(FloatSpringSpec).yei = function (initialValue, targetValue, initialVelocity) {
    var tmp0_stiffness = this.fej_1.mej();
    var tmp1_dampingRatio = this.fej_1.iej_1;
    var tmp2_initialDisplacement = (initialValue - targetValue) / this.eej_1;
    var tmp3_initialVelocity = initialVelocity / this.eej_1;
    return multiply(estimateAnimationDurationMillis(tmp0_stiffness, tmp1_dampingRatio, tmp3_initialVelocity, tmp2_initialDisplacement, 1.0), new Long(1000000, 0));
  };
  protoOf(FloatSpringSpec).qed = function (converter) {
    return this.bej(converter);
  };
  var androidx_compose_animation_core_FloatExponentialDecaySpec$stable;
  function FloatExponentialDecaySpec(frictionMultiplier, absVelocityThreshold) {
    frictionMultiplier = frictionMultiplier === VOID ? 1.0 : frictionMultiplier;
    absVelocityThreshold = absVelocityThreshold === VOID ? 0.1 : absVelocityThreshold;
    var tmp = this;
    // Inline function 'kotlin.math.abs' call
    // Inline function 'kotlin.math.max' call
    var b = Math.abs(absVelocityThreshold);
    tmp.nej_1 = Math.max(1.0E-7, b);
    var tmp_0 = this;
    // Inline function 'kotlin.math.max' call
    tmp_0.oej_1 = -4.2 * Math.max(1.0E-4, frictionMultiplier);
  }
  protoOf(FloatExponentialDecaySpec).zee = function () {
    return this.nej_1;
  };
  protoOf(FloatExponentialDecaySpec).gei = function (playTimeNanos, initialValue, initialVelocity) {
    var playTimeMillis = divide(playTimeNanos, new Long(1000000, 0));
    var tmp = initialValue - initialVelocity / this.oej_1;
    var tmp_0 = initialVelocity / this.oej_1;
    // Inline function 'kotlin.math.exp' call
    var x = this.oej_1 * toNumber(playTimeMillis) / 1000.0;
    return tmp + tmp_0 * Math.exp(x);
  };
  protoOf(FloatExponentialDecaySpec).iei = function (playTimeNanos, initialValue, initialVelocity) {
    var playTimeMillis = divide(playTimeNanos, new Long(1000000, 0));
    // Inline function 'kotlin.Long.div' call
    // Inline function 'kotlin.math.exp' call
    var x = toNumber(playTimeMillis) / 1000.0 * this.oej_1;
    return initialVelocity * Math.exp(x);
  };
  protoOf(FloatExponentialDecaySpec).hei = function (initialValue, initialVelocity) {
    // Inline function 'kotlin.math.abs' call
    var tmp$ret$0 = Math.abs(initialVelocity);
    // Inline function 'kotlin.math.ln' call
    var x = this.nej_1 / tmp$ret$0;
    var tmp$ret$1 = Math.log(x);
    return multiply(numberToLong(1000.0 * tmp$ret$1 / this.oej_1), new Long(1000000, 0));
  };
  protoOf(FloatExponentialDecaySpec).jei = function (initialValue, initialVelocity) {
    // Inline function 'kotlin.math.abs' call
    if (Math.abs(initialVelocity) <= this.nej_1) {
      return initialValue;
    }
    // Inline function 'kotlin.math.abs' call
    var x = this.nej_1 / initialVelocity;
    // Inline function 'kotlin.math.ln' call
    var x_0 = Math.abs(x);
    var duration = Math.log(x_0) / this.oej_1 * 1000;
    var tmp = initialValue - initialVelocity / this.oej_1;
    var tmp_0 = initialVelocity / this.oej_1;
    // Inline function 'kotlin.math.exp' call
    var x_1 = this.oej_1 * duration / 1000.0;
    return tmp + tmp_0 * Math.exp(x_1);
  };
  function withInfiniteAnimationFrameNanos(onFrame, $completion) {
    var tmp = new $withInfiniteAnimationFrameNanosCOROUTINE$(onFrame, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function withInfiniteAnimationFrameNanos$slambda($onFrame, resultContinuation) {
    this.hek_1 = $onFrame;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(withInfiniteAnimationFrameNanos$slambda).ia = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(withInfiniteAnimationFrameNanos$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = withFrameNanos(this.hek_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(withInfiniteAnimationFrameNanos$slambda).s2b = function (completion) {
    return new withInfiniteAnimationFrameNanos$slambda(this.hek_1, completion);
  };
  function withInfiniteAnimationFrameNanos$slambda_0($onFrame, resultContinuation) {
    var i = new withInfiniteAnimationFrameNanos$slambda($onFrame, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.ia($completion);
    }, 0);
  }
  function $withInfiniteAnimationFrameNanosCOROUTINE$(onFrame, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xej_1 = onFrame;
  }
  protoOf($withInfiniteAnimationFrameNanosCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var policy = this.t9().aa(Key_instance);
            if (policy == null) {
              this.n9_1 = 2;
              suspendResult = withFrameNanos(this.xej_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = policy.iek(withInfiniteAnimationFrameNanos$slambda_0(this.xej_1, null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.yej_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.yej_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return this.yej_1;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  var androidx_compose_animation_core_InfiniteTransition$stable;
  function InfiniteTransition$TransitionAnimationState$_get_value_$ref_4esztk() {
    return constructCallableReference(function (p0) {
      return p0.u1();
    }, 1, 0, 183);
  }
  function InfiniteTransition$TransitionAnimationState$_set_value_$ref_xpng84() {
    return constructCallableReference(function (p0, p1) {
      p0.gea(p1);
      return Unit_instance;
    }, 2, 0, 184);
  }
  function InfiniteTransition$run$slambda$lambda($toolingOverride, this$0, $durationScale, $this_LaunchedEffect) {
    return function (it) {
      var tmp0_safe_receiver = $toolingOverride.u1();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u1();
      var currentTimeNanos = tmp1_elvis_lhs == null ? it : tmp1_elvis_lhs;
      var tmp;
      if (equalsLong(this$0.xek_1, new Long(0, -2147483648)) || !($durationScale._v === get_durationScale($this_LaunchedEffect.q19()))) {
        this$0.xek_1 = it;
        // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
        var this_0 = this$0.vek_1;
        var i = 0;
        var tmp_0 = this_0.b3e_1;
        var content = isArray(tmp_0) ? tmp_0 : THROW_CCE();
        var size = this_0.d3e_1;
        while (i < size) {
          content[i].qea();
          i = i + 1 | 0;
        }
        $durationScale._v = get_durationScale($this_LaunchedEffect.q19());
        tmp = Unit_instance;
      }
      var tmp_1;
      if ($durationScale._v === 0.0) {
        // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
        var this_1 = this$0.vek_1;
        var i_0 = 0;
        var tmp_2 = this_1.b3e_1;
        var content_0 = isArray(tmp_2) ? tmp_2 : THROW_CCE();
        var size_0 = this_1.d3e_1;
        while (i_0 < size_0) {
          content_0[i_0].zek();
          i_0 = i_0 + 1 | 0;
        }
        tmp_1 = Unit_instance;
      } else {
        var tmp0 = subtract(currentTimeNanos, this$0.xek_1);
        // Inline function 'kotlin.Long.div' call
        var other = $durationScale._v;
        var tmp$ret$4 = toNumber(tmp0) / other;
        var playTimeNanos = numberToLong(tmp$ret$4);
        onFrame(this$0, playTimeNanos);
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function InfiniteTransition$run$slambda$lambda_0($this_LaunchedEffect) {
    return function () {
      return get_durationScale($this_LaunchedEffect.q19());
    };
  }
  function InfiniteTransition$run$slambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(InfiniteTransition$run$slambda$slambda).jel = function (it, $completion) {
    var tmp = this.kel(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(InfiniteTransition$run$slambda$slambda).ja = function (p1, $completion) {
    return this.jel((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(InfiniteTransition$run$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          return this.iel_1 > 0.0;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(InfiniteTransition$run$slambda$slambda).kel = function (it, completion) {
    var i = new InfiniteTransition$run$slambda$slambda(completion);
    i.iel_1 = it;
    return i;
  };
  function InfiniteTransition$run$slambda$slambda_0(resultContinuation) {
    var i = new InfiniteTransition$run$slambda$slambda(resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.jel(it, $completion);
    }, 1);
  }
  function TransitionAnimationState($outer, initialValue, targetValue, typeConverter, animationSpec, label) {
    this.tek_1 = $outer;
    this.jek_1 = initialValue;
    this.kek_1 = targetValue;
    this.lek_1 = typeConverter;
    this.mek_1 = label;
    this.nek_1 = mutableStateOf(this.jek_1);
    this.oek_1 = animationSpec;
    this.pek_1 = TargetBasedAnimation_init_$Create$(this.oek_1, this.lek_1, this.jek_1, this.kek_1);
    this.qek_1 = false;
    this.rek_1 = false;
    this.sek_1 = new Long(0, 0);
  }
  protoOf(TransitionAnimationState).gea = function (_set____db54di) {
    var tmp0 = this.nek_1;
    var tmp = KMutableProperty1;
    var tmp_0 = InfiniteTransition$TransitionAnimationState$_get_value_$ref_4esztk();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('value', 1, tmp, tmp_0, InfiniteTransition$TransitionAnimationState$_set_value_$ref_xpng84());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(TransitionAnimationState).u1 = function () {
    var tmp0 = this.nek_1;
    var tmp = KMutableProperty1;
    var tmp_0 = InfiniteTransition$TransitionAnimationState$_get_value_$ref_4esztk();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('value', 1, tmp, tmp_0, InfiniteTransition$TransitionAnimationState$_set_value_$ref_xpng84());
    return tmp0.u1();
  };
  protoOf(TransitionAnimationState).lel = function (initialValue, targetValue, animationSpec) {
    this.jek_1 = initialValue;
    this.kek_1 = targetValue;
    this.oek_1 = animationSpec;
    this.pek_1 = TargetBasedAnimation_init_$Create$(animationSpec, this.lek_1, initialValue, targetValue);
    _set_refreshChildNeeded__4sbmm9(this.tek_1, true);
    this.qek_1 = false;
    this.rek_1 = true;
  };
  protoOf(TransitionAnimationState).mel = function (playTimeNanos) {
    _set_refreshChildNeeded__4sbmm9(this.tek_1, false);
    if (this.rek_1) {
      this.rek_1 = false;
      this.sek_1 = playTimeNanos;
    }
    var playTime = subtract(playTimeNanos, this.sek_1);
    this.gea(this.pek_1.gee(playTime));
    this.qek_1 = this.pek_1.iee(playTime);
  };
  protoOf(TransitionAnimationState).zek = function () {
    this.gea(this.pek_1.sea());
    this.rek_1 = true;
  };
  protoOf(TransitionAnimationState).qea = function () {
    this.rek_1 = true;
  };
  function _set_refreshChildNeeded__4sbmm9($this, _set____db54di) {
    var tmp0 = $this.wek_1;
    var tmp = KMutableProperty1;
    var tmp_0 = InfiniteTransition$_get_refreshChildNeeded_$ref_yz57en();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('refreshChildNeeded', 1, tmp, tmp_0, InfiniteTransition$_set_refreshChildNeeded_$ref_cq1qyz());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get_refreshChildNeeded__t5joi3($this) {
    var tmp0 = $this.wek_1;
    var tmp = KMutableProperty1;
    var tmp_0 = InfiniteTransition$_get_refreshChildNeeded_$ref_yz57en();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('refreshChildNeeded', 1, tmp, tmp_0, InfiniteTransition$_set_refreshChildNeeded_$ref_cq1qyz());
    return tmp0.u1();
  }
  function _set_isRunning__kpbg34_0($this, _set____db54di) {
    var tmp0 = $this.yek_1;
    var tmp = KMutableProperty1;
    var tmp_0 = InfiniteTransition$_get_isRunning_$ref_aibw34();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('isRunning', 1, tmp, tmp_0, InfiniteTransition$_set_isRunning_$ref_pq3elg());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get_isRunning__l0y5hg($this) {
    var tmp0 = $this.yek_1;
    var tmp = KMutableProperty1;
    var tmp_0 = InfiniteTransition$_get_isRunning_$ref_aibw34();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('isRunning', 1, tmp, tmp_0, InfiniteTransition$_set_isRunning_$ref_pq3elg());
    return tmp0.u1();
  }
  function onFrame($this, playTimeNanos) {
    var allFinished = true;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = $this.vek_1;
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var it = content[i];
      if (!it.qek_1) {
        it.mel(playTimeNanos);
      }
      if (!it.qek_1) {
        allFinished = false;
      }
      i = i + 1 | 0;
    }
    _set_isRunning__kpbg34_0($this, !allFinished);
  }
  function InfiniteTransition$_get_refreshChildNeeded_$ref_yz57en() {
    return constructCallableReference(function (p0) {
      return _get_refreshChildNeeded__t5joi3(p0);
    }, 1, 0, 185);
  }
  function InfiniteTransition$_set_refreshChildNeeded_$ref_cq1qyz() {
    return constructCallableReference(function (p0, p1) {
      _set_refreshChildNeeded__4sbmm9(p0, p1);
      return Unit_instance;
    }, 2, 0, 186);
  }
  function InfiniteTransition$_get_isRunning_$ref_aibw34() {
    return constructCallableReference(function (p0) {
      return _get_isRunning__l0y5hg(p0);
    }, 1, 0, 187);
  }
  function InfiniteTransition$_set_isRunning_$ref_pq3elg() {
    return constructCallableReference(function (p0, p1) {
      _set_isRunning__kpbg34_0(p0, p1);
      return Unit_instance;
    }, 2, 0, 188);
  }
  function InfiniteTransition$run$slambda($toolingOverride, this$0, resultContinuation) {
    this.vel_1 = $toolingOverride;
    this.wel_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(InfiniteTransition$run$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(InfiniteTransition$run$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(InfiniteTransition$run$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.yel_1 = {_v: 1.0};
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.n9_1 = 6;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = withInfiniteAnimationFrameNanos(InfiniteTransition$run$slambda$lambda(this.vel_1, this.wel_1, this.yel_1, this.xel_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            if (this.yel_1._v === 0.0) {
              this.n9_1 = 3;
              var tmp_0 = snapshotFlow(InfiniteTransition$run$slambda$lambda_0(this.xel_1));
              suspendResult = first(tmp_0, InfiniteTransition$run$slambda$slambda_0(null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.n9_1 = 1;
            continue $sm;
          case 5:
            throw this.q9_1;
          case 6:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(InfiniteTransition$run$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new InfiniteTransition$run$slambda(this.vel_1, this.wel_1, completion);
    i.xel_1 = $this$LaunchedEffect;
    return i;
  };
  function InfiniteTransition$run$slambda_0($toolingOverride, this$0, resultContinuation) {
    var i = new InfiniteTransition$run$slambda($toolingOverride, this$0, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function InfiniteTransition$run$lambda($tmp0_rcvr, $$changed) {
    return function ($composer, $force) {
      $tmp0_rcvr.zel($composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function InfiniteTransition(label) {
    this.uek_1 = label;
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    tmp.vek_1 = new MutableVector(tmp$ret$2, 0);
    this.wek_1 = mutableStateOf(false);
    this.xek_1 = new Long(0, -2147483648);
    this.yek_1 = mutableStateOf(true);
  }
  protoOf(InfiniteTransition).aem = function (animation) {
    this.vek_1.zz(animation);
    _set_refreshChildNeeded__4sbmm9(this, true);
  };
  protoOf(InfiniteTransition).bem = function (animation) {
    this.vek_1.g10(animation);
  };
  protoOf(InfiniteTransition).zel = function ($composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-318043801);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(this) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 3) === 2), $dirty & 1)) {
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance().f30_1) {
        var value = mutableStateOf(null);
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var toolingOverride = tmp;
      if (_get_isRunning__l0y5hg(this) || _get_refreshChildNeeded__t5joi3(this)) {
        $composer_0.m30(-144841960);
        var tmp0 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31(this);
        // Inline function 'kotlin.let' call
        var it_0 = tmp0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value_0 = InfiniteTransition$run$slambda_0(toolingOverride, this, null);
          tmp0.j31(value_0);
          tmp_0 = value_0;
        } else {
          tmp_0 = it_0;
        }
        var tmp$ret$4 = tmp_0;
        LaunchedEffect(this, tmp$ret$4, $composer_0, 14 & $dirty);
        $composer_0.n30();
      } else {
        $composer_0.m30(-143455237);
        $composer_0.n30();
      }
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(InfiniteTransition$run$lambda(this, $changed));
    }
  };
  function rememberInfiniteTransition(label, $composer, $changed, $default) {
    var label_0 = label;
    var $composer_0 = $composer;
    if (!(($default & 1) === 0))
      label_0 = 'InfiniteTransition';
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance().f30_1) {
      var value = new InfiniteTransition(label_0);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var infiniteTransition = tmp;
    infiniteTransition.zel($composer_0, 0);
    return infiniteTransition;
  }
  function animateFloat(_this__u8e3s4, initialValue, targetValue, animationSpec, label, $composer, $changed, $default) {
    var label_0 = label;
    var $composer_0 = $composer;
    if (!(($default & 8) === 0))
      label_0 = 'FloatAnimation';
    return animateValue(_this__u8e3s4, initialValue, targetValue, get_VectorConverter(FloatCompanionObject_instance), animationSpec, label_0, $composer_0, 14 & $changed | 112 & $changed | 896 & $changed | 57344 & $changed << 3 | 458752 & $changed << 3, 0);
  }
  function androidx_compose_animation_core_InfiniteTransition$stableprop_getter() {
    return androidx_compose_animation_core_InfiniteTransition$stable;
  }
  function animateValue(_this__u8e3s4, initialValue, targetValue, typeConverter, animationSpec, label, $composer, $changed, $default) {
    var label_0 = label;
    var $composer_0 = $composer;
    if (!(($default & 16) === 0))
      label_0 = 'ValueAnimation';
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance().f30_1) {
      var value = new TransitionAnimationState(_this__u8e3s4, initialValue, targetValue, typeConverter, animationSpec, label_0);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var transitionAnimation = tmp;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!((($changed & 112 ^ 48) > 32 && $composer_0.q31(initialValue) || ($changed & 48) === 32) | (($changed & 896 ^ 384) > 256 && $composer_0.q31(targetValue) || ($changed & 384) === 256)) | (($changed & 57344 ^ 24576) > 16384 && $composer_0.q31(animationSpec) || ($changed & 24576) === 16384));
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_0;
    if (invalid || it_0 === Companion_getInstance().f30_1) {
      var value_0 = animateValue$lambda(initialValue, transitionAnimation, targetValue, animationSpec);
      $composer_0.j31(value_0);
      tmp_0 = value_0;
    } else {
      tmp_0 = it_0;
    }
    var tmp$ret$4 = tmp_0;
    SideEffect(tmp$ret$4, $composer_0, 0);
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid_0 = $composer_0.q31(_this__u8e3s4);
    // Inline function 'kotlin.let' call
    var it_1 = $composer_0.i31();
    var tmp_1;
    if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
      var value_1 = animateValue$lambda_0(_this__u8e3s4, transitionAnimation);
      $composer_0.j31(value_1);
      tmp_1 = value_1;
    } else {
      tmp_1 = it_1;
    }
    var tmp$ret$8 = tmp_1;
    DisposableEffect(transitionAnimation, tmp$ret$8, $composer_0, 6);
    return transitionAnimation;
  }
  function animateValue$lambda($initialValue, $transitionAnimation, $targetValue, $animationSpec) {
    return function () {
      var tmp;
      if (!equals($initialValue, $transitionAnimation.jek_1) || !equals($targetValue, $transitionAnimation.kek_1)) {
        $transitionAnimation.lel($initialValue, $targetValue, $animationSpec);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function animateValue$$inlined$cache$2$1($this_animateValue, $transitionAnimation) {
    this.cem_1 = $this_animateValue;
    this.dem_1 = $transitionAnimation;
  }
  protoOf(animateValue$$inlined$cache$2$1).s1d = function () {
    this.cem_1.bem(this.dem_1);
  };
  function animateValue$lambda_0($this_animateValue, $transitionAnimation) {
    return function ($this$DisposableEffect) {
      $this_animateValue.aem($transitionAnimation);
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new animateValue$$inlined$cache$2$1($this_animateValue, $transitionAnimation);
    };
  }
  var androidx_compose_animation_core_MutationInterruptedException$stable;
  var androidx_compose_animation_core_MutatorMutex$stable;
  function Mutator(priority, job) {
    this.eem_1 = priority;
    this.fem_1 = job;
  }
  protoOf(Mutator).gem = function (other) {
    return this.eem_1.i3(other.eem_1) >= 0;
  };
  protoOf(Mutator).e2z = function () {
    return this.fem_1.a1b(new MutationInterruptedException());
  };
  function tryMutateOrCancel($this, mutator) {
    $l$loop: while (true) {
      var oldMutator = $this.iea_1.f1i();
      if (oldMutator == null || mutator.gem(oldMutator)) {
        if ($this.iea_1.w21(oldMutator, mutator)) {
          if (oldMutator == null)
            null;
          else {
            oldMutator.e2z();
          }
          break $l$loop;
        }
      } else
        throw CancellationException_init_$Create$('Current mutation had a higher priority');
    }
  }
  function MutatorMutex$mutate$slambda($priority, this$0, $block, resultContinuation) {
    this.qem_1 = $priority;
    this.rem_1 = this$0;
    this.sem_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(MutatorMutex$mutate$slambda).j8x = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(MutatorMutex$mutate$slambda).ja = function (p1, $completion) {
    return this.j8x((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(MutatorMutex$mutate$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 9;
            this.wem_1 = new Mutator(this.qem_1, ensureNotNull(this.tem_1.q19().aa(Key_instance_0)));
            tryMutateOrCancel(this.rem_1, this.wem_1);
            this.vem_1 = this.rem_1.jea_1;
            this.uem_1 = null;
            this.n9_1 = 1;
            suspendResult = this.vem_1.o2u(this.uem_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.xem_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 8;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 7;
            this.n9_1 = 4;
            suspendResult = this.sem_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.yem_1 = suspendResult;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            var tmp_0 = this.yem_1;
            this.o9_1 = 8;
            this.rem_1.iea_1.w21(this.wem_1, null);
            this.xem_1 = tmp_0;
            this.o9_1 = 9;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            var tmp_1 = this.xem_1;
            this.o9_1 = 9;
            this.vem_1.q2u(this.uem_1);
            return tmp_1;
          case 7:
            this.o9_1 = 8;
            var t = this.q9_1;
            this.rem_1.iea_1.w21(this.wem_1, null);
            throw t;
          case 8:
            this.o9_1 = 9;
            var t_0 = this.q9_1;
            this.vem_1.q2u(this.uem_1);
            throw t_0;
          case 9:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 9) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(MutatorMutex$mutate$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new MutatorMutex$mutate$slambda(this.qem_1, this.rem_1, this.sem_1, completion);
    i.tem_1 = $this$coroutineScope;
    return i;
  };
  function MutatorMutex$mutate$slambda_0($priority, this$0, $block, resultContinuation) {
    var i = new MutatorMutex$mutate$slambda($priority, this$0, $block, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.j8x($this$coroutineScope, $completion);
    }, 1);
  }
  function MutatorMutex() {
    this.iea_1 = new AtomicReference(null);
    this.jea_1 = Mutex();
  }
  protoOf(MutatorMutex).zem = function (priority, block, $completion) {
    return coroutineScope(MutatorMutex$mutate$slambda_0(priority, this, block, null), $completion);
  };
  protoOf(MutatorMutex).kea = function (priority, block, $completion, $super) {
    priority = priority === VOID ? MutatePriority_Default_getInstance() : priority;
    return $super === VOID ? this.zem(priority, block, $completion) : $super.zem.call(this, priority, block, $completion);
  };
  var MutatePriority_Default_instance;
  var MutatePriority_UserInput_instance;
  var MutatePriority_PreventUserInput_instance;
  var MutatePriority_entriesInitialized;
  function MutatePriority_initEntries() {
    if (MutatePriority_entriesInitialized)
      return Unit_instance;
    MutatePriority_entriesInitialized = true;
    MutatePriority_Default_instance = new MutatePriority('Default', 0);
    MutatePriority_UserInput_instance = new MutatePriority('UserInput', 1);
    MutatePriority_PreventUserInput_instance = new MutatePriority('PreventUserInput', 2);
  }
  function MutatePriority(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function MutationInterruptedException() {
    PlatformOptimizedCancellationException.call(this, 'Mutation interrupted');
    captureStack(this, MutationInterruptedException);
  }
  function MutatePriority_Default_getInstance() {
    MutatePriority_initEntries();
    return MutatePriority_Default_instance;
  }
  var androidx_compose_animation_core_MonoSpline$stable;
  var androidx_compose_animation_core_PathEasing$stable;
  function throwIllegalStateException(message) {
    throw IllegalStateException_init_$Create$(message);
  }
  function throwIllegalArgumentException(message) {
    throw IllegalArgumentException_init_$Create$(message);
  }
  function estimateAnimationDurationMillis(stiffness, dampingRatio, initialVelocity, initialDisplacement, delta) {
    if (dampingRatio === 0.0) {
      return new Long(2077252342, 2147);
    }
    return estimateAnimationDurationMillis_0(stiffness, dampingRatio, initialVelocity, initialDisplacement, delta);
  }
  function estimateAnimationDurationMillis_0(stiffness, dampingRatio, initialVelocity, initialDisplacement, delta) {
    var tmp = 2.0 * dampingRatio;
    // Inline function 'kotlin.math.sqrt' call
    var dampingCoefficient = tmp * Math.sqrt(stiffness);
    var partialRoot = dampingCoefficient * dampingCoefficient - 4.0 * stiffness;
    var tmp_0;
    if (partialRoot < 0.0) {
      tmp_0 = 0.0;
    } else {
      // Inline function 'kotlin.math.sqrt' call
      tmp_0 = Math.sqrt(partialRoot);
    }
    var partialRootReal = tmp_0;
    var tmp_1;
    if (partialRoot < 0.0) {
      // Inline function 'kotlin.math.abs' call
      // Inline function 'kotlin.math.sqrt' call
      var x = Math.abs(partialRoot);
      tmp_1 = Math.sqrt(x);
    } else {
      tmp_1 = 0.0;
    }
    var partialRootImaginary = tmp_1;
    var firstRootReal = (-dampingCoefficient + partialRootReal) * 0.5;
    var firstRootImaginary = partialRootImaginary * 0.5;
    var secondRootReal = (-dampingCoefficient - partialRootReal) * 0.5;
    return estimateDurationInternal(firstRootReal, firstRootImaginary, secondRootReal, dampingRatio, initialVelocity, initialDisplacement, delta);
  }
  function estimateDurationInternal(firstRootReal, firstRootImaginary, secondRootReal, dampingRatio, initialVelocity, initialPosition, delta) {
    if (initialPosition === 0.0 && initialVelocity === 0.0) {
      return new Long(0, 0);
    }
    var v0 = initialPosition < 0 ? -initialVelocity : initialVelocity;
    // Inline function 'kotlin.math.abs' call
    var p0 = Math.abs(initialPosition);
    return numberToLong((dampingRatio > 1.0 ? estimateOverDamped(firstRootReal, secondRootReal, p0, v0, delta) : dampingRatio < 1.0 ? estimateUnderDamped(firstRootReal, firstRootImaginary, p0, v0, delta) : estimateCriticallyDamped(firstRootReal, p0, v0, delta)) * 1000.0);
  }
  function estimateOverDamped(firstRootReal, secondRootReal, p0, v0, delta) {
    var r1 = firstRootReal;
    var r2 = secondRootReal;
    var c2 = (r1 * p0 - v0) / (r1 - r2);
    var c1 = p0 - c2;
    // Inline function 'kotlin.math.abs' call
    var x = delta / c1;
    // Inline function 'kotlin.math.ln' call
    var x_0 = Math.abs(x);
    var t1 = Math.log(x_0) / r1;
    // Inline function 'kotlin.math.abs' call
    var x_1 = delta / c2;
    // Inline function 'kotlin.math.ln' call
    var x_2 = Math.abs(x_1);
    var t2 = Math.log(x_2) / r2;
    var tmp;
    // Inline function 'androidx.compose.animation.core.isNotFinite' call
    // Inline function 'androidx.compose.ui.util.fastIsFinite' call
    if (!(compare(bitwiseAnd(toRawBits(t1), new Long(-1, 2147483647)), new Long(0, 2146435072)) < 0)) {
      tmp = t2;
    } else {
      // Inline function 'androidx.compose.animation.core.isNotFinite' call
      // Inline function 'androidx.compose.ui.util.fastIsFinite' call
      if (!(compare(bitwiseAnd(toRawBits(t2), new Long(-1, 2147483647)), new Long(0, 2146435072)) < 0)) {
        tmp = t1;
      } else {
        // Inline function 'kotlin.math.max' call
        tmp = Math.max(t1, t2);
      }
    }
    var tCurr = tmp;
    // Inline function 'kotlin.math.ln' call
    var x_3 = c1 * r1 / (-c2 * r2);
    var tInflection = Math.log(x_3) / (r2 - r1);
    var tmp_0;
    if (isNaN_1(tInflection) || tInflection <= 0.0) {
      tmp_0 = -delta;
    } else if (tInflection > 0.0 && -estimateOverDamped$xInflection(c1, r1, tInflection, c2, r2) < delta) {
      if (c2 > 0.0 && c1 < 0.0) {
        tCurr = 0.0;
      }
      tmp_0 = -delta;
    } else {
      // Inline function 'kotlin.math.ln' call
      var x_4 = -(c2 * r2 * r2) / (c1 * r1 * r1);
      tCurr = Math.log(x_4) / (r1 - r2);
      tmp_0 = delta;
    }
    var signedDelta = tmp_0;
    var tmp_1 = c1 * r1;
    // Inline function 'kotlin.math.exp' call
    var x_5 = r1 * tCurr;
    var tmp_2 = tmp_1 * Math.exp(x_5);
    var tmp_3 = c2 * r2;
    // Inline function 'kotlin.math.exp' call
    var x_6 = r2 * tCurr;
    // Inline function 'kotlin.math.abs' call
    var x_7 = tmp_2 + tmp_3 * Math.exp(x_6);
    if (Math.abs(x_7) < 1.0E-4) {
      return tCurr;
    }
    var tDelta = 1.7976931348623157E308;
    var iterations = 0;
    while (tDelta > 0.001 && iterations < 100) {
      iterations = iterations + 1 | 0;
      var tLast = tCurr;
      // Inline function 'androidx.compose.animation.core.iterateNewtonsMethod' call
      var x_8 = tCurr;
      // Inline function 'kotlin.math.exp' call
      var x_9 = r1 * x_8;
      var tmp_4 = c1 * Math.exp(x_9);
      // Inline function 'kotlin.math.exp' call
      var x_10 = r2 * x_8;
      var tmp_5 = tmp_4 + c2 * Math.exp(x_10) + signedDelta;
      var tmp_6 = c1 * r1;
      // Inline function 'kotlin.math.exp' call
      var x_11 = r1 * x_8;
      var tmp_7 = tmp_6 * Math.exp(x_11);
      var tmp_8 = c2 * r2;
      // Inline function 'kotlin.math.exp' call
      var x_12 = r2 * x_8;
      tCurr = x_8 - tmp_5 / (tmp_7 + tmp_8 * Math.exp(x_12));
      // Inline function 'kotlin.math.abs' call
      var x_13 = tLast - tCurr;
      tDelta = Math.abs(x_13);
    }
    return tCurr;
  }
  function estimateUnderDamped(firstRootReal, firstRootImaginary, p0, v0, delta) {
    var r = firstRootReal;
    var c1 = p0;
    var c2 = (v0 - r * c1) / firstRootImaginary;
    // Inline function 'kotlin.math.sqrt' call
    var x = c1 * c1 + c2 * c2;
    var c = Math.sqrt(x);
    // Inline function 'kotlin.math.ln' call
    var x_0 = delta / c;
    return Math.log(x_0) / r;
  }
  function estimateCriticallyDamped(firstRootReal, p0, v0, delta) {
    var r = firstRootReal;
    var c1 = p0;
    var c2 = v0 - r * c1;
    // Inline function 'kotlin.math.abs' call
    var x = delta / c1;
    // Inline function 'kotlin.math.ln' call
    var x_0 = Math.abs(x);
    var t1 = Math.log(x_0) / r;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.math.abs' call
    var x_1 = delta / c2;
    // Inline function 'kotlin.math.ln' call
    var x_2 = Math.abs(x_1);
    var guess = Math.log(x_2);
    var t = guess;
    var inductionVariable = 0;
    if (inductionVariable <= 5)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.math.abs' call
        var x_3 = t / r;
        // Inline function 'kotlin.math.ln' call
        var x_4 = Math.abs(x_3);
        t = guess - Math.log(x_4);
      }
       while (inductionVariable <= 5);
    var t2 = t / r;
    var tmp;
    // Inline function 'androidx.compose.animation.core.isNotFinite' call
    // Inline function 'androidx.compose.ui.util.fastIsFinite' call
    if (!(compare(bitwiseAnd(toRawBits(t1), new Long(-1, 2147483647)), new Long(0, 2146435072)) < 0)) {
      tmp = t2;
    } else {
      // Inline function 'androidx.compose.animation.core.isNotFinite' call
      // Inline function 'androidx.compose.ui.util.fastIsFinite' call
      if (!(compare(bitwiseAnd(toRawBits(t2), new Long(-1, 2147483647)), new Long(0, 2146435072)) < 0)) {
        tmp = t1;
      } else {
        // Inline function 'kotlin.math.max' call
        tmp = Math.max(t1, t2);
      }
    }
    var tCurr = tmp;
    var tInflection = -(r * c1 + c2) / (r * c2);
    // Inline function 'kotlin.math.exp' call
    var x_5 = r * tInflection;
    var tmp_0 = c1 * Math.exp(x_5);
    var tmp_1 = c2 * tInflection;
    // Inline function 'kotlin.math.exp' call
    var x_6 = r * tInflection;
    var xInflection = tmp_0 + tmp_1 * Math.exp(x_6);
    var tmp_2;
    if (isNaN_1(tInflection) || tInflection <= 0.0) {
      tmp_2 = -delta;
    } else if (tInflection > 0.0 && -xInflection < delta) {
      if (c2 < 0 && c1 > 0) {
        tCurr = 0.0;
      }
      tmp_2 = -delta;
    } else {
      tCurr = -(2.0 / r) - c1 / c2;
      tmp_2 = delta;
    }
    var signedDelta = tmp_2;
    var tDelta = 1.7976931348623157E308;
    var iterations = 0;
    while (tDelta > 0.001 && iterations < 100) {
      iterations = iterations + 1 | 0;
      var tLast = tCurr;
      // Inline function 'androidx.compose.animation.core.iterateNewtonsMethod' call
      var x_7 = tCurr;
      var tmp_3 = c1 + c2 * x_7;
      // Inline function 'kotlin.math.exp' call
      var x_8 = r * x_7;
      var tmp_4 = tmp_3 * Math.exp(x_8) + signedDelta;
      var tmp_5 = c2 * (r * x_7 + 1) + c1 * r;
      // Inline function 'kotlin.math.exp' call
      var x_9 = r * x_7;
      tCurr = x_7 - tmp_4 / (tmp_5 * Math.exp(x_9));
      // Inline function 'kotlin.math.abs' call
      var x_10 = tLast - tCurr;
      tDelta = Math.abs(x_10);
    }
    return tCurr;
  }
  function estimateOverDamped$xInflection(c1, r1, tInflection, c2, r2) {
    // Inline function 'kotlin.math.exp' call
    var x = r1 * tInflection;
    var tmp = c1 * Math.exp(x);
    // Inline function 'kotlin.math.exp' call
    var x_0 = r2 * tInflection;
    return tmp + c2 * Math.exp(x_0);
  }
  var androidx_compose_animation_core_SpringSimulation$stable;
  function SpringSimulation(finalPosition) {
    this.gej_1 = finalPosition;
    var tmp = this;
    // Inline function 'kotlin.math.sqrt' call
    tmp.hej_1 = Math.sqrt(50.0);
    this.iej_1 = 1.0;
  }
  protoOf(SpringSimulation).kej = function (value) {
    if (this.mej() <= 0) {
      throwIllegalArgumentException('Spring stiffness constant must be positive.');
    }
    var tmp = this;
    // Inline function 'kotlin.math.sqrt' call
    tmp.hej_1 = Math.sqrt(value);
  };
  protoOf(SpringSimulation).mej = function () {
    return this.hej_1 * this.hej_1;
  };
  protoOf(SpringSimulation).jej = function (value) {
    if (value < 0) {
      throwIllegalArgumentException('Damping ratio must be non-negative');
    }
    this.iej_1 = value;
  };
  protoOf(SpringSimulation).lej = function (lastDisplacement, lastVelocity, timeElapsed) {
    var adjustedDisplacement = lastDisplacement - this.gej_1;
    // Inline function 'kotlin.Long.div' call
    var deltaT = toNumber(timeElapsed) / 1000.0;
    var dampingRatioSquared = this.iej_1 * this.iej_1;
    var r = -this.iej_1 * this.hej_1;
    var displacement;
    var currentVelocity;
    if (this.iej_1 > 1) {
      var tmp = this.hej_1;
      // Inline function 'kotlin.math.sqrt' call
      var x = dampingRatioSquared - 1;
      var s = tmp * Math.sqrt(x);
      var gammaPlus = r + s;
      var gammaMinus = r - s;
      var coeffB = (gammaMinus * adjustedDisplacement - lastVelocity) / (gammaMinus - gammaPlus);
      var coeffA = adjustedDisplacement - coeffB;
      // Inline function 'kotlin.math.exp' call
      var x_0 = gammaMinus * deltaT;
      var tmp_0 = coeffA * Math.exp(x_0);
      // Inline function 'kotlin.math.exp' call
      var x_1 = gammaPlus * deltaT;
      displacement = tmp_0 + coeffB * Math.exp(x_1);
      var tmp_1 = coeffA * gammaMinus;
      // Inline function 'kotlin.math.exp' call
      var x_2 = gammaMinus * deltaT;
      var tmp_2 = tmp_1 * Math.exp(x_2);
      var tmp_3 = coeffB * gammaPlus;
      // Inline function 'kotlin.math.exp' call
      var x_3 = gammaPlus * deltaT;
      currentVelocity = tmp_2 + tmp_3 * Math.exp(x_3);
    } else if (this.iej_1 === 1.0) {
      var coeffA_0 = adjustedDisplacement;
      var coeffB_0 = lastVelocity + this.hej_1 * adjustedDisplacement;
      var nFdT = -this.hej_1 * deltaT;
      var tmp_4 = coeffA_0 + coeffB_0 * deltaT;
      // Inline function 'kotlin.math.exp' call
      displacement = tmp_4 * Math.exp(nFdT);
      var tmp_5 = coeffA_0 + coeffB_0 * deltaT;
      // Inline function 'kotlin.math.exp' call
      var tmp_6 = tmp_5 * Math.exp(nFdT) * -this.hej_1;
      // Inline function 'kotlin.math.exp' call
      currentVelocity = tmp_6 + coeffB_0 * Math.exp(nFdT);
    } else {
      var tmp_7 = this.hej_1;
      // Inline function 'kotlin.math.sqrt' call
      var x_4 = 1 - dampingRatioSquared;
      var dampedFreq = tmp_7 * Math.sqrt(x_4);
      var cosCoeff = adjustedDisplacement;
      var sinCoeff = 1 / dampedFreq * (-r * adjustedDisplacement + lastVelocity);
      var dFdT = dampedFreq * deltaT;
      // Inline function 'kotlin.math.exp' call
      var x_5 = r * deltaT;
      var tmp_8 = Math.exp(x_5);
      // Inline function 'kotlin.math.cos' call
      var tmp_9 = cosCoeff * Math.cos(dFdT);
      // Inline function 'kotlin.math.sin' call
      displacement = tmp_8 * (tmp_9 + sinCoeff * Math.sin(dFdT));
      var tmp_10 = displacement * r;
      // Inline function 'kotlin.math.exp' call
      var x_6 = r * deltaT;
      var tmp_11 = Math.exp(x_6);
      var tmp_12 = -dampedFreq * cosCoeff;
      // Inline function 'kotlin.math.sin' call
      var tmp_13 = tmp_12 * Math.sin(dFdT);
      var tmp_14 = dampedFreq * sinCoeff;
      // Inline function 'kotlin.math.cos' call
      currentVelocity = tmp_10 + tmp_11 * (tmp_13 + tmp_14 * Math.cos(dFdT));
    }
    var newValue = displacement + this.gej_1;
    var newVelocity = currentVelocity;
    // Inline function 'androidx.compose.animation.core.Motion' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits_0(newValue));
    var v2 = fromInt(toRawBits_0(newVelocity));
    var tmp$ret$17 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Motion___init__impl__vk56rv(tmp$ret$17);
  };
  function _Motion___init__impl__vk56rv(packedValue) {
    return packedValue;
  }
  function _Motion___get_packedValue__impl__qymh4n($this) {
    return $this;
  }
  function animate(initialValue, targetValue, initialVelocity, animationSpec, block, $completion) {
    initialVelocity = initialVelocity === VOID ? 0.0 : initialVelocity;
    animationSpec = animationSpec === VOID ? spring() : animationSpec;
    return animate_1(get_VectorConverter(FloatCompanionObject_instance), initialValue, targetValue, initialVelocity, animationSpec, block, $completion);
  }
  function animateDecay(_this__u8e3s4, animationSpec, sequentialAnimation, block, $completion) {
    sequentialAnimation = sequentialAnimation === VOID ? false : sequentialAnimation;
    var tmp;
    if (block === VOID) {
      tmp = animateDecay$lambda;
    } else {
      tmp = block;
    }
    block = tmp;
    var tmp0_initialValue = _this__u8e3s4.u1();
    var tmp1_initialVelocityVector = _this__u8e3s4.cea_1;
    var tmp2_typeConverter = _this__u8e3s4.aea_1;
    var anim = DecayAnimation_init_$Create$(animationSpec, tmp2_typeConverter, tmp0_initialValue, tmp1_initialVelocityVector);
    return animate_0(_this__u8e3s4, anim, sequentialAnimation ? _this__u8e3s4.dea_1 : new Long(0, -2147483648), block, $completion);
  }
  function animateTo(_this__u8e3s4, targetValue, animationSpec, sequentialAnimation, block, $completion) {
    animationSpec = animationSpec === VOID ? spring() : animationSpec;
    sequentialAnimation = sequentialAnimation === VOID ? false : sequentialAnimation;
    var tmp;
    if (block === VOID) {
      tmp = animateTo$lambda;
    } else {
      tmp = block;
    }
    block = tmp;
    var tmp0_initialValue = _this__u8e3s4.u1();
    var tmp1_typeConverter = _this__u8e3s4.aea_1;
    var tmp2_initialVelocityVector = _this__u8e3s4.cea_1;
    var anim = TargetBasedAnimation_init_$Create$(animationSpec, tmp1_typeConverter, tmp0_initialValue, targetValue, tmp2_initialVelocityVector);
    return animate_0(_this__u8e3s4, anim, sequentialAnimation ? _this__u8e3s4.dea_1 : new Long(0, -2147483648), block, $completion);
  }
  function animate_0(_this__u8e3s4, animation, startTimeNanos, block, $completion) {
    startTimeNanos = startTimeNanos === VOID ? new Long(0, -2147483648) : startTimeNanos;
    var tmp;
    if (block === VOID) {
      tmp = animate$lambda;
    } else {
      tmp = block;
    }
    block = tmp;
    var tmp_0 = new $animateCOROUTINE$(_this__u8e3s4, animation, startTimeNanos, block, $completion);
    tmp_0.p9_1 = Unit_instance;
    tmp_0.q9_1 = null;
    return tmp_0.v9();
  }
  function updateState(_this__u8e3s4, state) {
    state.gea(_this__u8e3s4.u1());
    copyFrom(state.cea_1, _this__u8e3s4.we9_1);
    state.eea_1 = _this__u8e3s4.ye9_1;
    state.dea_1 = _this__u8e3s4.xe9_1;
    state.fea_1 = _this__u8e3s4.rea();
  }
  function animate_1(typeConverter, initialValue, targetValue, initialVelocity, animationSpec, block, $completion) {
    initialVelocity = initialVelocity === VOID ? null : initialVelocity;
    animationSpec = animationSpec === VOID ? spring() : animationSpec;
    var tmp;
    if (initialVelocity == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = typeConverter.lea()(initialVelocity);
    }
    var tmp1_elvis_lhs = tmp;
    var initialVelocityVector = tmp1_elvis_lhs == null ? newInstance(typeConverter.lea()(initialValue)) : tmp1_elvis_lhs;
    var anim = TargetBasedAnimation_init_$Create$(animationSpec, typeConverter, initialValue, targetValue, initialVelocityVector);
    var tmp_0 = new AnimationState(typeConverter, initialValue, initialVelocityVector);
    return animate_0(tmp_0, anim, VOID, animate$lambda_3(block, typeConverter), $completion);
  }
  function get_durationScale(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.aa(Key_instance_1);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r8w();
    var scale = tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs;
    // Inline function 'androidx.compose.animation.core.checkPrecondition' call
    if (!(scale >= 0.0)) {
      var tmp$ret$1 = 'negative scale factor';
      throwIllegalStateException(tmp$ret$1);
    }
    return scale;
  }
  function callWithFrameNanos(_this__u8e3s4, onFrame, $completion) {
    var tmp = new $callWithFrameNanosCOROUTINE$(_this__u8e3s4, onFrame, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function doAnimationFrameWithScale(_this__u8e3s4, frameTimeNanos, durationScale, anim, state, block) {
    var tmp;
    if (durationScale === 0.0) {
      tmp = anim.jee();
    } else {
      // Inline function 'kotlin.Long.div' call
      var this_0 = subtract(frameTimeNanos, _this__u8e3s4.te9_1);
      var tmp$ret$0 = toNumber(this_0) / durationScale;
      tmp = numberToLong(tmp$ret$0);
    }
    var playTimeNanos = tmp;
    doAnimationFrame(_this__u8e3s4, frameTimeNanos, playTimeNanos, anim, state, block);
  }
  function doAnimationFrame(_this__u8e3s4, frameTimeNanos, playTimeNanos, anim, state, block) {
    _this__u8e3s4.xe9_1 = frameTimeNanos;
    _this__u8e3s4.gea(anim.gee(playTimeNanos));
    _this__u8e3s4.we9_1 = anim.lee(playTimeNanos);
    var isLastFrame = anim.iee(playTimeNanos);
    if (isLastFrame) {
      _this__u8e3s4.ye9_1 = _this__u8e3s4.xe9_1;
      _this__u8e3s4.ieg(false);
    }
    updateState(_this__u8e3s4, state);
    block(_this__u8e3s4);
  }
  function animateDecay$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function animateTo$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function animate$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function animate$lambda$lambda($this_animate) {
    return function () {
      $this_animate.fea_1 = false;
      return Unit_instance;
    };
  }
  function animate$lambda_0($lateInitScope, $initialValue, $animation, $initialVelocityVector, $durationScale, $this_animate, $block) {
    return function (it) {
      var tmp = $animation.bee();
      var tmp_0 = $animation.sea();
      // Inline function 'kotlin.apply' call
      var this_0 = new AnimationScope($initialValue, tmp, $initialVelocityVector, it, tmp_0, it, true, animate$lambda$lambda($this_animate));
      doAnimationFrameWithScale(this_0, it, $durationScale, $animation, $this_animate, $block);
      $lateInitScope._v = this_0;
      return Unit_instance;
    };
  }
  function animate$lambda_1($this_animate) {
    return function () {
      $this_animate.fea_1 = false;
      return Unit_instance;
    };
  }
  function animate$lambda_2($lateInitScope, $durationScale, $animation, $this_animate, $block) {
    return function (it) {
      doAnimationFrameWithScale(ensureNotNull($lateInitScope._v), it, $durationScale, $animation, $this_animate, $block);
      return Unit_instance;
    };
  }
  function animate$lambda_3($block, $typeConverter) {
    return function ($this$animate) {
      $block($this$animate.u1(), $typeConverter.pea()($this$animate.we9_1));
      return Unit_instance;
    };
  }
  function callWithFrameNanos$lambda($onFrame) {
    return function (it) {
      // Inline function 'kotlin.Long.div' call
      var tmp$ret$0 = divide(it, fromInt(1));
      return $onFrame(tmp$ret$0);
    };
  }
  function $animateCOROUTINE$(_this__u8e3s4, animation, startTimeNanos, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ien_1 = _this__u8e3s4;
    this.jen_1 = animation;
    this.ken_1 = startTimeNanos;
    this.len_1 = block;
  }
  protoOf($animateCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            var initialValue = this.jen_1.gee(new Long(0, 0));
            var initialVelocityVector = this.jen_1.lee(new Long(0, 0));
            this.men_1 = {_v: null};
            this.o9_1 = 7;
            if (equalsLong(this.ken_1, new Long(0, -2147483648))) {
              var durationScale = get_durationScale(this.t9());
              this.n9_1 = 1;
              suspendResult = callWithFrameNanos(this.jen_1, animate$lambda_0(this.men_1, initialValue, this.jen_1, initialVelocityVector, durationScale, this.ien_1, this.len_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_0 = this.jen_1.bee();
              var tmp_1 = this.jen_1.sea();
              var this_0 = new AnimationScope(initialValue, tmp_0, initialVelocityVector, this.ken_1, tmp_1, this.ken_1, true, animate$lambda_1(this.ien_1));
              doAnimationFrameWithScale(this_0, this.ken_1, get_durationScale(this.t9()), this.jen_1, this.ien_1, this.len_1);
              this.men_1._v = this_0;
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            if (!ensureNotNull(this.men_1._v).rea()) {
              this.n9_1 = 5;
              continue $sm;
            }

            var durationScale_0 = get_durationScale(this.t9());
            this.n9_1 = 4;
            suspendResult = callWithFrameNanos(this.jen_1, animate$lambda_2(this.men_1, durationScale_0, this.jen_1, this.ien_1, this.len_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.n9_1 = 3;
            continue $sm;
          case 5:
            this.o9_1 = 8;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.o9_1 = 8;
            return Unit_instance;
          case 7:
            this.o9_1 = 8;
            var tmp_2 = this.q9_1;
            if (tmp_2 instanceof CancellationException) {
              var e = this.q9_1;
              var tmp0_safe_receiver = this.men_1._v;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.ieg(false);
              }
              var tmp1_safe_receiver = this.men_1._v;
              if (equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.xe9_1, this.ien_1.dea_1)) {
                this.ien_1.fea_1 = false;
              }
              throw e;
            } else {
              throw this.q9_1;
            }

          case 8:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 8) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $callWithFrameNanosCOROUTINE$(_this__u8e3s4, onFrame, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ven_1 = _this__u8e3s4;
    this.wen_1 = onFrame;
  }
  protoOf($callWithFrameNanosCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            if (this.ven_1.fee()) {
              this.n9_1 = 2;
              suspendResult = withInfiniteAnimationFrameNanos(this.wen_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = withFrameNanos(callWithFrameNanos$lambda(this.wen_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.xen_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.xen_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return this.xen_1;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function get_SeekableTransitionStateTotalDurationChanged() {
    _init_properties_Transition_kt__s6zoln();
    return SeekableTransitionStateTotalDurationChanged;
  }
  var SeekableTransitionStateTotalDurationChanged;
  var androidx_compose_animation_core_TransitionState$stable;
  var androidx_compose_animation_core_MutableTransitionState$stable;
  var androidx_compose_animation_core_SeekableTransitionState_SeekingAnimationState$stable;
  var androidx_compose_animation_core_SeekableTransitionState$stable;
  var androidx_compose_animation_core_Transition$stable;
  function _set_targetValue__aqsk0r_0($this, _set____db54di) {
    var tmp0 = $this.aeo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$TransitionAnimationState$_get_targetValue_$ref_k2d87h();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('targetValue', 1, tmp, tmp_0, Transition$TransitionAnimationState$_set_targetValue_$ref_9yn0ox());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get_targetValue__jjlmb5($this) {
    var tmp0 = $this.aeo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$TransitionAnimationState$_get_targetValue_$ref_k2d87h();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('targetValue', 1, tmp, tmp_0, Transition$TransitionAnimationState$_set_targetValue_$ref_9yn0ox());
    return tmp0.u1();
  }
  function _set_animationSpec__7qdru($this, _set____db54di) {
    var tmp0 = $this.ceo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$TransitionAnimationState$_get_animationSpec_$ref_yvkiem();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('animationSpec', 1, tmp, tmp_0, Transition$TransitionAnimationState$_set_animationSpec_$ref_efqna6());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _set_animation__pan2kh($this, _set____db54di) {
    var tmp0 = $this.deo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$TransitionAnimationState$_get_animation_$ref_xmz6jb();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('animation', 1, tmp, tmp_0, Transition$TransitionAnimationState$_set_animation_$ref_if7o0z());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function updateAnimation($this, initialValue, isInterrupted) {
    initialValue = initialValue === VOID ? $this.u1() : initialValue;
    isInterrupted = isInterrupted === VOID ? false : isInterrupted;
    var tmp0_safe_receiver = $this.feo_1;
    if (equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sea(), _get_targetValue__jjlmb5($this))) {
      _set_animation__pan2kh($this, TargetBasedAnimation_init_$Create$($this.neo_1, $this.yen_1, initialValue, initialValue, newInstance($this.keo_1)));
      $this.ieo_1 = true;
      $this.qeo($this.peo().jee());
      return Unit_instance;
    }
    var tmp;
    if (isInterrupted && !$this.meo_1) {
      var tmp_0;
      var tmp_1 = $this.reo();
      if (tmp_1 instanceof SpringSpec) {
        tmp_0 = $this.reo();
      } else {
        tmp_0 = $this.neo_1;
      }
      tmp = tmp_0;
    } else {
      tmp = $this.reo();
    }
    var specWithoutDelay = tmp;
    var tmp_2;
    if (compare($this.oeo_1.fep(), new Long(0, 0)) <= 0) {
      tmp_2 = specWithoutDelay;
    } else {
      tmp_2 = delayed(specWithoutDelay, $this.oeo_1.fep());
    }
    var spec = tmp_2;
    _set_animation__pan2kh($this, TargetBasedAnimation_init_$Create$(spec, $this.yen_1, initialValue, _get_targetValue__jjlmb5($this), $this.keo_1));
    $this.qeo($this.peo().jee());
    $this.ieo_1 = false;
    onChildAnimationUpdated($this.oeo_1);
  }
  function Transition$TransitionAnimationState$_get_targetValue_$ref_k2d87h() {
    return constructCallableReference(function (p0) {
      return _get_targetValue__jjlmb5(p0);
    }, 1, 0, 189);
  }
  function Transition$TransitionAnimationState$_set_targetValue_$ref_9yn0ox() {
    return constructCallableReference(function (p0, p1) {
      _set_targetValue__aqsk0r_0(p0, p1);
      return Unit_instance;
    }, 2, 0, 190);
  }
  function Transition$TransitionAnimationState$_get_animationSpec_$ref_yvkiem() {
    return constructCallableReference(function (p0) {
      return p0.reo();
    }, 1, 0, 191);
  }
  function Transition$TransitionAnimationState$_set_animationSpec_$ref_efqna6() {
    return constructCallableReference(function (p0, p1) {
      _set_animationSpec__7qdru(p0, p1);
      return Unit_instance;
    }, 2, 0, 192);
  }
  function Transition$TransitionAnimationState$_get_animation_$ref_xmz6jb() {
    return constructCallableReference(function (p0) {
      return p0.peo();
    }, 1, 0, 193);
  }
  function Transition$TransitionAnimationState$_set_animation_$ref_if7o0z() {
    return constructCallableReference(function (p0, p1) {
      _set_animation__pan2kh(p0, p1);
      return Unit_instance;
    }, 2, 0, 194);
  }
  function Transition$TransitionAnimationState$_get_isFinished_$ref_fvu6sx() {
    return constructCallableReference(function (p0) {
      return p0.gep();
    }, 1, 0, 195);
  }
  function Transition$TransitionAnimationState$_set_isFinished_$ref_9n998j() {
    return constructCallableReference(function (p0, p1) {
      p0.hep(p1);
      return Unit_instance;
    }, 2, 0, 196);
  }
  function Transition$TransitionAnimationState$_get_resetSnapValue_$ref_1qtvjp() {
    return constructCallableReference(function (p0) {
      return p0.iep();
    }, 1, 0, 197);
  }
  function Transition$TransitionAnimationState$_set_resetSnapValue_$ref_zcevb3() {
    return constructCallableReference(function (p0, p1) {
      p0.jep(p1);
      return Unit_instance;
    }, 2, 0, 198);
  }
  function Transition$TransitionAnimationState$_get_value_$ref_sfag84() {
    return constructCallableReference(function (p0) {
      return p0.u1();
    }, 1, 0, 199);
  }
  function Transition$TransitionAnimationState$_set_value_$ref_daz5cg() {
    return constructCallableReference(function (p0, p1) {
      p0.gea(p1);
      return Unit_instance;
    }, 2, 0, 200);
  }
  function Transition$TransitionAnimationState$_get_durationNanos_$ref_gmcx6m() {
    return constructCallableReference(function (p0) {
      return p0.kep();
    }, 1, 0, 201);
  }
  function Transition$TransitionAnimationState$_set_durationNanos_$ref_53fz3q() {
    return constructCallableReference(function (p0, p1) {
      p0.qeo(p1);
      return Unit_instance;
    }, 2, 0, 202);
  }
  function DeferredAnimationData($outer, animation, transitionSpec, targetValueByState) {
    this.oep_1 = $outer;
    this.lep_1 = animation;
    this.mep_1 = transitionSpec;
    this.nep_1 = targetValueByState;
  }
  protoOf(DeferredAnimationData).pep = function (segment) {
    var targetValue = this.nep_1(segment.o70());
    if (this.oep_1.wep_1.xep()) {
      var initialValue = this.nep_1(segment.rep());
      this.lep_1.sep(initialValue, targetValue, this.mep_1(segment));
    } else {
      this.lep_1.qep(targetValue, this.mep_1(segment));
    }
  };
  protoOf(DeferredAnimationData).u1 = function () {
    this.pep(this.oep_1.wep_1.yep());
    return this.lep_1.u1();
  };
  function Transition$DeferredAnimation$_get_data_$ref_yf6va6() {
    return constructCallableReference(function (p0) {
      return p0.zep();
    }, 1, 0, 203);
  }
  function Transition$DeferredAnimation$_set_data_$ref_nt0v86() {
    return constructCallableReference(function (p0, p1) {
      p0.aeq(p1);
      return Unit_instance;
    }, 2, 0, 204);
  }
  function Transition$animateTo$lambda$slambda$lambda(this$0, $durationScale) {
    return function (it) {
      var tmp;
      if (!this$0.xep()) {
        // Inline function 'kotlin.Long.div' call
        var tmp$ret$0 = divide(it, fromInt(1));
        this$0.beq(tmp$ret$0, $durationScale);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function Transition_init_$Init$(transitionState, label, $this) {
    label = label === VOID ? null : label;
    Transition.call($this, transitionState, null, label);
    return $this;
  }
  function Transition_init_$Create$(transitionState, label) {
    return Transition_init_$Init$(transitionState, label, objectCreate(protoOf(Transition)));
  }
  function Transition_init_$Init$_0(initialState, label, $this) {
    Transition.call($this, new MutableTransitionState(initialState), null, label);
    return $this;
  }
  function Transition_init_$Create$_0(initialState, label) {
    return Transition_init_$Init$_0(initialState, label, objectCreate(protoOf(Transition)));
  }
  function _set_segment__77iylu($this, _set____db54di) {
    var tmp0 = $this.weo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$_get_segment_$ref_hll1ky();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('segment', 1, tmp, tmp_0, Transition$_set_segment_$ref_n54u2a());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _set__playTimeNanos__8elh7c($this, _set____db54di) {
    var tmp0 = $this.xeo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$_get__playTimeNanos_$ref_dkmemi();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('_playTimeNanos', 1, tmp, tmp_0, Transition$_set__playTimeNanos_$ref_nimc8a());
    tmp0.i49(_set____db54di);
    return Unit_instance;
  }
  function _get__playTimeNanos__xxox8s($this) {
    var tmp0 = $this.xeo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$_get__playTimeNanos_$ref_dkmemi();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('_playTimeNanos', 1, tmp, tmp_0, Transition$_set__playTimeNanos_$ref_nimc8a());
    return tmp0.j49();
  }
  function _set_updateChildrenNeeded__eksjzu($this, _set____db54di) {
    var tmp0 = $this.zeo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$_get_updateChildrenNeeded_$ref_m1jdik();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('updateChildrenNeeded', 1, tmp, tmp_0, Transition$_set_updateChildrenNeeded_$ref_hj65vc());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get_updateChildrenNeeded__mpvzi($this) {
    var tmp0 = $this.zeo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$_get_updateChildrenNeeded_$ref_m1jdik();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('updateChildrenNeeded', 1, tmp, tmp_0, Transition$_set_updateChildrenNeeded_$ref_hj65vc());
    return tmp0.u1();
  }
  function calculateTotalDurationNanos($this) {
    var maxDurationNanos = new Long(0, 0);
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = $this.aep_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        var tmp0 = maxDurationNanos;
        // Inline function 'kotlin.math.max' call
        var b = item.kep();
        maxDurationNanos = compare(tmp0, b) >= 0 ? tmp0 : b;
      }
       while (inductionVariable <= last);
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_1 = $this.bep_1;
    var inductionVariable_0 = 0;
    var last_0 = this_1.n1() - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item_0 = this_1.l1(index_0);
        var tmp0_0 = maxDurationNanos;
        // Inline function 'kotlin.math.max' call
        var b_0 = calculateTotalDurationNanos(item_0);
        maxDurationNanos = compare(tmp0_0, b_0) >= 0 ? tmp0_0 : b_0;
      }
       while (inductionVariable_0 <= last_0);
    return maxDurationNanos;
  }
  function onChildAnimationUpdated($this) {
    _set_updateChildrenNeeded__eksjzu($this, true);
    if ($this.xep()) {
      var maxDurationNanos = new Long(0, 0);
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = $this.aep_1;
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          var tmp0 = maxDurationNanos;
          // Inline function 'kotlin.math.max' call
          var b = item.kep();
          maxDurationNanos = compare(tmp0, b) >= 0 ? tmp0 : b;
          item.ceq($this.dep_1);
        }
         while (inductionVariable <= last);
      _set_updateChildrenNeeded__eksjzu($this, false);
    }
  }
  function TransitionAnimationState_0($outer, initialValue, initialVelocityVector, typeConverter, label) {
    this.oeo_1 = $outer;
    this.yen_1 = typeConverter;
    this.zen_1 = label;
    this.aeo_1 = mutableStateOf(initialValue);
    this.beo_1 = spring();
    this.ceo_1 = mutableStateOf(this.beo_1);
    this.deo_1 = mutableStateOf(TargetBasedAnimation_init_$Create$(this.reo(), this.yen_1, initialValue, _get_targetValue__jjlmb5(this), initialVelocityVector));
    this.eeo_1 = null;
    this.feo_1 = null;
    this.geo_1 = mutableStateOf(true);
    this.heo_1 = mutableFloatStateOf(-1.0);
    this.ieo_1 = false;
    this.jeo_1 = mutableStateOf(initialValue);
    this.keo_1 = initialVelocityVector;
    this.leo_1 = mutableLongStateOf(this.peo().jee());
    this.meo_1 = false;
    var tmp0_safe_receiver = get_VisibilityThresholdMap().w2(this.yen_1);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var vector = this.yen_1.lea()(initialValue);
      var inductionVariable = 0;
      var last = vector.mea();
      if (inductionVariable < last)
        do {
          var id = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          vector.oea(id, tmp0_safe_receiver);
        }
         while (inductionVariable < last);
      tmp = this.yen_1.pea()(vector);
    }
    var visibilityThreshold = tmp;
    this.neo_1 = spring(VOID, VOID, visibilityThreshold);
  }
  protoOf(TransitionAnimationState_0).reo = function () {
    var tmp0 = this.ceo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$TransitionAnimationState$_get_animationSpec_$ref_yvkiem();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('animationSpec', 1, tmp, tmp_0, Transition$TransitionAnimationState$_set_animationSpec_$ref_efqna6());
    return tmp0.u1();
  };
  protoOf(TransitionAnimationState_0).peo = function () {
    var tmp0 = this.deo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$TransitionAnimationState$_get_animation_$ref_xmz6jb();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('animation', 1, tmp, tmp_0, Transition$TransitionAnimationState$_set_animation_$ref_if7o0z());
    return tmp0.u1();
  };
  protoOf(TransitionAnimationState_0).hep = function (_set____db54di) {
    var tmp0 = this.geo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$TransitionAnimationState$_get_isFinished_$ref_fvu6sx();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('isFinished', 1, tmp, tmp_0, Transition$TransitionAnimationState$_set_isFinished_$ref_9n998j());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(TransitionAnimationState_0).gep = function () {
    var tmp0 = this.geo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$TransitionAnimationState$_get_isFinished_$ref_fvu6sx();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('isFinished', 1, tmp, tmp_0, Transition$TransitionAnimationState$_set_isFinished_$ref_9n998j());
    return tmp0.u1();
  };
  protoOf(TransitionAnimationState_0).jep = function (_set____db54di) {
    var tmp0 = this.heo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$TransitionAnimationState$_get_resetSnapValue_$ref_1qtvjp();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('resetSnapValue', 1, tmp, tmp_0, Transition$TransitionAnimationState$_set_resetSnapValue_$ref_zcevb3());
    tmp0.i45(_set____db54di);
    return Unit_instance;
  };
  protoOf(TransitionAnimationState_0).iep = function () {
    var tmp0 = this.heo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$TransitionAnimationState$_get_resetSnapValue_$ref_1qtvjp();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('resetSnapValue', 1, tmp, tmp_0, Transition$TransitionAnimationState$_set_resetSnapValue_$ref_zcevb3());
    return tmp0.j45();
  };
  protoOf(TransitionAnimationState_0).gea = function (_set____db54di) {
    var tmp0 = this.jeo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$TransitionAnimationState$_get_value_$ref_sfag84();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('value', 1, tmp, tmp_0, Transition$TransitionAnimationState$_set_value_$ref_daz5cg());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(TransitionAnimationState_0).u1 = function () {
    var tmp0 = this.jeo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$TransitionAnimationState$_get_value_$ref_sfag84();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('value', 1, tmp, tmp_0, Transition$TransitionAnimationState$_set_value_$ref_daz5cg());
    return tmp0.u1();
  };
  protoOf(TransitionAnimationState_0).qeo = function (_set____db54di) {
    var tmp0 = this.leo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$TransitionAnimationState$_get_durationNanos_$ref_gmcx6m();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('durationNanos', 1, tmp, tmp_0, Transition$TransitionAnimationState$_set_durationNanos_$ref_53fz3q());
    tmp0.i49(_set____db54di);
    return Unit_instance;
  };
  protoOf(TransitionAnimationState_0).kep = function () {
    var tmp0 = this.leo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$TransitionAnimationState$_get_durationNanos_$ref_gmcx6m();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('durationNanos', 1, tmp, tmp_0, Transition$TransitionAnimationState$_set_durationNanos_$ref_53fz3q());
    return tmp0.j49();
  };
  protoOf(TransitionAnimationState_0).deq = function (playTimeNanos, scaleToEnd) {
    var playTime = scaleToEnd ? this.peo().jee() : playTimeNanos;
    this.gea(this.peo().gee(playTime));
    this.keo_1 = this.peo().lee(playTime);
    if (this.peo().iee(playTime)) {
      this.hep(true);
    }
  };
  protoOf(TransitionAnimationState_0).ceq = function (playTimeNanos) {
    if (!(this.iep() === -1.0)) {
      return Unit_instance;
    }
    this.meo_1 = true;
    if (equals(this.peo().sea(), this.peo().eee())) {
      this.gea(this.peo().sea());
    } else {
      this.gea(this.peo().gee(playTimeNanos));
      this.keo_1 = this.peo().lee(playTimeNanos);
    }
  };
  protoOf(TransitionAnimationState_0).eeq = function () {
    var tmp0_elvis_lhs = this.eeo_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var animState = tmp;
    var tmp1_elvis_lhs = this.feo_1;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var animation = tmp_0;
    var tmp0 = animState.leq_1;
    // Inline function 'kotlin.Long.times' call
    var other = animState.ieq_1;
    var tmp$ret$0 = toNumber(tmp0) * other;
    var initialPlayTimeNanos = roundToLong(tmp$ret$0);
    var initialValue = animation.gee(initialPlayTimeNanos);
    if (this.ieo_1) {
      this.peo().cee(initialValue);
    }
    this.peo().dee(initialValue);
    this.qeo(this.peo().jee());
    if (this.iep() === -2.0 || this.ieo_1) {
      this.gea(initialValue);
    } else {
      this.ceq(this.oeo_1.fep());
    }
    if (compare(initialPlayTimeNanos, animState.leq_1) >= 0) {
      this.eeo_1 = null;
      this.feo_1 = null;
    } else {
      animState.heq_1 = false;
    }
  };
  protoOf(TransitionAnimationState_0).neq = function () {
    this.jep(-2.0);
  };
  protoOf(TransitionAnimationState_0).oeq = function (fraction) {
    switch (fraction) {
      case -4.0:
      case -5.0:
        var initAnim = this.feo_1;
        if (!(initAnim == null)) {
          this.peo().dee(initAnim.sea());
          this.eeo_1 = null;
          this.feo_1 = null;
        }

        var tmp;
        if (fraction === -4.0) {
          tmp = this.peo().eee();
        } else {
          tmp = this.peo().sea();
        }

        var animationValue = tmp;
        this.peo().dee(animationValue);
        this.peo().cee(animationValue);
        this.gea(animationValue);
        this.qeo(this.peo().jee());
        break;
      default:
        this.jep(fraction);
        break;
    }
  };
  protoOf(TransitionAnimationState_0).peq = function (animationState) {
    if (!equals(this.peo().sea(), this.peo().eee())) {
      this.feo_1 = this.peo();
      this.eeo_1 = animationState;
    }
    _set_animation__pan2kh(this, TargetBasedAnimation_init_$Create$(this.neo_1, this.yen_1, this.u1(), this.u1(), newInstance(this.keo_1)));
    this.qeo(this.peo().jee());
    this.ieo_1 = true;
  };
  protoOf(TransitionAnimationState_0).qeq = function () {
    this.feo_1 = null;
    this.eeo_1 = null;
    this.ieo_1 = false;
  };
  protoOf(TransitionAnimationState_0).toString = function () {
    return 'current value: ' + toString_0(this.u1()) + ', target: ' + toString_0(_get_targetValue__jjlmb5(this)) + ', spec: ' + toString(this.reo());
  };
  protoOf(TransitionAnimationState_0).qep = function (targetValue, animationSpec) {
    var tmp;
    if (this.ieo_1) {
      var tmp0_safe_receiver = this.feo_1;
      tmp = equals(targetValue, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sea());
    } else {
      tmp = false;
    }
    if (tmp) {
      return Unit_instance;
    }
    if (equals(_get_targetValue__jjlmb5(this), targetValue) && this.iep() === -1.0) {
      return Unit_instance;
    }
    _set_targetValue__aqsk0r_0(this, targetValue);
    _set_animationSpec__7qdru(this, animationSpec);
    var initialValue = this.iep() === -3.0 ? targetValue : this.u1();
    updateAnimation(this, initialValue, !this.gep());
    this.hep(this.iep() === -3.0);
    if (this.iep() >= 0.0) {
      var duration = this.peo().jee();
      var tmp_0 = this.peo();
      // Inline function 'kotlin.Long.times' call
      var other = this.iep();
      var tmp$ret$0 = toNumber(duration) * other;
      this.gea(tmp_0.gee(numberToLong(tmp$ret$0)));
    } else if (this.iep() === -3.0) {
      this.gea(targetValue);
    }
    this.ieo_1 = false;
    this.jep(-1.0);
  };
  protoOf(TransitionAnimationState_0).sep = function (initialValue, targetValue, animationSpec) {
    _set_targetValue__aqsk0r_0(this, targetValue);
    _set_animationSpec__7qdru(this, animationSpec);
    if (equals(this.peo().eee(), initialValue) && equals(this.peo().sea(), targetValue)) {
      return Unit_instance;
    }
    updateAnimation(this, initialValue);
  };
  function SegmentImpl(initialState, targetState) {
    this.req_1 = initialState;
    this.seq_1 = targetState;
  }
  protoOf(SegmentImpl).rep = function () {
    return this.req_1;
  };
  protoOf(SegmentImpl).o70 = function () {
    return this.seq_1;
  };
  protoOf(SegmentImpl).equals = function (other) {
    var tmp;
    var tmp_0;
    if (!(other == null) ? isInterface(other, Segment) : false) {
      tmp_0 = equals(this.req_1, other.rep());
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.seq_1, other.o70());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SegmentImpl).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.req_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(tmp$ret$0, 31);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = this.seq_1;
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    return tmp + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
  };
  function Segment() {
  }
  function DeferredAnimation($outer, typeConverter, label) {
    this.wep_1 = $outer;
    this.tep_1 = typeConverter;
    this.uep_1 = label;
    this.vep_1 = mutableStateOf(null);
  }
  protoOf(DeferredAnimation).aeq = function (_set____db54di) {
    var tmp0 = this.vep_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$DeferredAnimation$_get_data_$ref_yf6va6();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('data', 1, tmp, tmp_0, Transition$DeferredAnimation$_set_data_$ref_nt0v86());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(DeferredAnimation).zep = function () {
    var tmp0 = this.vep_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$DeferredAnimation$_get_data_$ref_yf6va6();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('data', 1, tmp, tmp_0, Transition$DeferredAnimation$_set_data_$ref_nt0v86());
    return tmp0.u1();
  };
  protoOf(DeferredAnimation).ueq = function (transitionSpec, targetValueByState) {
    var tmp0_elvis_lhs = this.zep();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.apply' call
      var this_0 = new DeferredAnimationData(this, new TransitionAnimationState_0(this.wep_1, targetValueByState(this.wep_1.v70()), createZeroVectorFrom(this.tep_1, targetValueByState(this.wep_1.v70())), this.tep_1, this.uep_1), transitionSpec, targetValueByState);
      this.aeq(this_0);
      this.wep_1.veq(this_0.lep_1);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var animData = tmp;
    // Inline function 'kotlin.apply' call
    animData.nep_1 = targetValueByState;
    animData.mep_1 = transitionSpec;
    animData.pep(this.wep_1.yep());
    return animData;
  };
  protoOf(DeferredAnimation).weq = function () {
    var tmp0_safe_receiver = this.zep();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.apply' call
      tmp0_safe_receiver.lep_1.sep(tmp0_safe_receiver.nep_1(this.wep_1.yep().rep()), tmp0_safe_receiver.nep_1(this.wep_1.yep().o70()), tmp0_safe_receiver.mep_1(this.wep_1.yep()));
    }
  };
  function Transition$_get_targetState_$ref_4jc5u9() {
    return constructCallableReference(function (p0) {
      return p0.o70();
    }, 1, 0, 205);
  }
  function Transition$_set_targetState_$ref_5ke1ob() {
    return constructCallableReference(function (p0, p1) {
      p0.xeq(p1);
      return Unit_instance;
    }, 2, 0, 206);
  }
  function Transition$_get_segment_$ref_hll1ky() {
    return constructCallableReference(function (p0) {
      return p0.yep();
    }, 1, 0, 207);
  }
  function Transition$_set_segment_$ref_n54u2a() {
    return constructCallableReference(function (p0, p1) {
      _set_segment__77iylu(p0, p1);
      return Unit_instance;
    }, 2, 0, 208);
  }
  function Transition$_get__playTimeNanos_$ref_dkmemi() {
    return constructCallableReference(function (p0) {
      return _get__playTimeNanos__xxox8s(p0);
    }, 1, 0, 209);
  }
  function Transition$_set__playTimeNanos_$ref_nimc8a() {
    return constructCallableReference(function (p0, p1) {
      _set__playTimeNanos__8elh7c(p0, p1);
      return Unit_instance;
    }, 2, 0, 210);
  }
  function Transition$_get_startTimeNanos_$ref_69ueft() {
    return constructCallableReference(function (p0) {
      return p0.yeq();
    }, 1, 0, 211);
  }
  function Transition$_set_startTimeNanos_$ref_utecez() {
    return constructCallableReference(function (p0, p1) {
      p0.zeq(p1);
      return Unit_instance;
    }, 2, 0, 212);
  }
  function Transition$_get_updateChildrenNeeded_$ref_m1jdik() {
    return constructCallableReference(function (p0) {
      return _get_updateChildrenNeeded__mpvzi(p0);
    }, 1, 0, 213);
  }
  function Transition$_set_updateChildrenNeeded_$ref_hj65vc() {
    return constructCallableReference(function (p0, p1) {
      _set_updateChildrenNeeded__eksjzu(p0, p1);
      return Unit_instance;
    }, 2, 0, 214);
  }
  function Transition$_get_isSeeking_$ref_mx3xt() {
    return constructCallableReference(function (p0) {
      return p0.xep();
    }, 1, 0, 215);
  }
  function Transition$_set_isSeeking_$ref_fuomg5() {
    return constructCallableReference(function (p0, p1) {
      p0.aer(p1);
      return Unit_instance;
    }, 2, 0, 216);
  }
  function Transition$totalDurationNanos$delegate$lambda(this$0) {
    return function () {
      return calculateTotalDurationNanos(this$0);
    };
  }
  function Transition$_get_totalDurationNanos_$ref_owbzlq() {
    return constructCallableReference(function (p0) {
      return p0.ber();
    }, 1, 0, 217);
  }
  function animateTo$lambda_0($runFrameLoop$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('runFrameLoop', KProperty0, false);
    return $runFrameLoop$delegate.u1();
  }
  function Transition$animateTo$lambda(this$0) {
    return function () {
      return !equals(this$0.o70(), this$0.v70()) || this$0.rea() || _get_updateChildrenNeeded__mpvzi(this$0);
    };
  }
  function Transition$animateTo$lambda_0() {
    return EmptyCoroutineContext_getInstance();
  }
  function Transition$animateTo$lambda$slambda(this$0, resultContinuation) {
    this.ker_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Transition$animateTo$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(Transition$animateTo$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(Transition$animateTo$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.mer_1 = get_durationScale(this.ler_1.q19());
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!get_isActive(this.ler_1)) {
              this.n9_1 = 3;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = withFrameNanos(Transition$animateTo$lambda$slambda$lambda(this.ker_1, this.mer_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(Transition$animateTo$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new Transition$animateTo$lambda$slambda(this.ker_1, completion);
    i.ler_1 = $this$launch;
    return i;
  };
  function Transition$animateTo$lambda$slambda_0(this$0, resultContinuation) {
    var i = new Transition$animateTo$lambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function Transition$animateTo$$inlined$cache$1$2() {
  }
  protoOf(Transition$animateTo$$inlined$cache$1$2).s1d = function () {
  };
  function Transition$animateTo$lambda_1($coroutineScope, this$0) {
    return function ($this$DisposableEffect) {
      var tmp = CoroutineStart_UNDISPATCHED_getInstance();
      launch($coroutineScope, VOID, tmp, Transition$animateTo$lambda$slambda_0(this$0, null));
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new Transition$animateTo$$inlined$cache$1$2();
    };
  }
  function Transition$animateTo$lambda_2($tmp0_rcvr, $targetState, $$changed) {
    return function ($composer, $force) {
      $tmp0_rcvr.ner($targetState, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function Transition(transitionState, parentTransition, label) {
    label = label === VOID ? null : label;
    this.seo_1 = transitionState;
    this.teo_1 = parentTransition;
    this.ueo_1 = label;
    this.veo_1 = mutableStateOf(this.v70());
    this.weo_1 = mutableStateOf(new SegmentImpl(this.v70(), this.v70()));
    this.xeo_1 = mutableLongStateOf(new Long(0, 0));
    this.yeo_1 = mutableLongStateOf(new Long(0, -2147483648));
    this.zeo_1 = mutableStateOf(false);
    this.aep_1 = mutableStateListOf();
    this.bep_1 = mutableStateListOf();
    this.cep_1 = mutableStateOf(false);
    this.dep_1 = new Long(0, 0);
    var tmp = this;
    tmp.eep_1 = derivedStateOf(Transition$totalDurationNanos$delegate$lambda(this));
    this.seo_1.per(this);
  }
  protoOf(Transition).v70 = function () {
    return this.seo_1.v70();
  };
  protoOf(Transition).xeq = function (_set____db54di) {
    var tmp0 = this.veo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$_get_targetState_$ref_4jc5u9();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('targetState', 1, tmp, tmp_0, Transition$_set_targetState_$ref_5ke1ob());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(Transition).o70 = function () {
    var tmp0 = this.veo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$_get_targetState_$ref_4jc5u9();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('targetState', 1, tmp, tmp_0, Transition$_set_targetState_$ref_5ke1ob());
    return tmp0.u1();
  };
  protoOf(Transition).yep = function () {
    var tmp0 = this.weo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$_get_segment_$ref_hll1ky();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('segment', 1, tmp, tmp_0, Transition$_set_segment_$ref_n54u2a());
    return tmp0.u1();
  };
  protoOf(Transition).rea = function () {
    return !equalsLong(this.yeq(), new Long(0, -2147483648));
  };
  protoOf(Transition).qer = function (value) {
    if (this.teo_1 == null) {
      _set__playTimeNanos__8elh7c(this, value);
    }
  };
  protoOf(Transition).fep = function () {
    var tmp0_safe_receiver = this.teo_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fep();
    return tmp1_elvis_lhs == null ? _get__playTimeNanos__xxox8s(this) : tmp1_elvis_lhs;
  };
  protoOf(Transition).zeq = function (_set____db54di) {
    var tmp0 = this.yeo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$_get_startTimeNanos_$ref_69ueft();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('startTimeNanos', 1, tmp, tmp_0, Transition$_set_startTimeNanos_$ref_utecez());
    tmp0.i49(_set____db54di);
    return Unit_instance;
  };
  protoOf(Transition).yeq = function () {
    var tmp0 = this.yeo_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$_get_startTimeNanos_$ref_69ueft();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('startTimeNanos', 1, tmp, tmp_0, Transition$_set_startTimeNanos_$ref_utecez());
    return tmp0.j49();
  };
  protoOf(Transition).rer = function () {
    return this.aep_1;
  };
  protoOf(Transition).aer = function (_set____db54di) {
    var tmp0 = this.cep_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$_get_isSeeking_$ref_mx3xt();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('isSeeking', 1, tmp, tmp_0, Transition$_set_isSeeking_$ref_fuomg5());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(Transition).xep = function () {
    var tmp0 = this.cep_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Transition$_get_isSeeking_$ref_mx3xt();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('isSeeking', 1, tmp, tmp_0, Transition$_set_isSeeking_$ref_fuomg5());
    return tmp0.u1();
  };
  protoOf(Transition).ser = function () {
    var tmp;
    var tmp0 = this.aep_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastAny' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (!(item.eeo_1 == null)) {
            tmp$ret$0 = true;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = false;
    }
    if (tmp$ret$0) {
      tmp = true;
    } else {
      var tmp0_0 = this.bep_1;
      var tmp$ret$4;
      $l$block_0: {
        // Inline function 'androidx.compose.ui.util.fastAny' call
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable_0 = 0;
        var last_0 = tmp0_0.n1() - 1 | 0;
        if (inductionVariable_0 <= last_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var item_0 = tmp0_0.l1(index_0);
            if (item_0.ser()) {
              tmp$ret$4 = true;
              break $l$block_0;
            }
          }
           while (inductionVariable_0 <= last_0);
        tmp$ret$4 = false;
      }
      tmp = tmp$ret$4;
    }
    return tmp;
  };
  protoOf(Transition).ber = function () {
    var tmp0 = this.eep_1;
    var tmp = KProperty1;
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('totalDurationNanos', 1, tmp, Transition$_get_totalDurationNanos_$ref_owbzlq(), null);
    return tmp0.u1();
  };
  protoOf(Transition).beq = function (frameTimeNanos, durationScale) {
    if (equalsLong(this.yeq(), new Long(0, -2147483648))) {
      this.ter(frameTimeNanos);
    }
    var deltaT = subtract(frameTimeNanos, this.yeq());
    var tmp;
    if (durationScale === 0.0) {
      tmp = deltaT;
    } else {
      // Inline function 'kotlin.Long.div' call
      var tmp$ret$0 = toNumber(deltaT) / durationScale;
      tmp = roundToLong(tmp$ret$0);
    }
    var scaledPlayTimeNanos = tmp;
    this.qer(scaledPlayTimeNanos);
    this.uer(scaledPlayTimeNanos, durationScale === 0.0);
  };
  protoOf(Transition).uer = function (scaledPlayTimeNanos, scaleToEnd) {
    if (equalsLong(this.yeq(), new Long(0, -2147483648))) {
      this.ter(scaledPlayTimeNanos);
    } else if (!this.seo_1.ver()) {
      this.seo_1.ieg(true);
    }
    _set_updateChildrenNeeded__eksjzu(this, false);
    var allFinished = true;
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = this.aep_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        if (!item.gep()) {
          item.deq(scaledPlayTimeNanos, scaleToEnd);
        }
        if (!item.gep()) {
          allFinished = false;
        }
      }
       while (inductionVariable <= last);
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_1 = this.bep_1;
    var inductionVariable_0 = 0;
    var last_0 = this_1.n1() - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item_0 = this_1.l1(index_0);
        if (!equals(item_0.o70(), item_0.v70())) {
          item_0.uer(scaledPlayTimeNanos, scaleToEnd);
        }
        if (!equals(item_0.o70(), item_0.v70())) {
          allFinished = false;
        }
      }
       while (inductionVariable_0 <= last_0);
    if (allFinished) {
      this.wer();
    }
  };
  protoOf(Transition).ter = function (frameTimeNanos) {
    this.zeq(frameTimeNanos);
    this.seo_1.ieg(true);
  };
  protoOf(Transition).xer = function () {
    this.wer();
    this.seo_1.yer();
  };
  protoOf(Transition).wer = function () {
    this.zeq(new Long(0, -2147483648));
    var tmp = this.seo_1;
    if (tmp instanceof MutableTransitionState) {
      this.seo_1.ces(this.o70());
    }
    this.qer(new Long(0, 0));
    this.seo_1.ieg(false);
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = this.bep_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        item.wer();
      }
       while (inductionVariable <= last);
  };
  protoOf(Transition).des = function (initialState, targetState, playTimeNanos) {
    this.zeq(new Long(0, -2147483648));
    this.seo_1.ieg(false);
    if (!this.xep() || !equals(this.v70(), initialState) || !equals(this.o70(), targetState)) {
      var tmp;
      if (!equals(this.v70(), initialState)) {
        var tmp_0 = this.seo_1;
        tmp = tmp_0 instanceof MutableTransitionState;
      } else {
        tmp = false;
      }
      if (tmp) {
        this.seo_1.ces(initialState);
      }
      this.xeq(targetState);
      this.aer(true);
      _set_segment__77iylu(this, new SegmentImpl(initialState, targetState));
    }
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = this.bep_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        // Inline function 'kotlin.let' call
        var it = item instanceof Transition ? item : THROW_CCE();
        if (it.xep()) {
          it.des(it.v70(), it.o70(), playTimeNanos);
        }
      }
       while (inductionVariable <= last);
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_1 = this.aep_1;
    var inductionVariable_0 = 0;
    var last_0 = this_1.n1() - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item_0 = this_1.l1(index_0);
        item_0.ceq(playTimeNanos);
      }
       while (inductionVariable_0 <= last_0);
    this.dep_1 = playTimeNanos;
  };
  protoOf(Transition).ees = function (transition) {
    return this.bep_1.zz(transition);
  };
  protoOf(Transition).fes = function (transition) {
    return this.bep_1.g10(transition);
  };
  protoOf(Transition).veq = function (animation) {
    return this.aep_1.zz(animation);
  };
  protoOf(Transition).ges = function (animation) {
    this.aep_1.g10(animation);
  };
  protoOf(Transition).hes = function (targetState) {
    if (!equals(this.o70(), targetState)) {
      _set_segment__77iylu(this, new SegmentImpl(this.o70(), targetState));
      if (!equals(this.v70(), this.o70())) {
        this.seo_1.ces(this.o70());
      }
      this.xeq(targetState);
      if (!this.rea()) {
        _set_updateChildrenNeeded__eksjzu(this, true);
      }
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = this.aep_1;
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          item.neq();
        }
         while (inductionVariable <= last);
    }
  };
  protoOf(Transition).ner = function (targetState, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1493585151);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(targetState) : $composer_0.q31(targetState)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(this) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (!this.xep()) {
        $composer_0.m30(466062241);
        this.hes(targetState);
        var tmp0 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = ($dirty & 112) === 32;
        // Inline function 'kotlin.let' call
        var it = tmp0.i31();
        var tmp;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = derivedStateOf(Transition$animateTo$lambda(this));
          tmp0.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        var runFrameLoop$delegate = tmp;
        if (animateTo$lambda_0(runFrameLoop$delegate)) {
          $composer_0.m30(466470356);
          // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
          var getContext = null;
          var $composer_1 = $composer_0;
          if (!((1 & 1) === 0)) {
            getContext = Transition$animateTo$lambda_0;
          }
          var composer = $composer_1;
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_0 = $composer_1.i31();
          var tmp_0;
          if (false || it_0 === Companion_getInstance().f30_1) {
            var value_0 = createCompositionCoroutineScope(getContext(), composer);
            $composer_1.j31(value_0);
            tmp_0 = value_0;
          } else {
            tmp_0 = it_0;
          }
          var coroutineScope = tmp_0;
          var tmp0_0 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_0 = !!($composer_0.q31(coroutineScope) | ($dirty & 112) === 32);
          // Inline function 'kotlin.let' call
          var it_1 = tmp0_0.i31();
          var tmp_1;
          if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
            var value_1 = Transition$animateTo$lambda_1(coroutineScope, this);
            tmp0_0.j31(value_1);
            tmp_1 = value_1;
          } else {
            tmp_1 = it_1;
          }
          var tmp$ret$9 = tmp_1;
          DisposableEffect_0(coroutineScope, this, tmp$ret$9, $composer_0, 112 & $dirty);
          $composer_0.n30();
        } else {
          $composer_0.m30(467712929);
          $composer_0.n30();
        }
        $composer_0.n30();
      } else {
        $composer_0.m30(467722849);
        $composer_0.n30();
      }
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(Transition$animateTo$lambda_2(this, targetState, $changed));
    }
  };
  protoOf(Transition).ies = function (playTimeNanos) {
    if (equalsLong(this.yeq(), new Long(0, -2147483648))) {
      this.zeq(playTimeNanos);
    }
    this.qer(playTimeNanos);
    _set_updateChildrenNeeded__eksjzu(this, false);
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = this.aep_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        item.ceq(playTimeNanos);
      }
       while (inductionVariable <= last);
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_1 = this.bep_1;
    var inductionVariable_0 = 0;
    var last_0 = this_1.n1() - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item_0 = this_1.l1(index_0);
        if (!equals(item_0.o70(), item_0.v70())) {
          item_0.ies(playTimeNanos);
        }
      }
       while (inductionVariable_0 <= last_0);
  };
  protoOf(Transition).jes = function (animationState) {
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = this.aep_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        item.peq(animationState);
      }
       while (inductionVariable <= last);
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_1 = this.bep_1;
    var inductionVariable_0 = 0;
    var last_0 = this_1.n1() - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item_0 = this_1.l1(index_0);
        item_0.jes(animationState);
      }
       while (inductionVariable_0 <= last_0);
  };
  protoOf(Transition).kes = function (fraction) {
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = this.aep_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        item.oeq(fraction);
      }
       while (inductionVariable <= last);
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_1 = this.bep_1;
    var inductionVariable_0 = 0;
    var last_0 = this_1.n1() - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item_0 = this_1.l1(index_0);
        item_0.kes(fraction);
      }
       while (inductionVariable_0 <= last_0);
  };
  protoOf(Transition).les = function () {
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = this.aep_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        item.qeq();
      }
       while (inductionVariable <= last);
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_1 = this.bep_1;
    var inductionVariable_0 = 0;
    var last_0 = this_1.n1() - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item_0 = this_1.l1(index_0);
        item_0.les();
      }
       while (inductionVariable_0 <= last_0);
  };
  protoOf(Transition).mes = function () {
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = this.aep_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        item.eeq();
      }
       while (inductionVariable <= last);
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_1 = this.bep_1;
    var inductionVariable_0 = 0;
    var last_0 = this_1.n1() - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item_0 = this_1.l1(index_0);
        item_0.mes();
      }
       while (inductionVariable_0 <= last_0);
  };
  protoOf(Transition).toString = function () {
    var tmp0 = this.rer();
    // Inline function 'androidx.compose.ui.util.fastFold' call
    var accumulator = 'Transition animation values: ';
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = tmp0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = tmp0.l1(index);
        accumulator = accumulator + item.toString() + ', ';
      }
       while (inductionVariable <= last);
    return accumulator;
  };
  protoOf(Transition).nes = function (deferredAnimation) {
    var tmp0_safe_receiver = deferredAnimation.zep();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lep_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.ges(tmp1_safe_receiver);
    }
  };
  function updateTransition(targetState, label, $composer, $changed, $default) {
    _init_properties_Transition_kt__s6zoln();
    var label_0 = label;
    var $composer_0 = $composer;
    if (!(($default & 2) === 0))
      label_0 = null;
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance().f30_1) {
      var value = Transition_init_$Create$_0(targetState, label_0);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var transition = tmp;
    transition.ner(targetState, $composer_0, 48 | 8 & $changed | 14 & $changed);
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_0;
    if (false || it_0 === Companion_getInstance().f30_1) {
      var value_0 = updateTransition$lambda(transition);
      $composer_0.j31(value_0);
      tmp_0 = value_0;
    } else {
      tmp_0 = it_0;
    }
    var tmp$ret$4 = tmp_0;
    DisposableEffect(transition, tmp$ret$4, $composer_0, 54);
    return transition;
  }
  function SeekableTransitionState$seekTo$slambda$slambda$slambda(this$0, resultContinuation) {
    this.wes_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SeekableTransitionState$seekTo$slambda$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SeekableTransitionState$seekTo$slambda$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SeekableTransitionState$seekTo$slambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = runAnimations(this.wes_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SeekableTransitionState$seekTo$slambda$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new SeekableTransitionState$seekTo$slambda$slambda$slambda(this.wes_1, completion);
    i.xes_1 = $this$launch;
    return i;
  };
  function SeekableTransitionState$seekTo$slambda$slambda$slambda_0(this$0, resultContinuation) {
    var i = new SeekableTransitionState$seekTo$slambda$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function SeekableTransitionState$seekTo$slambda$slambda($targetState, $oldTargetState, this$0, $transition, $fraction, resultContinuation) {
    this.get_1 = $targetState;
    this.het_1 = $oldTargetState;
    this.iet_1 = this$0;
    this.jet_1 = $transition;
    this.ket_1 = $fraction;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SeekableTransitionState$seekTo$slambda$slambda).p24 = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SeekableTransitionState$seekTo$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SeekableTransitionState$seekTo$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            if (!equals(this.get_1, this.het_1)) {
              moveAnimationToInitialState(this.iet_1);
            } else {
              this.iet_1.aeu_1 = null;
              if (equals(this.iet_1.v70(), this.get_1)) {
                return Unit_instance;
              }
            }

            if (!equals(this.get_1, this.het_1)) {
              this.jet_1.hes(this.get_1);
              this.jet_1.qer(new Long(0, 0));
              this.iet_1.xeq(this.get_1);
              this.jet_1.kes(this.ket_1);
            }

            _set_fraction__t78qnf(this.iet_1, this.ket_1);
            if (this.iet_1.zet_1.fv()) {
              launch(this.let_1, VOID, VOID, SeekableTransitionState$seekTo$slambda$slambda$slambda_0(this.iet_1, null));
            } else {
              this.iet_1.yet_1 = new Long(0, -2147483648);
            }

            this.n9_1 = 1;
            suspendResult = waitForCompositionAfterTargetStateChange(this.iet_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            seekToFraction(this.iet_1);
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SeekableTransitionState$seekTo$slambda$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new SeekableTransitionState$seekTo$slambda$slambda(this.get_1, this.het_1, this.iet_1, this.jet_1, this.ket_1, completion);
    i.let_1 = $this$coroutineScope;
    return i;
  };
  function SeekableTransitionState$seekTo$slambda$slambda_0($targetState, $oldTargetState, this$0, $transition, $fraction, resultContinuation) {
    var i = new SeekableTransitionState$seekTo$slambda$slambda($targetState, $oldTargetState, this$0, $transition, $fraction, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.p24($this$coroutineScope, $completion);
    }, 1);
  }
  function SeekableTransitionState$animateTo$slambda$slambda(this$0, $targetState, $transition, $animationSpec, resultContinuation) {
    this.meu_1 = this$0;
    this.neu_1 = $targetState;
    this.oeu_1 = $transition;
    this.peu_1 = $animationSpec;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SeekableTransitionState$animateTo$slambda$slambda).p24 = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SeekableTransitionState$animateTo$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SeekableTransitionState$animateTo$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            var oldTargetState = this.meu_1.o70();
            if (!equals(this.neu_1, oldTargetState)) {
              moveAnimationToInitialState(this.meu_1);
              _set_fraction__t78qnf(this.meu_1, 0.0);
              this.oeu_1.hes(this.neu_1);
              this.oeu_1.qer(new Long(0, 0));
              this.meu_1.ces(oldTargetState);
              this.meu_1.xeq(this.neu_1);
            }

            this.seu_1 = this.meu_1.wet_1;
            this.reu_1 = null;
            this.n9_1 = 1;
            suspendResult = this.seu_1.o2u(this.reu_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp$ret$0 = Unit_instance;
            l$ret$1: do {
              var tmp_0;
              try {
                tmp$ret$0 = this.meu_1.pet_1;
                break l$ret$1;
              } catch ($p) {
                var tmp_1;
                var t = $p;
                this.seu_1.q2u(this.reu_1);
                throw t;
              }
            }
             while (false);
            var tmp_2 = tmp$ret$0;
            this.seu_1.q2u(this.reu_1);
            var composedTargetState = tmp_2;
            if (!equals(this.neu_1, composedTargetState)) {
              this.n9_1 = 2;
              suspendResult = doOneFrame(this.meu_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 2:
            this.n9_1 = 3;
            suspendResult = waitForCompositionAfterTargetStateChange(this.meu_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            if (!equals(this.meu_1.v70(), this.neu_1)) {
              if (this.meu_1.veu() < 1.0) {
                var runningAnimation = this.meu_1.aeu_1;
                var tmp0_safe_receiver = this.peu_1;
                var newSpec = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qed(get_VectorConverter(FloatCompanionObject_instance));
                if (runningAnimation == null || !equals(newSpec, runningAnimation.geq_1)) {
                  var oldSpec = runningAnimation == null ? null : runningAnimation.geq_1;
                  var oldVelocity;
                  if (!(oldSpec == null)) {
                    var tmp_3 = runningAnimation.feq_1;
                    var tmp_4 = runningAnimation.jeq_1;
                    var tmp_5 = Companion_getInstance_8().ueu_1;
                    var tmp2_elvis_lhs = runningAnimation.keq_1;
                    oldVelocity = oldSpec.mee(tmp_3, tmp_4, tmp_5, tmp2_elvis_lhs == null ? Companion_getInstance_8().teu_1 : tmp2_elvis_lhs);
                  } else if (runningAnimation == null || equalsLong(runningAnimation.feq_1, new Long(0, 0))) {
                    oldVelocity = Companion_getInstance_8().teu_1;
                  } else {
                    var oldDurationNanos = runningAnimation.leq_1;
                    var tmp_6;
                    if (equalsLong(oldDurationNanos, new Long(0, -2147483648))) {
                      tmp_6 = this.meu_1.ret_1;
                    } else {
                      tmp_6 = oldDurationNanos;
                    }
                    var tmp0 = tmp_6;
                    var other = 1000.0 * toNumber(new Long(1000000, 0));
                    var oldDuration = toNumber(tmp0) / other;
                    if (oldDuration <= toNumber(new Long(0, 0))) {
                      oldVelocity = Companion_getInstance_8().teu_1;
                    } else {
                      oldVelocity = new AnimationVector1D(1.0 / oldDuration);
                    }
                  }
                  var newAnimation = runningAnimation == null ? new SeekingAnimationState() : runningAnimation;
                  newAnimation.geq_1 = newSpec;
                  newAnimation.heq_1 = false;
                  newAnimation.ieq_1 = this.meu_1.veu();
                  newAnimation.jeq_1.oea(0, this.meu_1.veu());
                  newAnimation.leq_1 = this.meu_1.ret_1;
                  newAnimation.feq_1 = new Long(0, 0);
                  newAnimation.keq_1 = oldVelocity;
                  var tmp_7 = newAnimation;
                  var tmp5_elvis_lhs = newSpec == null ? null : newSpec.kee(newAnimation.jeq_1, Companion_getInstance_8().ueu_1, oldVelocity);
                  var tmp_8;
                  if (tmp5_elvis_lhs == null) {
                    var tmp0_0 = this.meu_1.ret_1;
                    var other_0 = 1.0 - this.meu_1.veu();
                    tmp_8 = roundToLong(toNumber(tmp0_0) * other_0);
                  } else {
                    tmp_8 = tmp5_elvis_lhs;
                  }
                  tmp_7.meq_1 = tmp_8;
                  this.meu_1.aeu_1 = newAnimation;
                }
              }
              this.n9_1 = 5;
              suspendResult = runAnimations(this.meu_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 7;
              continue $sm;
            }

          case 5:
            this.meu_1.ces(this.neu_1);
            this.n9_1 = 6;
            suspendResult = waitForComposition(this.meu_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            _set_fraction__t78qnf(this.meu_1, 0.0);
            this.n9_1 = 7;
            continue $sm;
          case 7:
            return Unit_instance;
          case 8:
            throw this.q9_1;
        }
      } catch ($p_0) {
        var e = $p_0;
        if (this.o9_1 === 8) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SeekableTransitionState$animateTo$slambda$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new SeekableTransitionState$animateTo$slambda$slambda(this.meu_1, this.neu_1, this.oeu_1, this.peu_1, completion);
    i.qeu_1 = $this$coroutineScope;
    return i;
  };
  function SeekableTransitionState$animateTo$slambda$slambda_0(this$0, $targetState, $transition, $animationSpec, resultContinuation) {
    var i = new SeekableTransitionState$animateTo$slambda$slambda(this$0, $targetState, $transition, $animationSpec, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.p24($this$coroutineScope, $completion);
    }, 1);
  }
  function _set_fraction__t78qnf($this, _set____db54di) {
    var tmp0 = $this.uet_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SeekableTransitionState$_get_fraction_$ref_yo18y6();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('fraction', 1, tmp, tmp_0, SeekableTransitionState$_set_fraction_$ref_ktc2gu());
    tmp0.i45(_set____db54di);
    return Unit_instance;
  }
  function endAllAnimations($this) {
    var tmp0_safe_receiver = $this.qet_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.les();
    }
    $this.zet_1.c3();
    var current = $this.aeu_1;
    if (!(current == null)) {
      $this.aeu_1 = null;
      _set_fraction__t78qnf($this, 1.0);
      seekToFraction($this);
    }
  }
  function runAnimations($this, $completion) {
    var tmp = new $runAnimationsCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function doOneFrame($this, $completion) {
    var tmp = new $doOneFrameCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function animateOneFrame($this, $completion) {
    var tmp = new $animateOneFrameCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function recalculateAnimationValue($this, animation, deltaPlayTimeNanos) {
    var playTimeNanos = add(animation.feq_1, deltaPlayTimeNanos);
    animation.feq_1 = playTimeNanos;
    var durationNanos = animation.meq_1;
    if (compare(playTimeNanos, durationNanos) >= 0) {
      animation.ieq_1 = 1.0;
    } else {
      var animationSpec = animation.geq_1;
      if (!(animationSpec == null)) {
        var tmp = animation;
        var tmp_0 = animation.jeq_1;
        var tmp_1 = Companion_getInstance_8().ueu_1;
        var tmp0_elvis_lhs = animation.keq_1;
        tmp.ieq_1 = coerceIn(animationSpec.hee(playTimeNanos, tmp_0, tmp_1, tmp0_elvis_lhs == null ? Companion_getInstance_8().teu_1 : tmp0_elvis_lhs).nea(0), 0.0, 1.0);
      } else {
        var tmp_2 = animation;
        var tmp0 = animation.jeq_1.nea(0);
        // Inline function 'androidx.compose.animation.core.lerp' call
        var fraction = toNumber(playTimeNanos) / toNumber(durationNanos);
        tmp_2.ieq_1 = tmp0 * (1 - fraction) + 1.0 * fraction;
      }
    }
  }
  function waitForCompositionAfterTargetStateChange($this, $completion) {
    var tmp = new $waitForCompositionAfterTargetStateChangeCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function waitForComposition($this, $completion) {
    var tmp = new $waitForCompositionCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function moveAnimationToInitialState($this) {
    var tmp0_elvis_lhs = $this.qet_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var transition = tmp;
    var tmp1_elvis_lhs = $this.aeu_1;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var tmp_1;
      if (compare($this.ret_1, new Long(0, 0)) <= 0 || $this.veu() === 1.0 || equals($this.v70(), $this.o70())) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.also' call
        var this_0 = new SeekingAnimationState();
        this_0.ieq_1 = $this.veu();
        var totalDurationNanos = $this.ret_1;
        this_0.leq_1 = totalDurationNanos;
        var tmp_2 = this_0;
        // Inline function 'kotlin.Long.times' call
        var other = 1.0 - $this.veu();
        var tmp$ret$2 = toNumber(totalDurationNanos) * other;
        tmp_2.meq_1 = roundToLong(tmp$ret$2);
        this_0.jeq_1.oea(0, $this.veu());
        tmp_1 = this_0;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var animation = tmp_0;
    if (!(animation == null)) {
      animation.leq_1 = $this.ret_1;
      // Inline function 'androidx.collection.MutableObjectList.plusAssign' call
      $this.zet_1.j1(animation);
      transition.jes(animation);
    }
    $this.aeu_1 = null;
  }
  function seekToFraction($this) {
    var tmp0_elvis_lhs = $this.qet_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var transition = tmp;
    var playTimeNanos = roundToLong($this.veu() * toNumber(transition.ber()));
    transition.ies(playTimeNanos);
  }
  function SeekingAnimationState() {
    this.feq_1 = new Long(0, 0);
    this.geq_1 = null;
    this.heq_1 = false;
    this.ieq_1 = 0.0;
    this.jeq_1 = new AnimationVector1D(0.0);
    this.keq_1 = null;
    this.leq_1 = new Long(0, 0);
    this.meq_1 = new Long(0, 0);
  }
  protoOf(SeekingAnimationState).toString = function () {
    return 'progress nanos: ' + this.feq_1.toString() + ', animationSpec: ' + toString_0(this.geq_1) + ',' + (' isComplete: ' + this.heq_1 + ', value: ' + this.ieq_1 + ', start: ' + this.jeq_1.toString() + ',') + (' initialVelocity: ' + toString_0(this.keq_1) + ', durationNanos: ' + this.leq_1.toString() + ',') + (' animationSpecDuration: ' + this.meq_1.toString());
  };
  function Companion_0() {
    Companion_instance_2 = this;
    this.teu_1 = new AnimationVector1D(0.0);
    this.ueu_1 = new AnimationVector1D(1.0);
  }
  var Companion_instance_2;
  function Companion_getInstance_8() {
    if (Companion_instance_2 == null)
      new Companion_0();
    return Companion_instance_2;
  }
  function SeekableTransitionState$_get_targetState_$ref_y39d4q() {
    return constructCallableReference(function (p0) {
      return p0.o70();
    }, 1, 0, 218);
  }
  function SeekableTransitionState$_set_targetState_$ref_qu4hbu() {
    return constructCallableReference(function (p0, p1) {
      p0.xeq(p1);
      return Unit_instance;
    }, 2, 0, 219);
  }
  function SeekableTransitionState$_get_currentState_$ref_jj5e70() {
    return constructCallableReference(function (p0) {
      return p0.v70();
    }, 1, 0, 220);
  }
  function SeekableTransitionState$_set_currentState_$ref_9jyuvs() {
    return constructCallableReference(function (p0, p1) {
      p0.ces(p1);
      return Unit_instance;
    }, 2, 0, 221);
  }
  function SeekableTransitionState$recalculateTotalDurationNanos$lambda(this$0) {
    return function () {
      var tmp = this$0;
      var tmp0_safe_receiver = this$0.qet_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ber();
      tmp.ret_1 = tmp1_elvis_lhs == null ? new Long(0, 0) : tmp1_elvis_lhs;
      return Unit_instance;
    };
  }
  function SeekableTransitionState$_get_fraction_$ref_yo18y6() {
    return constructCallableReference(function (p0) {
      return p0.veu();
    }, 1, 0, 222);
  }
  function SeekableTransitionState$_set_fraction_$ref_ktc2gu() {
    return constructCallableReference(function (p0, p1) {
      _set_fraction__t78qnf(p0, p1);
      return Unit_instance;
    }, 2, 0, 223);
  }
  function SeekableTransitionState$firstFrameLambda$lambda(this$0) {
    return function (frameTimeNanos) {
      this$0.yet_1 = frameTimeNanos;
      return Unit_instance;
    };
  }
  function SeekableTransitionState$animateOneFrameLambda$lambda(this$0) {
    return function (frameTimeNanos) {
      var delta = subtract(frameTimeNanos, this$0.yet_1);
      this$0.yet_1 = frameTimeNanos;
      // Inline function 'kotlin.Long.div' call
      var other = this$0.ceu_1;
      var tmp$ret$0 = toNumber(delta) / other;
      var deltaPlayTimeNanos = roundToLong(tmp$ret$0);
      var tmp;
      if (this$0.zet_1.fv()) {
        // Inline function 'androidx.collection.ObjectList.forEach' call
        var this_0 = this$0.zet_1;
        // Inline function 'kotlin.contracts.contract' call
        var content = this_0.sz_1;
        var inductionVariable = 0;
        var last = this_0.tz_1;
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var animation = content[i];
            recalculateAnimationValue(this$0, animation, deltaPlayTimeNanos);
            animation.heq_1 = true;
          }
           while (inductionVariable < last);
        var tmp0_safe_receiver = this$0.qet_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.mes();
        }
        // Inline function 'androidx.collection.MutableObjectList.removeIf' call
        var this_1 = this$0.zet_1;
        var gap = 0;
        var size = this_1.tz_1;
        var content_0 = this_1.sz_1;
        // Inline function 'androidx.collection.ObjectList.indices' call
        var progression = until(0, this_1.tz_1);
        var inductionVariable_0 = progression.x1_1;
        var last_0 = progression.y1_1;
        if (inductionVariable_0 <= last_0)
          do {
            var i_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            content_0[i_0 - gap | 0] = content_0[i_0];
            if (content_0[i_0].heq_1) {
              gap = gap + 1 | 0;
            }
          }
           while (!(i_0 === last_0));
        fill(content_0, null, size - gap | 0, size);
        this_1.tz_1 = this_1.tz_1 - gap | 0;
        tmp = Unit_instance;
      }
      var currentAnimation = this$0.aeu_1;
      var tmp_0;
      if (!(currentAnimation == null)) {
        currentAnimation.leq_1 = this$0.ret_1;
        recalculateAnimationValue(this$0, currentAnimation, deltaPlayTimeNanos);
        _set_fraction__t78qnf(this$0, currentAnimation.ieq_1);
        if (currentAnimation.ieq_1 === 1.0) {
          this$0.aeu_1 = null;
        }
        seekToFraction(this$0);
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SeekableTransitionState$snapTo$slambda(this$0, $targetState, $transition, resultContinuation) {
    this.zew_1 = this$0;
    this.aex_1 = $targetState;
    this.bex_1 = $transition;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SeekableTransitionState$snapTo$slambda).r2b = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SeekableTransitionState$snapTo$slambda).ia = function ($completion) {
    return this.r2b($completion);
  };
  protoOf(SeekableTransitionState$snapTo$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            endAllAnimations(this.zew_1);
            this.zew_1.yet_1 = new Long(0, -2147483648);
            _set_fraction__t78qnf(this.zew_1, 0.0);
            var tmp0_subject = this.aex_1;
            var fraction = equals(tmp0_subject, this.zew_1.v70()) ? -4.0 : equals(tmp0_subject, this.zew_1.o70()) ? -5.0 : -3.0;
            this.bex_1.hes(this.aex_1);
            this.bex_1.qer(new Long(0, 0));
            this.zew_1.xeq(this.aex_1);
            _set_fraction__t78qnf(this.zew_1, 0.0);
            this.zew_1.ces(this.aex_1);
            this.bex_1.kes(fraction);
            if (fraction === -3.0) {
              this.n9_1 = 1;
              suspendResult = waitForCompositionAfterTargetStateChange(this.zew_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.bex_1.wer();
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SeekableTransitionState$snapTo$slambda).s2b = function (completion) {
    return new SeekableTransitionState$snapTo$slambda(this.zew_1, this.aex_1, this.bex_1, completion);
  };
  function SeekableTransitionState$snapTo$slambda_0(this$0, $targetState, $transition, resultContinuation) {
    var i = new SeekableTransitionState$snapTo$slambda(this$0, $targetState, $transition, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.r2b($completion);
    }, 0);
  }
  function SeekableTransitionState$seekTo$slambda($targetState, $oldTargetState, this$0, $transition, $fraction, resultContinuation) {
    this.kex_1 = $targetState;
    this.lex_1 = $oldTargetState;
    this.mex_1 = this$0;
    this.nex_1 = $transition;
    this.oex_1 = $fraction;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SeekableTransitionState$seekTo$slambda).r2b = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SeekableTransitionState$seekTo$slambda).ia = function ($completion) {
    return this.r2b($completion);
  };
  protoOf(SeekableTransitionState$seekTo$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = coroutineScope(SeekableTransitionState$seekTo$slambda$slambda_0(this.kex_1, this.lex_1, this.mex_1, this.nex_1, this.oex_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SeekableTransitionState$seekTo$slambda).s2b = function (completion) {
    return new SeekableTransitionState$seekTo$slambda(this.kex_1, this.lex_1, this.mex_1, this.nex_1, this.oex_1, completion);
  };
  function SeekableTransitionState$seekTo$slambda_0($targetState, $oldTargetState, this$0, $transition, $fraction, resultContinuation) {
    var i = new SeekableTransitionState$seekTo$slambda($targetState, $oldTargetState, this$0, $transition, $fraction, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.r2b($completion);
    }, 0);
  }
  function SeekableTransitionState$animateTo$slambda($transition, this$0, $targetState, $animationSpec, resultContinuation) {
    this.xex_1 = $transition;
    this.yex_1 = this$0;
    this.zex_1 = $targetState;
    this.aey_1 = $animationSpec;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SeekableTransitionState$animateTo$slambda).r2b = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SeekableTransitionState$animateTo$slambda).ia = function ($completion) {
    return this.r2b($completion);
  };
  protoOf(SeekableTransitionState$animateTo$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = coroutineScope(SeekableTransitionState$animateTo$slambda$slambda_0(this.yex_1, this.zex_1, this.xex_1, this.aey_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.xex_1.wer();
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SeekableTransitionState$animateTo$slambda).s2b = function (completion) {
    return new SeekableTransitionState$animateTo$slambda(this.xex_1, this.yex_1, this.zex_1, this.aey_1, completion);
  };
  function SeekableTransitionState$animateTo$slambda_0($transition, this$0, $targetState, $animationSpec, resultContinuation) {
    var i = new SeekableTransitionState$animateTo$slambda($transition, this$0, $targetState, $animationSpec, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.r2b($completion);
    }, 0);
  }
  function $runAnimationsCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.eev_1 = _this__u8e3s4;
  }
  protoOf($runAnimationsCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            if (this.eev_1.zet_1.r() && this.eev_1.aeu_1 == null) {
              return Unit_instance;
            }

            if (get_durationScale(this.t9()) === 0.0) {
              endAllAnimations(this.eev_1);
              this.eev_1.yet_1 = new Long(0, -2147483648);
              return Unit_instance;
            }

            if (equalsLong(this.eev_1.yet_1, new Long(0, -2147483648))) {
              this.n9_1 = 1;
              suspendResult = withFrameNanos(this.eev_1.beu_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            if (!(this.eev_1.zet_1.fv() || !(this.eev_1.aeu_1 == null))) {
              this.n9_1 = 5;
              continue $sm;
            }

            this.n9_1 = 4;
            suspendResult = animateOneFrame(this.eev_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.n9_1 = 3;
            continue $sm;
          case 5:
            this.eev_1.yet_1 = new Long(0, -2147483648);
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $doOneFrameCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.nev_1 = _this__u8e3s4;
  }
  protoOf($doOneFrameCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            if (equalsLong(this.nev_1.yet_1, new Long(0, -2147483648))) {
              this.n9_1 = 2;
              suspendResult = withFrameNanos(this.nev_1.beu_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = animateOneFrame(this.nev_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $animateOneFrameCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wev_1 = _this__u8e3s4;
  }
  protoOf($animateOneFrameCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var durationScale = get_durationScale(this.t9());
            if (durationScale <= 0.0) {
              endAllAnimations(this.wev_1);
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.wev_1.ceu_1 = durationScale;
              this.n9_1 = 1;
              suspendResult = withFrameNanos(this.wev_1.deu_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $waitForCompositionAfterTargetStateChangeCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.few_1 = _this__u8e3s4;
  }
  protoOf($waitForCompositionAfterTargetStateChangeCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.gew_1 = this.few_1.o70();
            this.n9_1 = 1;
            suspendResult = this.few_1.wet_1.p2u(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (equals(this.gew_1, this.few_1.pet_1)) {
              this.few_1.wet_1.r2u();
              this.n9_1 = 3;
              continue $sm;
            } else {
              this.n9_1 = 2;
              var cancellable = new CancellableContinuationImpl(intercepted(this), 1);
              cancellable.v1e();
              this.few_1.vet_1 = cancellable;
              this.few_1.wet_1.r2u();
              suspendResult = returnIfSuspended(cancellable.x1b(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            var state = suspendResult;
            if (!equals(state, this.gew_1)) {
              this.few_1.yet_1 = new Long(0, -2147483648);
              throw CancellationException_init_$Create$('snapTo() was canceled because state was changed to ' + (toString_0(state) + ' instead of ' + toString_0(this.gew_1)));
            }

            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $waitForCompositionCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pew_1 = _this__u8e3s4;
  }
  protoOf($waitForCompositionCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.qew_1 = this.pew_1.o70();
            this.n9_1 = 1;
            suspendResult = this.pew_1.wet_1.p2u(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            var cancellable = new CancellableContinuationImpl(intercepted(this), 1);
            cancellable.v1e();
            this.pew_1.vet_1 = cancellable;
            this.pew_1.wet_1.r2u();
            suspendResult = returnIfSuspended(cancellable.x1b(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var state = suspendResult;
            if (!equals(state, this.qew_1)) {
              this.pew_1.yet_1 = new Long(0, -2147483648);
              throw CancellationException_init_$Create$('targetState while waiting for composition');
            }

            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function SeekableTransitionState(initialState) {
    Companion_getInstance_8();
    TransitionState.call(this);
    this.net_1 = mutableStateOf(initialState);
    this.oet_1 = mutableStateOf(initialState);
    this.pet_1 = initialState;
    this.qet_1 = null;
    this.ret_1 = new Long(0, 0);
    var tmp = this;
    tmp.set_1 = SeekableTransitionState$recalculateTotalDurationNanos$lambda(this);
    this.tet_1 = null;
    this.uet_1 = mutableFloatStateOf(0.0);
    this.vet_1 = null;
    this.wet_1 = Mutex();
    this.xet_1 = new MutatorMutex();
    this.yet_1 = new Long(0, -2147483648);
    this.zet_1 = new MutableObjectList();
    this.aeu_1 = null;
    var tmp_0 = this;
    tmp_0.beu_1 = SeekableTransitionState$firstFrameLambda$lambda(this);
    this.ceu_1 = 0.0;
    var tmp_1 = this;
    tmp_1.deu_1 = SeekableTransitionState$animateOneFrameLambda$lambda(this);
  }
  protoOf(SeekableTransitionState).xeq = function (_set____db54di) {
    var tmp0 = this.net_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SeekableTransitionState$_get_targetState_$ref_y39d4q();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('targetState', 1, tmp, tmp_0, SeekableTransitionState$_set_targetState_$ref_qu4hbu());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(SeekableTransitionState).o70 = function () {
    var tmp0 = this.net_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SeekableTransitionState$_get_targetState_$ref_y39d4q();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('targetState', 1, tmp, tmp_0, SeekableTransitionState$_set_targetState_$ref_qu4hbu());
    return tmp0.u1();
  };
  protoOf(SeekableTransitionState).ces = function (_set____db54di) {
    var tmp0 = this.oet_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SeekableTransitionState$_get_currentState_$ref_jj5e70();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('currentState', 1, tmp, tmp_0, SeekableTransitionState$_set_currentState_$ref_9jyuvs());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(SeekableTransitionState).v70 = function () {
    var tmp0 = this.oet_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SeekableTransitionState$_get_currentState_$ref_jj5e70();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('currentState', 1, tmp, tmp_0, SeekableTransitionState$_set_currentState_$ref_9jyuvs());
    return tmp0.u1();
  };
  protoOf(SeekableTransitionState).bey = function (value) {
    if (!equals(this.tet_1, value)) {
      var tmp0_safe_receiver = this.tet_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.a5b(this);
      }
      var tmp1_safe_receiver = this.tet_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.d5b();
      }
      this.tet_1 = value;
      if (value == null)
        null;
      else {
        value.c5b();
      }
      this.cey();
    }
  };
  protoOf(SeekableTransitionState).veu = function () {
    var tmp0 = this.uet_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SeekableTransitionState$_get_fraction_$ref_yo18y6();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('fraction', 1, tmp, tmp_0, SeekableTransitionState$_set_fraction_$ref_ktc2gu());
    return tmp0.j45();
  };
  protoOf(SeekableTransitionState).dey = function (targetState, $completion) {
    var tmp0_elvis_lhs = this.qet_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var transition = tmp;
    if (equals(this.v70(), targetState) && equals(this.o70(), targetState)) {
      return Unit_instance;
    }
    return this.xet_1.kea(VOID, SeekableTransitionState$snapTo$slambda_0(this, targetState, transition, null), $completion);
  };
  protoOf(SeekableTransitionState).eey = function (fraction, targetState, $completion) {
    // Inline function 'androidx.compose.animation.core.requirePrecondition' call
    if (!(0.0 <= fraction ? fraction <= 1.0 : false)) {
      var tmp$ret$1 = 'Expecting fraction between 0 and 1. Got ' + fraction;
      throwIllegalArgumentException(tmp$ret$1);
    }
    var tmp0_elvis_lhs = this.qet_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var transition = tmp;
    var oldTargetState = this.o70();
    return this.xet_1.kea(VOID, SeekableTransitionState$seekTo$slambda_0(targetState, oldTargetState, this, transition, fraction, null), $completion);
  };
  protoOf(SeekableTransitionState).fey = function (fraction, targetState, $completion, $super) {
    targetState = targetState === VOID ? this.o70() : targetState;
    return $super === VOID ? this.eey(fraction, targetState, $completion) : $super.eey.call(this, fraction, targetState, $completion);
  };
  protoOf(SeekableTransitionState).gey = function (targetState, animationSpec, $completion) {
    var tmp0_elvis_lhs = this.qet_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var transition = tmp;
    return this.xet_1.kea(VOID, SeekableTransitionState$animateTo$slambda_0(transition, this, targetState, animationSpec, null), $completion);
  };
  protoOf(SeekableTransitionState).hey = function (targetState, animationSpec, $completion, $super) {
    targetState = targetState === VOID ? this.o70() : targetState;
    animationSpec = animationSpec === VOID ? null : animationSpec;
    return $super === VOID ? this.gey(targetState, animationSpec, $completion) : $super.gey.call(this, targetState, animationSpec, $completion);
  };
  protoOf(SeekableTransitionState).per = function (transition) {
    // Inline function 'androidx.compose.animation.core.checkPrecondition' call
    if (!(this.qet_1 == null || equals(transition, this.qet_1))) {
      var tmp$ret$1 = 'An instance of SeekableTransitionState has been used in different Transitions. ' + ('Previous instance: ' + toString_0(this.qet_1) + ', new instance: ' + transition.toString());
      throwIllegalStateException(tmp$ret$1);
    }
    this.qet_1 = transition;
  };
  protoOf(SeekableTransitionState).yer = function () {
    this.qet_1 = null;
    var tmp0_safe_receiver = this.tet_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a5b(this);
    }
  };
  protoOf(SeekableTransitionState).cey = function () {
    var tmp0_safe_receiver = this.tet_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.z5a(this, get_SeekableTransitionStateTotalDurationChanged(), this.set_1);
    }
  };
  protoOf(SeekableTransitionState).iey = function () {
    var previousTotalDurationNanos = this.ret_1;
    this.cey();
    if (!equalsLong(previousTotalDurationNanos, this.ret_1)) {
      var animation = this.aeu_1;
      if (!(animation == null)) {
        if (compare(animation.feq_1, this.ret_1) > 0) {
          endAllAnimations(this);
        } else {
          animation.leq_1 = this.ret_1;
          if (animation.geq_1 == null) {
            animation.meq_1 = roundToLong((1.0 - animation.jeq_1.nea(0)) * toNumber(this.ret_1));
          }
        }
      } else if (!equalsLong(this.ret_1, new Long(0, 0))) {
        seekToFraction(this);
      }
    }
  };
  function TransitionState$_get_isRunning_$ref_gi5vj1() {
    return constructCallableReference(function (p0) {
      return p0.ver();
    }, 1, 0, 224);
  }
  function TransitionState$_set_isRunning_$ref_1aed0p() {
    return constructCallableReference(function (p0, p1) {
      p0.ieg(p1);
      return Unit_instance;
    }, 2, 0, 225);
  }
  function TransitionState() {
    this.oer_1 = mutableStateOf(false);
  }
  protoOf(TransitionState).ieg = function (_set____db54di) {
    var tmp0 = this.oer_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TransitionState$_get_isRunning_$ref_gi5vj1();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('isRunning', 1, tmp, tmp_0, TransitionState$_set_isRunning_$ref_1aed0p());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(TransitionState).ver = function () {
    var tmp0 = this.oer_1;
    var tmp = KMutableProperty1;
    var tmp_0 = TransitionState$_get_isRunning_$ref_gi5vj1();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('isRunning', 1, tmp, tmp_0, TransitionState$_set_isRunning_$ref_1aed0p());
    return tmp0.u1();
  };
  function MutableTransitionState$_get_currentState_$ref_7vauvk() {
    return constructCallableReference(function (p0) {
      return p0.v70();
    }, 1, 0, 226);
  }
  function MutableTransitionState$_set_currentState_$ref_y2oy0s() {
    return constructCallableReference(function (p0, p1) {
      p0.ces(p1);
      return Unit_instance;
    }, 2, 0, 227);
  }
  function MutableTransitionState$_get_targetState_$ref_l85mby() {
    return constructCallableReference(function (p0) {
      return p0.o70();
    }, 1, 0, 228);
  }
  function MutableTransitionState$_set_targetState_$ref_vbvtui() {
    return constructCallableReference(function (p0, p1) {
      p0.jey(p1);
      return Unit_instance;
    }, 2, 0, 229);
  }
  function MutableTransitionState(initialState) {
    TransitionState.call(this);
    this.aes_1 = mutableStateOf(initialState);
    this.bes_1 = mutableStateOf(initialState);
  }
  protoOf(MutableTransitionState).ces = function (_set____db54di) {
    var tmp0 = this.aes_1;
    var tmp = KMutableProperty1;
    var tmp_0 = MutableTransitionState$_get_currentState_$ref_7vauvk();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('currentState', 1, tmp, tmp_0, MutableTransitionState$_set_currentState_$ref_y2oy0s());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(MutableTransitionState).v70 = function () {
    var tmp0 = this.aes_1;
    var tmp = KMutableProperty1;
    var tmp_0 = MutableTransitionState$_get_currentState_$ref_7vauvk();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('currentState', 1, tmp, tmp_0, MutableTransitionState$_set_currentState_$ref_y2oy0s());
    return tmp0.u1();
  };
  protoOf(MutableTransitionState).jey = function (_set____db54di) {
    var tmp0 = this.bes_1;
    var tmp = KMutableProperty1;
    var tmp_0 = MutableTransitionState$_get_targetState_$ref_l85mby();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('targetState', 1, tmp, tmp_0, MutableTransitionState$_set_targetState_$ref_vbvtui());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(MutableTransitionState).o70 = function () {
    var tmp0 = this.bes_1;
    var tmp = KMutableProperty1;
    var tmp_0 = MutableTransitionState$_get_targetState_$ref_l85mby();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('targetState', 1, tmp, tmp_0, MutableTransitionState$_set_targetState_$ref_vbvtui());
    return tmp0.u1();
  };
  protoOf(MutableTransitionState).per = function (transition) {
  };
  protoOf(MutableTransitionState).yer = function () {
  };
  function createTransitionAnimation(_this__u8e3s4, initialValue, targetValue, animationSpec, typeConverter, label, $composer, $changed) {
    _init_properties_Transition_kt__s6zoln();
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = ($changed & 14 ^ 6) > 4 && $composer_0.k31(_this__u8e3s4) || ($changed & 6) === 4;
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      var tmp$ret$4;
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
        var previousSnapshot = Companion_instance.p52();
        var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
        var newSnapshot = Companion_instance.q52(previousSnapshot);
        try {
          tmp$ret$4 = new TransitionAnimationState_0(_this__u8e3s4, initialValue, createZeroVectorFrom(typeConverter, targetValue), typeConverter, label);
          break $l$block;
        }finally {
          Companion_instance.c53(previousSnapshot, newSnapshot, observer);
        }
      }
      var value = tmp$ret$4;
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var transitionAnimation = tmp;
    UpdateInitialAndTargetValues(_this__u8e3s4, transitionAnimation, initialValue, targetValue, animationSpec, $composer_0, 14 & $changed | (8 & $changed >> 3) << 6 | 896 & $changed << 3 | (8 & $changed >> 3) << 9 | 7168 & $changed << 3 | 57344 & $changed << 3);
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid_0 = !!((($changed & 14 ^ 6) > 4 && $composer_0.k31(_this__u8e3s4) || ($changed & 6) === 4) | $composer_0.k31(transitionAnimation));
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_0;
    if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
      var value_0 = createTransitionAnimation$lambda(_this__u8e3s4, transitionAnimation);
      $composer_0.j31(value_0);
      tmp_0 = value_0;
    } else {
      tmp_0 = it_0;
    }
    var tmp$ret$6 = tmp_0;
    DisposableEffect(transitionAnimation, tmp$ret$6, $composer_0, 0);
    return transitionAnimation;
  }
  function UpdateInitialAndTargetValues(_this__u8e3s4, transitionAnimation, initialValue, targetValue, animationSpec, $composer, $changed) {
    _init_properties_Transition_kt__s6zoln();
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(867041821);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(_this__u8e3s4) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(transitionAnimation) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ((($changed & 512) === 0 ? $composer_0.k31(initialValue) : $composer_0.q31(initialValue)) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ((($changed & 4096) === 0 ? $composer_0.k31(targetValue) : $composer_0.q31(targetValue)) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ((($changed & 32768) === 0 ? $composer_0.k31(animationSpec) : $composer_0.q31(animationSpec)) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 9363) === 9362), $dirty & 1)) {
      if (_this__u8e3s4.xep()) {
        transitionAnimation.sep(initialValue, targetValue, animationSpec);
      } else {
        transitionAnimation.qep(targetValue, animationSpec);
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(UpdateInitialAndTargetValues$lambda(_this__u8e3s4, transitionAnimation, initialValue, targetValue, animationSpec, $changed));
    }
  }
  function createDeferredAnimation(_this__u8e3s4, typeConverter, label, $composer, $changed, $default) {
    _init_properties_Transition_kt__s6zoln();
    var label_0 = label;
    var $composer_0 = $composer;
    if (!(($default & 2) === 0))
      label_0 = 'DeferredAnimation';
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = ($changed & 14 ^ 6) > 4 && $composer_0.k31(_this__u8e3s4) || ($changed & 6) === 4;
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      var value = new DeferredAnimation(_this__u8e3s4, typeConverter, label_0);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var lazyAnim = tmp;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid_0 = !!((($changed & 14 ^ 6) > 4 && $composer_0.k31(_this__u8e3s4) || ($changed & 6) === 4) | $composer_0.q31(lazyAnim));
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_0;
    if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
      var value_0 = createDeferredAnimation$lambda(_this__u8e3s4, lazyAnim);
      $composer_0.j31(value_0);
      tmp_0 = value_0;
    } else {
      tmp_0 = it_0;
    }
    var tmp$ret$4 = tmp_0;
    DisposableEffect(lazyAnim, tmp$ret$4, $composer_0, 0);
    if (_this__u8e3s4.xep()) {
      lazyAnim.weq();
    }
    return lazyAnim;
  }
  function rememberTransition(transitionState, label, $composer, $changed, $default) {
    _init_properties_Transition_kt__s6zoln();
    var label_0 = label;
    var $composer_0 = $composer;
    if (!(($default & 2) === 0))
      label_0 = null;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = ($changed & 14 ^ 6) > 4 && $composer_0.k31(transitionState) || ($changed & 6) === 4;
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      var tmp$ret$4;
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
        var previousSnapshot = Companion_instance.p52();
        var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
        var newSnapshot = Companion_instance.q52(previousSnapshot);
        try {
          tmp$ret$4 = Transition_init_$Create$(transitionState, label_0);
          break $l$block;
        }finally {
          Companion_instance.c53(previousSnapshot, newSnapshot, observer);
        }
      }
      var value = tmp$ret$4;
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var transition = tmp;
    if (transitionState instanceof SeekableTransitionState) {
      $composer_0.m30(-1357590553);
      // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
      var getContext = null;
      var $composer_1 = $composer_0;
      if (!((1 & 1) === 0)) {
        getContext = rememberTransition$lambda;
      }
      var composer = $composer_1;
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_0 = $composer_1.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = createCompositionCoroutineScope(getContext(), composer);
        $composer_1.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var coroutineScope = tmp_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_0.q31(coroutineScope) | (($changed & 14 ^ 6) > 4 && $composer_0.k31(transitionState) || ($changed & 6) === 4));
      // Inline function 'kotlin.let' call
      var it_1 = $composer_0.i31();
      var tmp_1;
      if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
        var value_1 = rememberTransition$lambda_0(transitionState, coroutineScope);
        $composer_0.j31(value_1);
        tmp_1 = value_1;
      } else {
        tmp_1 = it_1;
      }
      var tmp$ret$11 = tmp_1;
      DisposableEffect(coroutineScope, tmp$ret$11, $composer_0, 0);
      var tmp_2 = transitionState.v70();
      var tmp_3 = transitionState.o70();
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = ($changed & 14 ^ 6) > 4 && $composer_0.k31(transitionState) || ($changed & 6) === 4;
      // Inline function 'kotlin.let' call
      var it_2 = $composer_0.i31();
      var tmp_4;
      if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = rememberTransition$slambda_0(transitionState, null);
        $composer_0.j31(value_2);
        tmp_4 = value_2;
      } else {
        tmp_4 = it_2;
      }
      var tmp$ret$15 = tmp_4;
      LaunchedEffect_0(tmp_2, tmp_3, tmp$ret$15, $composer_0, 0);
      $composer_0.n30();
    } else {
      $composer_0.m30(-1356604288);
      transition.ner(transitionState.o70(), $composer_0, 0);
      $composer_0.n30();
    }
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid_2 = $composer_0.k31(transition);
    // Inline function 'kotlin.let' call
    var it_3 = $composer_0.i31();
    var tmp_5;
    if (invalid_2 || it_3 === Companion_getInstance().f30_1) {
      var value_3 = rememberTransition$lambda_1(transition);
      $composer_0.j31(value_3);
      tmp_5 = value_3;
    } else {
      tmp_5 = it_3;
    }
    var tmp$ret$19 = tmp_5;
    DisposableEffect(transition, tmp$ret$19, $composer_0, 0);
    return transition;
  }
  function androidx_compose_animation_core_MutableTransitionState$stableprop_getter() {
    return androidx_compose_animation_core_MutableTransitionState$stable;
  }
  function androidx_compose_animation_core_SeekableTransitionState$stableprop_getter() {
    return androidx_compose_animation_core_SeekableTransitionState$stable;
  }
  function updateTransition_0(transitionState, label, $composer, $changed, $default) {
    _init_properties_Transition_kt__s6zoln();
    var label_0 = label;
    var $composer_0 = $composer;
    if (!(($default & 2) === 0))
      label_0 = null;
    var state = transitionState;
    return rememberTransition(state, label_0, $composer_0, 14 & $changed | 112 & $changed, 0);
  }
  function createChildTransitionInternal(_this__u8e3s4, initialState, targetState, childLabel, $composer, $changed) {
    _init_properties_Transition_kt__s6zoln();
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = ($changed & 14 ^ 6) > 4 && $composer_0.k31(_this__u8e3s4) || ($changed & 6) === 4;
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      var value = new Transition(new MutableTransitionState(initialState), _this__u8e3s4, '' + _this__u8e3s4.ueo_1 + ' > ' + childLabel);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var transition = tmp;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid_0 = !!((($changed & 14 ^ 6) > 4 && $composer_0.k31(_this__u8e3s4) || ($changed & 6) === 4) | $composer_0.k31(transition));
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_0;
    if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
      var value_0 = createChildTransitionInternal$lambda(_this__u8e3s4, transition);
      $composer_0.j31(value_0);
      tmp_0 = value_0;
    } else {
      tmp_0 = it_0;
    }
    var tmp$ret$4 = tmp_0;
    DisposableEffect(transition, tmp$ret$4, $composer_0, 0);
    if (_this__u8e3s4.xep()) {
      transition.des(initialState, targetState, _this__u8e3s4.dep_1);
    } else {
      transition.hes(targetState);
      transition.aer(false);
    }
    return transition;
  }
  function SeekableTransitionStateTotalDurationChanged$lambda(it) {
    _init_properties_Transition_kt__s6zoln();
    it.iey();
    return Unit_instance;
  }
  function updateTransition$$inlined$cache$1$1($transition) {
    this.key_1 = $transition;
  }
  protoOf(updateTransition$$inlined$cache$1$1).s1d = function () {
    this.key_1.xer();
  };
  function updateTransition$lambda($transition) {
    return function ($this$DisposableEffect) {
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new updateTransition$$inlined$cache$1$1($transition);
    };
  }
  function createTransitionAnimation$$inlined$cache$1$1($this_createTransitionAnimation, $transitionAnimation) {
    this.ley_1 = $this_createTransitionAnimation;
    this.mey_1 = $transitionAnimation;
  }
  protoOf(createTransitionAnimation$$inlined$cache$1$1).s1d = function () {
    this.ley_1.ges(this.mey_1);
  };
  function createTransitionAnimation$lambda($this_createTransitionAnimation, $transitionAnimation) {
    return function ($this$DisposableEffect) {
      $this_createTransitionAnimation.veq($transitionAnimation);
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new createTransitionAnimation$$inlined$cache$1$1($this_createTransitionAnimation, $transitionAnimation);
    };
  }
  function UpdateInitialAndTargetValues$lambda($this_UpdateInitialAndTargetValues, $transitionAnimation, $initialValue, $targetValue, $animationSpec, $$changed) {
    return function ($composer, $force) {
      UpdateInitialAndTargetValues($this_UpdateInitialAndTargetValues, $transitionAnimation, $initialValue, $targetValue, $animationSpec, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function createDeferredAnimation$$inlined$cache$1$1($this_createDeferredAnimation, $lazyAnim) {
    this.ney_1 = $this_createDeferredAnimation;
    this.oey_1 = $lazyAnim;
  }
  protoOf(createDeferredAnimation$$inlined$cache$1$1).s1d = function () {
    this.ney_1.nes(this.oey_1);
  };
  function createDeferredAnimation$lambda($this_createDeferredAnimation, $lazyAnim) {
    return function ($this$DisposableEffect) {
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new createDeferredAnimation$$inlined$cache$1$1($this_createDeferredAnimation, $lazyAnim);
    };
  }
  function rememberTransition$lambda() {
    _init_properties_Transition_kt__s6zoln();
    return EmptyCoroutineContext_getInstance();
  }
  function rememberTransition$lambda$lambda$slambda($it, resultContinuation) {
    this.xey_1 = $it;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rememberTransition$lambda$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(rememberTransition$lambda$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rememberTransition$lambda$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.xey_1();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(rememberTransition$lambda$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new rememberTransition$lambda$lambda$slambda(this.xey_1, completion);
    i.yey_1 = $this$launch;
    return i;
  };
  function rememberTransition$lambda$lambda$slambda_0($it, resultContinuation) {
    var i = new rememberTransition$lambda$lambda$slambda($it, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function rememberTransition$lambda$lambda($thread, $coroutineScope) {
    return function (it) {
      if ($thread === getCurrentThread()) {
        it();
      } else {
        launch($coroutineScope, VOID, VOID, rememberTransition$lambda$lambda$slambda_0(it, null));
      }
      return Unit_instance;
    };
  }
  function rememberTransition$$inlined$cache$1$2($transitionState) {
    this.zey_1 = $transitionState;
  }
  protoOf(rememberTransition$$inlined$cache$1$2).s1d = function () {
    this.zey_1.bey(null);
  };
  function rememberTransition$lambda_0($transitionState, $coroutineScope) {
    return function ($this$DisposableEffect) {
      var thread = getCurrentThread();
      var snapshotStateObserver = new SnapshotStateObserver(rememberTransition$lambda$lambda(thread, $coroutineScope));
      $transitionState.bey(snapshotStateObserver);
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new rememberTransition$$inlined$cache$1$2($transitionState);
    };
  }
  function rememberTransition$slambda($transitionState, resultContinuation) {
    this.iez_1 = $transitionState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rememberTransition$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(rememberTransition$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rememberTransition$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.iez_1.cey();
            this.lez_1 = this.iez_1.wet_1;
            this.kez_1 = null;
            this.n9_1 = 1;
            suspendResult = this.lez_1.o2u(this.kez_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            l$ret$1: do {
              var tmp_0;
              try {
                this.iez_1.pet_1 = this.iez_1.o70();
                var tmp0_safe_receiver = this.iez_1.vet_1;
                if (tmp0_safe_receiver == null)
                  null;
                else {
                  var value = this.iez_1.o70();
                  tmp0_safe_receiver.y9(_Result___init__impl__xyqfz8(value));
                }
                this.iez_1.vet_1 = null;
                break l$ret$1;
              } catch ($p) {
                var tmp_1;
                var t = $p;
                this.lez_1.q2u(this.kez_1);
                throw t;
              }
            }
             while (false);
            this.lez_1.q2u(this.kez_1);
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p_0) {
        var e = $p_0;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(rememberTransition$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new rememberTransition$slambda(this.iez_1, completion);
    i.jez_1 = $this$LaunchedEffect;
    return i;
  };
  function rememberTransition$slambda_0($transitionState, resultContinuation) {
    var i = new rememberTransition$slambda($transitionState, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function rememberTransition$$inlined$cache$3$1($transition) {
    this.mez_1 = $transition;
  }
  protoOf(rememberTransition$$inlined$cache$3$1).s1d = function () {
    this.mez_1.xer();
  };
  function rememberTransition$lambda_1($transition) {
    return function ($this$DisposableEffect) {
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new rememberTransition$$inlined$cache$3$1($transition);
    };
  }
  function createChildTransitionInternal$$inlined$cache$1$1($this_createChildTransitionInternal, $transition) {
    this.nez_1 = $this_createChildTransitionInternal;
    this.oez_1 = $transition;
  }
  protoOf(createChildTransitionInternal$$inlined$cache$1$1).s1d = function () {
    this.nez_1.fes(this.oez_1);
  };
  function createChildTransitionInternal$lambda($this_createChildTransitionInternal, $transition) {
    return function ($this$DisposableEffect) {
      $this_createChildTransitionInternal.ees($transition);
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new createChildTransitionInternal$$inlined$cache$1$1($this_createChildTransitionInternal, $transition);
    };
  }
  var properties_initialized_Transition_kt_wb2qvd;
  function _init_properties_Transition_kt__s6zoln() {
    if (!properties_initialized_Transition_kt_wb2qvd) {
      properties_initialized_Transition_kt_wb2qvd = true;
      SeekableTransitionStateTotalDurationChanged = SeekableTransitionStateTotalDurationChanged$lambda;
      androidx_compose_animation_core_TransitionState$stable = 0;
      androidx_compose_animation_core_MutableTransitionState$stable = 0;
      androidx_compose_animation_core_SeekableTransitionState_SeekingAnimationState$stable = 8;
      androidx_compose_animation_core_SeekableTransitionState$stable = 8;
      androidx_compose_animation_core_Transition$stable = 0;
    }
  }
  function get_FloatToVector() {
    _init_properties_VectorConverters_kt__g28mmu();
    return FloatToVector;
  }
  var FloatToVector;
  function get_IntToVector() {
    _init_properties_VectorConverters_kt__g28mmu();
    return IntToVector;
  }
  var IntToVector;
  function get_DpToVector() {
    _init_properties_VectorConverters_kt__g28mmu();
    return DpToVector;
  }
  var DpToVector;
  function get_DpOffsetToVector() {
    _init_properties_VectorConverters_kt__g28mmu();
    return DpOffsetToVector;
  }
  var DpOffsetToVector;
  function get_SizeToVector() {
    _init_properties_VectorConverters_kt__g28mmu();
    return SizeToVector;
  }
  var SizeToVector;
  function get_OffsetToVector() {
    _init_properties_VectorConverters_kt__g28mmu();
    return OffsetToVector;
  }
  var OffsetToVector;
  function get_IntOffsetToVector() {
    _init_properties_VectorConverters_kt__g28mmu();
    return IntOffsetToVector;
  }
  var IntOffsetToVector;
  function get_IntSizeToVector() {
    _init_properties_VectorConverters_kt__g28mmu();
    return IntSizeToVector;
  }
  var IntSizeToVector;
  function get_RectToVector() {
    _init_properties_VectorConverters_kt__g28mmu();
    return RectToVector;
  }
  var RectToVector;
  function TwoWayConverter(convertToVector, convertFromVector) {
    _init_properties_VectorConverters_kt__g28mmu();
    return new TwoWayConverterImpl(convertToVector, convertFromVector);
  }
  function get_VectorConverter(_this__u8e3s4) {
    _init_properties_VectorConverters_kt__g28mmu();
    return get_FloatToVector();
  }
  function get_VectorConverter_0(_this__u8e3s4) {
    _init_properties_VectorConverters_kt__g28mmu();
    return get_DpToVector();
  }
  function TwoWayConverterImpl(convertToVector, convertFromVector) {
    this.pez_1 = convertToVector;
    this.qez_1 = convertFromVector;
  }
  protoOf(TwoWayConverterImpl).lea = function () {
    return this.pez_1;
  };
  protoOf(TwoWayConverterImpl).pea = function () {
    return this.qez_1;
  };
  function get_VectorConverter_1(_this__u8e3s4) {
    _init_properties_VectorConverters_kt__g28mmu();
    return get_IntToVector();
  }
  function get_VectorConverter_2(_this__u8e3s4) {
    _init_properties_VectorConverters_kt__g28mmu();
    return get_IntSizeToVector();
  }
  function get_VectorConverter_3(_this__u8e3s4) {
    _init_properties_VectorConverters_kt__g28mmu();
    return get_IntOffsetToVector();
  }
  function get_VectorConverter_4(_this__u8e3s4) {
    _init_properties_VectorConverters_kt__g28mmu();
    return get_RectToVector();
  }
  function get_VectorConverter_5(_this__u8e3s4) {
    _init_properties_VectorConverters_kt__g28mmu();
    return get_SizeToVector();
  }
  function get_VectorConverter_6(_this__u8e3s4) {
    _init_properties_VectorConverters_kt__g28mmu();
    return get_OffsetToVector();
  }
  function get_VectorConverter_7(_this__u8e3s4) {
    _init_properties_VectorConverters_kt__g28mmu();
    return get_DpOffsetToVector();
  }
  function FloatToVector$lambda(it) {
    _init_properties_VectorConverters_kt__g28mmu();
    return new AnimationVector1D(it);
  }
  function FloatToVector$lambda_0(it) {
    _init_properties_VectorConverters_kt__g28mmu();
    return it.jeg_1;
  }
  function IntToVector$lambda(it) {
    _init_properties_VectorConverters_kt__g28mmu();
    return new AnimationVector1D(it);
  }
  function IntToVector$lambda_0(it) {
    _init_properties_VectorConverters_kt__g28mmu();
    return numberToInt(it.jeg_1);
  }
  function DpToVector$lambda(it) {
    _init_properties_VectorConverters_kt__g28mmu();
    return new AnimationVector1D(_Dp___get_value__impl__geb1vb(it.m5f_1));
  }
  function DpToVector$lambda_0(it) {
    _init_properties_VectorConverters_kt__g28mmu();
    return new Dp(_Dp___init__impl__ms3zkb(it.jeg_1));
  }
  function DpOffsetToVector$lambda(it) {
    _init_properties_VectorConverters_kt__g28mmu();
    return new AnimationVector2D(_Dp___get_value__impl__geb1vb(_DpOffset___get_x__impl__uauqb5(it.v5f_1)), _Dp___get_value__impl__geb1vb(_DpOffset___get_y__impl__1h898y(it.v5f_1)));
  }
  function DpOffsetToVector$lambda_0(it) {
    _init_properties_VectorConverters_kt__g28mmu();
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = it.reg_1;
    var tmp0 = _Dp___init__impl__ms3zkb(this_0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_1 = it.seg_1;
    // Inline function 'androidx.compose.ui.unit.DpOffset' call
    var y = _Dp___init__impl__ms3zkb(this_1);
    var tmp0_0 = _Dp___get_value__impl__geb1vb(tmp0);
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = _Dp___get_value__impl__geb1vb(y);
    var v1 = fromInt(toRawBits_0(tmp0_0));
    var v2 = fromInt(toRawBits_0(val2));
    var tmp$ret$3 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp$ret$2 = _DpOffset___init__impl__yq36wy(tmp$ret$3);
    return new DpOffset(tmp$ret$2);
  }
  function SizeToVector$lambda(it) {
    _init_properties_VectorConverters_kt__g28mmu();
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    var this_0 = it.l5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o(this_0);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    var this_1 = it.l5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Size___get_packedValue__impl__7rlt1o(this_1);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp$ret$4 = floatFromBits(bits_0);
    return new AnimationVector2D(tmp, tmp$ret$4);
  }
  function SizeToVector$lambda_0(it) {
    _init_properties_VectorConverters_kt__g28mmu();
    var tmp0 = it.reg_1;
    // Inline function 'androidx.compose.ui.geometry.Size' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = it.seg_1;
    var v1 = fromInt(toRawBits_0(tmp0));
    var v2 = fromInt(toRawBits_0(val2));
    var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp$ret$0 = _Size___init__impl__aywn0g(tmp$ret$1);
    return new Size(tmp$ret$0);
  }
  function OffsetToVector$lambda(it) {
    _init_properties_VectorConverters_kt__g28mmu();
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    var this_0 = it.e5d_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(this_0);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    var this_1 = it.e5d_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(this_1);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp$ret$4 = floatFromBits(bits_0);
    return new AnimationVector2D(tmp, tmp$ret$4);
  }
  function OffsetToVector$lambda_0(it) {
    _init_properties_VectorConverters_kt__g28mmu();
    var tmp0 = it.reg_1;
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = it.seg_1;
    var v1 = fromInt(toRawBits_0(tmp0));
    var v2 = fromInt(toRawBits_0(val2));
    var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp$ret$0 = _Offset___init__impl__c168vi(tmp$ret$1);
    return new Offset(tmp$ret$0);
  }
  function IntOffsetToVector$lambda(it) {
    _init_properties_VectorConverters_kt__g28mmu();
    return new AnimationVector2D(_IntOffset___get_x__impl__qiqr5o(it.a5g_1), _IntOffset___get_y__impl__2avpwj(it.a5g_1));
  }
  function IntOffsetToVector$lambda_0(it) {
    _init_properties_VectorConverters_kt__g28mmu();
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_0 = it.reg_1;
    var tmp;
    if (isNaN_0(this_0)) {
      tmp = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp = roundToInt(this_0);
    }
    var tmp0 = tmp;
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_1 = it.seg_1;
    var tmp_0;
    if (isNaN_0(this_1)) {
      tmp_0 = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp_0 = roundToInt(this_1);
    }
    // Inline function 'androidx.compose.ui.unit.IntOffset' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = tmp_0;
    var tmp$ret$5 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    var tmp$ret$4 = _IntOffset___init__impl__rq8h7b(tmp$ret$5);
    return new IntOffset(tmp$ret$4);
  }
  function IntSizeToVector$lambda(it) {
    _init_properties_VectorConverters_kt__g28mmu();
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    var this_0 = it.o5g_1;
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
    var tmp = convertToInt(shiftRight(value, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    var this_1 = it.o5g_1;
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
    var tmp$ret$2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    return new AnimationVector2D(tmp, tmp$ret$2);
  }
  function IntSizeToVector$lambda_0(it) {
    _init_properties_VectorConverters_kt__g28mmu();
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_0 = it.reg_1;
    var tmp;
    if (isNaN_0(this_0)) {
      tmp = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp = roundToInt(this_0);
    }
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var this_1 = tmp;
    var tmp0 = this_1 < 0 ? 0 : this_1;
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_2 = it.seg_1;
    var tmp_0;
    if (isNaN_0(this_2)) {
      tmp_0 = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp_0 = roundToInt(this_2);
    }
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var this_3 = tmp_0;
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = this_3 < 0 ? 0 : this_3;
    var tmp$ret$7 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    var tmp$ret$6 = _IntSize___init__impl__emcjft(tmp$ret$7);
    return new IntSize(tmp$ret$6);
  }
  function RectToVector$lambda(it) {
    _init_properties_VectorConverters_kt__g28mmu();
    return new AnimationVector4D(it.k5d_1, it.l5d_1, it.m5d_1, it.n5d_1);
  }
  function RectToVector$lambda_0(it) {
    _init_properties_VectorConverters_kt__g28mmu();
    return new Rect(it.leg_1, it.meg_1, it.neg_1, it.oeg_1);
  }
  var properties_initialized_VectorConverters_kt_cg0a6g;
  function _init_properties_VectorConverters_kt__g28mmu() {
    if (!properties_initialized_VectorConverters_kt_cg0a6g) {
      properties_initialized_VectorConverters_kt_cg0a6g = true;
      var tmp = FloatToVector$lambda;
      FloatToVector = TwoWayConverter(tmp, FloatToVector$lambda_0);
      var tmp_0 = IntToVector$lambda;
      IntToVector = TwoWayConverter(tmp_0, IntToVector$lambda_0);
      var tmp_1 = DpToVector$lambda;
      DpToVector = TwoWayConverter(tmp_1, DpToVector$lambda_0);
      var tmp_2 = DpOffsetToVector$lambda;
      DpOffsetToVector = TwoWayConverter(tmp_2, DpOffsetToVector$lambda_0);
      var tmp_3 = SizeToVector$lambda;
      SizeToVector = TwoWayConverter(tmp_3, SizeToVector$lambda_0);
      var tmp_4 = OffsetToVector$lambda;
      OffsetToVector = TwoWayConverter(tmp_4, OffsetToVector$lambda_0);
      var tmp_5 = IntOffsetToVector$lambda;
      IntOffsetToVector = TwoWayConverter(tmp_5, IntOffsetToVector$lambda_0);
      var tmp_6 = IntSizeToVector$lambda;
      IntSizeToVector = TwoWayConverter(tmp_6, IntSizeToVector$lambda_0);
      var tmp_7 = RectToVector$lambda;
      RectToVector = TwoWayConverter(tmp_7, RectToVector$lambda_0);
    }
  }
  function get_EmptyIntArray() {
    _init_properties_VectorizedAnimationSpec_kt__qefgpy();
    return EmptyIntArray;
  }
  var EmptyIntArray;
  function get_EmptyFloatArray() {
    _init_properties_VectorizedAnimationSpec_kt__qefgpy();
    return EmptyFloatArray;
  }
  var EmptyFloatArray;
  function get_EmptyArcSpline() {
    _init_properties_VectorizedAnimationSpec_kt__qefgpy();
    return EmptyArcSpline;
  }
  var EmptyArcSpline;
  var androidx_compose_animation_core_VectorizedKeyframesSpec$stable;
  var androidx_compose_animation_core_VectorizedKeyframeSpecElementInfo$stable;
  var androidx_compose_animation_core_VectorizedSnapSpec$stable;
  var androidx_compose_animation_core_VectorizedInfiniteRepeatableSpec$stable;
  var androidx_compose_animation_core_VectorizedRepeatableSpec$stable;
  var androidx_compose_animation_core_Spring$stable;
  var androidx_compose_animation_core_VectorizedSpringSpec$stable;
  var androidx_compose_animation_core_VectorizedTweenSpec$stable;
  var androidx_compose_animation_core_VectorizedFloatAnimationSpec$stable;
  function VectorizedAnimationSpec() {
  }
  function VectorizedSpringSpec_init_$Init$(dampingRatio, stiffness, visibilityThreshold, $this) {
    dampingRatio = dampingRatio === VOID ? 1.0 : dampingRatio;
    stiffness = stiffness === VOID ? 1500.0 : stiffness;
    visibilityThreshold = visibilityThreshold === VOID ? null : visibilityThreshold;
    VectorizedSpringSpec.call($this, dampingRatio, stiffness, createSpringAnimations(visibilityThreshold, dampingRatio, stiffness));
    return $this;
  }
  function VectorizedSpringSpec_init_$Create$(dampingRatio, stiffness, visibilityThreshold) {
    return VectorizedSpringSpec_init_$Init$(dampingRatio, stiffness, visibilityThreshold, objectCreate(protoOf(VectorizedSpringSpec)));
  }
  function VectorizedSpringSpec(dampingRatio, stiffness, anims) {
    this.rez_1 = new VectorizedFloatAnimationSpec(anims);
    this.sez_1 = dampingRatio;
    this.tez_1 = stiffness;
  }
  protoOf(VectorizedSpringSpec).fee = function () {
    return this.rez_1.fee();
  };
  protoOf(VectorizedSpringSpec).hee = function (playTimeNanos, initialValue, targetValue, initialVelocity) {
    return this.rez_1.hee(playTimeNanos, initialValue, targetValue, initialVelocity);
  };
  protoOf(VectorizedSpringSpec).mee = function (playTimeNanos, initialValue, targetValue, initialVelocity) {
    return this.rez_1.mee(playTimeNanos, initialValue, targetValue, initialVelocity);
  };
  protoOf(VectorizedSpringSpec).kee = function (initialValue, targetValue, initialVelocity) {
    return this.rez_1.kee(initialValue, targetValue, initialVelocity);
  };
  protoOf(VectorizedSpringSpec).aee = function (initialValue, targetValue, initialVelocity) {
    return this.rez_1.aee(initialValue, targetValue, initialVelocity);
  };
  function VectorizedFiniteAnimationSpec() {
  }
  function VectorizedTweenSpec(durationMillis, delayMillis, easing) {
    durationMillis = durationMillis === VOID ? 300 : durationMillis;
    delayMillis = delayMillis === VOID ? 0 : delayMillis;
    easing = easing === VOID ? get_FastOutSlowInEasing() : easing;
    this.yez_1 = durationMillis;
    this.zez_1 = delayMillis;
    this.af0_1 = easing;
    this.bf0_1 = VectorizedFloatAnimationSpec_init_$Create$(new FloatTweenSpec(this.yez_1, this.zez_1, this.af0_1));
  }
  protoOf(VectorizedTweenSpec).cf0 = function () {
    return this.yez_1;
  };
  protoOf(VectorizedTweenSpec).df0 = function () {
    return this.zez_1;
  };
  protoOf(VectorizedTweenSpec).hee = function (playTimeNanos, initialValue, targetValue, initialVelocity) {
    return this.bf0_1.hee(playTimeNanos, initialValue, targetValue, initialVelocity);
  };
  protoOf(VectorizedTweenSpec).mee = function (playTimeNanos, initialValue, targetValue, initialVelocity) {
    return this.bf0_1.mee(playTimeNanos, initialValue, targetValue, initialVelocity);
  };
  function VectorizedDurationBasedAnimationSpec() {
  }
  function VectorizedSnapSpec(delayMillis) {
    delayMillis = delayMillis === VOID ? 0 : delayMillis;
    this.ef0_1 = delayMillis;
  }
  protoOf(VectorizedSnapSpec).df0 = function () {
    return this.ef0_1;
  };
  protoOf(VectorizedSnapSpec).hee = function (playTimeNanos, initialValue, targetValue, initialVelocity) {
    var tmp;
    if (compare(playTimeNanos, multiply(numberToLong(this.ef0_1), new Long(1000000, 0))) < 0) {
      tmp = initialValue;
    } else {
      tmp = targetValue;
    }
    return tmp;
  };
  protoOf(VectorizedSnapSpec).mee = function (playTimeNanos, initialValue, targetValue, initialVelocity) {
    return initialVelocity;
  };
  protoOf(VectorizedSnapSpec).cf0 = function () {
    return 0;
  };
  function _get_valueVector__r10idf_0($this) {
    var tmp = $this.vez_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('valueVector');
    }
  }
  function _get_velocityVector__dvxlkl_0($this) {
    var tmp = $this.wez_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('velocityVector');
    }
  }
  function _get_endVelocityVector__l8kbka($this) {
    var tmp = $this.xez_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('endVelocityVector');
    }
  }
  function VectorizedFloatAnimationSpec_init_$Init$(anim, $this) {
    VectorizedFloatAnimationSpec.call($this, new VectorizedFloatAnimationSpec$1(anim));
    return $this;
  }
  function VectorizedFloatAnimationSpec_init_$Create$(anim) {
    return VectorizedFloatAnimationSpec_init_$Init$(anim, objectCreate(protoOf(VectorizedFloatAnimationSpec)));
  }
  function VectorizedFloatAnimationSpec$1($anim) {
    this.ff0_1 = $anim;
  }
  protoOf(VectorizedFloatAnimationSpec$1).l1 = function (index) {
    return this.ff0_1;
  };
  function VectorizedFloatAnimationSpec(anims) {
    this.uez_1 = anims;
  }
  protoOf(VectorizedFloatAnimationSpec).hee = function (playTimeNanos, initialValue, targetValue, initialVelocity) {
    if (!!(this.vez_1 == null)) {
      this.vez_1 = newInstance(initialValue);
    }
    var inductionVariable = 0;
    var last = _get_valueVector__r10idf_0(this).mea();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        _get_valueVector__r10idf_0(this).oea(i, this.uez_1.l1(i).xei(playTimeNanos, initialValue.nea(i), targetValue.nea(i), initialVelocity.nea(i)));
      }
       while (inductionVariable < last);
    return _get_valueVector__r10idf_0(this);
  };
  protoOf(VectorizedFloatAnimationSpec).mee = function (playTimeNanos, initialValue, targetValue, initialVelocity) {
    if (!!(this.wez_1 == null)) {
      this.wez_1 = newInstance(initialVelocity);
    }
    var inductionVariable = 0;
    var last = _get_velocityVector__dvxlkl_0(this).mea();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        _get_velocityVector__dvxlkl_0(this).oea(i, this.uez_1.l1(i).zei(playTimeNanos, initialValue.nea(i), targetValue.nea(i), initialVelocity.nea(i)));
      }
       while (inductionVariable < last);
    return _get_velocityVector__dvxlkl_0(this);
  };
  protoOf(VectorizedFloatAnimationSpec).aee = function (initialValue, targetValue, initialVelocity) {
    if (!!(this.xez_1 == null)) {
      this.xez_1 = newInstance(initialVelocity);
    }
    var inductionVariable = 0;
    var last = _get_endVelocityVector__l8kbka(this).mea();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        _get_endVelocityVector__l8kbka(this).oea(i, this.uez_1.l1(i).aej(initialValue.nea(i), targetValue.nea(i), initialVelocity.nea(i)));
      }
       while (inductionVariable < last);
    return _get_endVelocityVector__l8kbka(this);
  };
  protoOf(VectorizedFloatAnimationSpec).kee = function (initialValue, targetValue, initialVelocity) {
    var maxDuration = new Long(0, 0);
    var inductionVariable = 0;
    var last = initialValue.mea();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0 = maxDuration;
        // Inline function 'kotlin.comparisons.maxOf' call
        var b = this.uez_1.l1(i).yei(initialValue.nea(i), targetValue.nea(i), initialVelocity.nea(i));
        maxDuration = compare(tmp0, b) >= 0 ? tmp0 : b;
      }
       while (inductionVariable < last);
    return maxDuration;
  };
  function createSpringAnimations(visibilityThreshold, dampingRatio, stiffness) {
    _init_properties_VectorizedAnimationSpec_kt__qefgpy();
    var tmp;
    if (!(visibilityThreshold == null)) {
      tmp = new createSpringAnimations$1(visibilityThreshold, dampingRatio, stiffness);
    } else {
      tmp = new createSpringAnimations$2(dampingRatio, stiffness);
    }
    return tmp;
  }
  function _ArcMode___init__impl__iiwx98(value) {
    return value;
  }
  function _ArcMode___get_value__impl__j60x0o($this) {
    return $this;
  }
  function Companion_1() {
    Companion_instance_3 = this;
    this.yef_1 = _ArcMode___init__impl__iiwx98(5);
    this.zef_1 = _ArcMode___init__impl__iiwx98(4);
    this.aeg_1 = _ArcMode___init__impl__iiwx98(0);
  }
  var Companion_instance_3;
  function Companion_getInstance_9() {
    if (Companion_instance_3 == null)
      new Companion_1();
    return Companion_instance_3;
  }
  function ArcMode__toString_impl_wsn638($this) {
    return 'ArcMode(value=' + $this + ')';
  }
  function ArcMode__hashCode_impl_ghaz31($this) {
    return $this;
  }
  function ArcMode__equals_impl_alzc5j($this, other) {
    if (!(other instanceof ArcMode))
      return false;
    if (!($this === other.gf0_1))
      return false;
    return true;
  }
  function ArcMode(value) {
    Companion_getInstance_9();
    this.gf0_1 = value;
  }
  protoOf(ArcMode).toString = function () {
    return ArcMode__toString_impl_wsn638(this.gf0_1);
  };
  protoOf(ArcMode).hashCode = function () {
    return ArcMode__hashCode_impl_ghaz31(this.gf0_1);
  };
  protoOf(ArcMode).equals = function (other) {
    return ArcMode__equals_impl_alzc5j(this.gf0_1, other);
  };
  function repetitionPlayTimeNanos($this, playTimeNanos) {
    if (compare(add(playTimeNanos, $this.kf0_1), new Long(0, 0)) <= 0) {
      return new Long(0, 0);
    } else {
      var postOffsetPlayTimeNanos = add(playTimeNanos, $this.kf0_1);
      var repeatsCount = divide(postOffsetPlayTimeNanos, $this.jf0_1);
      var tmp;
      if ($this.if0_1.equals(RepeatMode_Restart_getInstance())) {
        tmp = true;
      } else {
        // Inline function 'kotlin.Long.rem' call
        var tmp$ret$0 = modulo(repeatsCount, fromInt(2));
        tmp = equalsLong(tmp$ret$0, new Long(0, 0));
      }
      if (tmp) {
        return subtract(postOffsetPlayTimeNanos, multiply(repeatsCount, $this.jf0_1));
      } else {
        // Inline function 'kotlin.Long.plus' call
        var tmp$ret$1 = add(repeatsCount, fromInt(1));
        return subtract(multiply(tmp$ret$1, $this.jf0_1), postOffsetPlayTimeNanos);
      }
    }
  }
  function repetitionStartVelocity($this, playTimeNanos, start, startVelocity, end) {
    var tmp;
    if (compare(add(playTimeNanos, $this.kf0_1), $this.jf0_1) > 0) {
      tmp = $this.hf0_1.mee(subtract($this.jf0_1, $this.kf0_1), start, end, startVelocity);
    } else {
      tmp = startVelocity;
    }
    return tmp;
  }
  function VectorizedInfiniteRepeatableSpec(animation, repeatMode, initialStartOffset) {
    repeatMode = repeatMode === VOID ? RepeatMode_Restart_getInstance() : repeatMode;
    initialStartOffset = initialStartOffset === VOID ? _StartOffset___init__impl__615djw_0(0) : initialStartOffset;
    this.hf0_1 = animation;
    this.if0_1 = repeatMode;
    this.jf0_1 = multiply(numberToLong(this.hf0_1.df0() + this.hf0_1.cf0() | 0), new Long(1000000, 0));
    this.kf0_1 = multiply(_StartOffset___get_value__impl__8sikig(initialStartOffset), new Long(1000000, 0));
  }
  protoOf(VectorizedInfiniteRepeatableSpec).fee = function () {
    return true;
  };
  protoOf(VectorizedInfiniteRepeatableSpec).hee = function (playTimeNanos, initialValue, targetValue, initialVelocity) {
    return this.hf0_1.hee(repetitionPlayTimeNanos(this, playTimeNanos), initialValue, targetValue, repetitionStartVelocity(this, playTimeNanos, initialValue, initialVelocity, targetValue));
  };
  protoOf(VectorizedInfiniteRepeatableSpec).mee = function (playTimeNanos, initialValue, targetValue, initialVelocity) {
    return this.hf0_1.mee(repetitionPlayTimeNanos(this, playTimeNanos), initialValue, targetValue, repetitionStartVelocity(this, playTimeNanos, initialValue, initialVelocity, targetValue));
  };
  protoOf(VectorizedInfiniteRepeatableSpec).kee = function (initialValue, targetValue, initialVelocity) {
    return new Long(-1, 2147483647);
  };
  function init($this, initialValue, targetValue, initialVelocity) {
    var requiresArcSpline = {_v: !($this.zf0_1 === get_EmptyArcSpline())};
    if ($this.tf0_1 == null) {
      $this.tf0_1 = newInstance(initialValue);
      $this.uf0_1 = newInstance(initialVelocity);
      var tmp = $this;
      var tmp_0 = 0;
      // Inline function 'androidx.collection.IntList.size' call
      var tmp_1 = $this.lf0_1.jv_1;
      var tmp_2 = new Float32Array(tmp_1);
      while (tmp_0 < tmp_1) {
        var tmp_3 = tmp_0;
        tmp_2[tmp_3] = $this.lf0_1.l1(tmp_3) / toNumber(new Long(1000, 0));
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp.sf0_1 = tmp_2;
      var tmp_4 = $this;
      var tmp_5 = 0;
      // Inline function 'androidx.collection.IntList.size' call
      var tmp_6 = $this.lf0_1.jv_1;
      var tmp_7 = new Int32Array(tmp_6);
      while (tmp_5 < tmp_6) {
        var tmp_8 = tmp_5;
        var tmp0_safe_receiver = $this.mf0_1.l1($this.lf0_1.l1(tmp_8));
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cf1_1;
        var tmp_9;
        var tmp_10 = tmp1_elvis_lhs;
        if ((tmp_10 == null ? null : new ArcMode(tmp_10)) == null) {
          tmp_9 = $this.qf0_1;
        } else {
          tmp_9 = tmp1_elvis_lhs;
        }
        var mode = tmp_9;
        if (!(mode === Companion_getInstance_9().aeg_1)) {
          requiresArcSpline._v = true;
        }
        tmp_7[tmp_8] = _ArcMode___get_value__impl__j60x0o(mode);
        tmp_5 = tmp_5 + 1 | 0;
      }
      tmp_4.rf0_1 = tmp_7;
    }
    if (!requiresArcSpline._v) {
      return Unit_instance;
    }
    if ($this.zf0_1 === get_EmptyArcSpline() || !equals($this.vf0_1, initialValue) || !equals($this.wf0_1, targetValue)) {
      $this.vf0_1 = initialValue;
      $this.wf0_1 = targetValue;
      var dimensionCount = (initialValue.mea() % 2 | 0) + initialValue.mea() | 0;
      $this.xf0_1 = new Float32Array(dimensionCount);
      $this.yf0_1 = new Float32Array(dimensionCount);
      var tmp_11 = 0;
      // Inline function 'androidx.collection.IntList.size' call
      var tmp_12 = $this.lf0_1.jv_1;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_13 = Array(tmp_12);
      while (tmp_11 < tmp_12) {
        var tmp_14 = tmp_11;
        var timestamp = $this.lf0_1.l1(tmp_14);
        var info = $this.mf0_1.l1(timestamp);
        var tmp_15;
        if (timestamp === 0 && info == null) {
          var tmp_16 = 0;
          var tmp_17 = new Float32Array(dimensionCount);
          while (tmp_16 < dimensionCount) {
            var tmp_18 = tmp_16;
            tmp_17[tmp_18] = initialValue.nea(tmp_18);
            tmp_16 = tmp_16 + 1 | 0;
          }
          tmp_15 = tmp_17;
        } else if (timestamp === $this.nf0_1 && info == null) {
          var tmp_19 = 0;
          var tmp_20 = new Float32Array(dimensionCount);
          while (tmp_19 < dimensionCount) {
            var tmp_21 = tmp_19;
            tmp_20[tmp_21] = targetValue.nea(tmp_21);
            tmp_19 = tmp_19 + 1 | 0;
          }
          tmp_15 = tmp_20;
        } else {
          var vectorValue = ensureNotNull(info).af1_1;
          var tmp_22 = 0;
          var tmp_23 = new Float32Array(dimensionCount);
          while (tmp_22 < dimensionCount) {
            var tmp_24 = tmp_22;
            tmp_23[tmp_24] = vectorValue.nea(tmp_24);
            tmp_22 = tmp_22 + 1 | 0;
          }
          tmp_15 = tmp_23;
        }
        tmp_13[tmp_14] = tmp_15;
        tmp_11 = tmp_11 + 1 | 0;
      }
      var values = tmp_13;
      $this.zf0_1 = new ArcSpline($this.rf0_1, $this.sf0_1, values);
    }
  }
  function getEasedTime($this, timeMillis) {
    var index = findEntryForTimeMillis($this, timeMillis);
    return getEasedTimeFromIndex($this, index, timeMillis, false);
  }
  function getEasedTimeFromIndex($this, index, timeMillis, asFraction) {
    // Inline function 'androidx.collection.IntList.lastIndex' call
    if (index >= ($this.lf0_1.jv_1 - 1 | 0)) {
      return timeMillis / toNumber(new Long(1000, 0));
    }
    var timeMin = $this.lf0_1.l1(index);
    var timeMax = $this.lf0_1.l1(index + 1 | 0);
    if (timeMillis === timeMin) {
      return timeMin / toNumber(new Long(1000, 0));
    }
    var timeRange = timeMax - timeMin | 0;
    var tmp0_safe_receiver = $this.mf0_1.l1(timeMin);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bf1_1;
    var easing = tmp1_elvis_lhs == null ? $this.pf0_1 : tmp1_elvis_lhs;
    var rawFraction = (timeMillis - timeMin | 0) / timeRange;
    var easedFraction = easing.kei(rawFraction);
    if (asFraction) {
      return easedFraction;
    }
    return (timeRange * easedFraction + timeMin) / toNumber(new Long(1000, 0));
  }
  function findEntryForTimeMillis($this, timeMillis) {
    var index = $this.lf0_1.lv(timeMillis);
    return index < -1 ? -(index + 2 | 0) | 0 : index;
  }
  function VectorizedKeyframesSpec(timestamps, keyframes, durationMillis, delayMillis, defaultEasing, initialArcMode) {
    this.lf0_1 = timestamps;
    this.mf0_1 = keyframes;
    this.nf0_1 = durationMillis;
    this.of0_1 = delayMillis;
    this.pf0_1 = defaultEasing;
    this.qf0_1 = initialArcMode;
    this.rf0_1 = get_EmptyIntArray();
    this.sf0_1 = get_EmptyFloatArray();
    this.tf0_1 = null;
    this.uf0_1 = null;
    this.vf0_1 = null;
    this.wf0_1 = null;
    this.xf0_1 = get_EmptyFloatArray();
    this.yf0_1 = get_EmptyFloatArray();
    this.zf0_1 = get_EmptyArcSpline();
  }
  protoOf(VectorizedKeyframesSpec).cf0 = function () {
    return this.nf0_1;
  };
  protoOf(VectorizedKeyframesSpec).df0 = function () {
    return this.of0_1;
  };
  protoOf(VectorizedKeyframesSpec).hee = function (playTimeNanos, initialValue, targetValue, initialVelocity) {
    var playTimeMillis = divide(playTimeNanos, new Long(1000000, 0));
    var clampedPlayTime = convertToInt(clampPlayTime(this, playTimeMillis));
    var keyframe = this.mf0_1.l1(clampedPlayTime);
    if (!(keyframe == null)) {
      return keyframe.af1_1;
    }
    if (clampedPlayTime >= this.nf0_1) {
      return targetValue;
    } else if (clampedPlayTime <= 0) {
      return initialValue;
    }
    init(this, initialValue, targetValue, initialVelocity);
    var valueVector = ensureNotNull(this.tf0_1);
    if (!(this.zf0_1 === get_EmptyArcSpline())) {
      var easedTime = getEasedTime(this, clampedPlayTime);
      var posArray = this.xf0_1;
      this.zf0_1.yeh(easedTime, posArray);
      var inductionVariable = 0;
      var last = posArray.length - 1 | 0;
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          valueVector.oea(i, posArray[i]);
        }
         while (inductionVariable <= last);
      return valueVector;
    }
    var index = findEntryForTimeMillis(this, clampedPlayTime);
    var easedTime_0 = getEasedTimeFromIndex(this, index, clampedPlayTime, true);
    var timestampStart = this.lf0_1.l1(index);
    var startKeyframe = this.mf0_1.l1(timestampStart);
    var tmp1_elvis_lhs = startKeyframe == null ? null : startKeyframe.af1_1;
    var startValue = tmp1_elvis_lhs == null ? initialValue : tmp1_elvis_lhs;
    var timestampEnd = this.lf0_1.l1(index + 1 | 0);
    var endKeyframe = this.mf0_1.l1(timestampEnd);
    var tmp3_elvis_lhs = endKeyframe == null ? null : endKeyframe.af1_1;
    var endValue = tmp3_elvis_lhs == null ? targetValue : tmp3_elvis_lhs;
    var inductionVariable_0 = 0;
    var last_0 = valueVector.mea();
    if (inductionVariable_0 < last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'androidx.compose.animation.core.lerp' call
        var tmp$ret$0 = startValue.nea(i_0) * (1 - easedTime_0) + endValue.nea(i_0) * easedTime_0;
        valueVector.oea(i_0, tmp$ret$0);
      }
       while (inductionVariable_0 < last_0);
    return valueVector;
  };
  protoOf(VectorizedKeyframesSpec).mee = function (playTimeNanos, initialValue, targetValue, initialVelocity) {
    var playTimeMillis = divide(playTimeNanos, new Long(1000000, 0));
    var clampedPlayTime = clampPlayTime(this, playTimeMillis);
    if (compare(clampedPlayTime, new Long(0, 0)) < 0) {
      return initialVelocity;
    }
    init(this, initialValue, targetValue, initialVelocity);
    var velocityVector = ensureNotNull(this.uf0_1);
    if (!(this.zf0_1 === get_EmptyArcSpline())) {
      var easedTime = getEasedTime(this, convertToInt(clampedPlayTime));
      var slopeArray = this.yf0_1;
      this.zf0_1.zeh(easedTime, slopeArray);
      var inductionVariable = 0;
      var last = slopeArray.length - 1 | 0;
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          velocityVector.oea(i, slopeArray[i]);
        }
         while (inductionVariable <= last);
      return velocityVector;
    }
    // Inline function 'kotlin.Long.minus' call
    var tmp$ret$0 = subtract(clampedPlayTime, fromInt(1));
    var startNum = getValueFromMillis(this, tmp$ret$0, initialValue, targetValue, initialVelocity);
    var endNum = getValueFromMillis(this, clampedPlayTime, initialValue, targetValue, initialVelocity);
    var inductionVariable_0 = 0;
    var last_0 = startNum.mea();
    if (inductionVariable_0 < last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        velocityVector.oea(i_0, (startNum.nea(i_0) - endNum.nea(i_0)) * 1000.0);
      }
       while (inductionVariable_0 < last_0);
    return velocityVector;
  };
  function VectorizedKeyframeSpecElementInfo(vectorValue, easing, arcMode) {
    this.af1_1 = vectorValue;
    this.bf1_1 = easing;
    this.cf1_1 = arcMode;
  }
  protoOf(VectorizedKeyframeSpecElementInfo).toString = function () {
    return 'VectorizedKeyframeSpecElementInfo(vectorValue=' + toString(this.af1_1) + ', easing=' + toString(this.bf1_1) + ', arcMode=' + ArcMode__toString_impl_wsn638(this.cf1_1) + ')';
  };
  protoOf(VectorizedKeyframeSpecElementInfo).hashCode = function () {
    var result = hashCode(this.af1_1);
    result = imul(result, 31) + hashCode(this.bf1_1) | 0;
    result = imul(result, 31) + ArcMode__hashCode_impl_ghaz31(this.cf1_1) | 0;
    return result;
  };
  protoOf(VectorizedKeyframeSpecElementInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VectorizedKeyframeSpecElementInfo))
      return false;
    if (!equals(this.af1_1, other.af1_1))
      return false;
    if (!equals(this.bf1_1, other.bf1_1))
      return false;
    if (!(this.cf1_1 === other.cf1_1))
      return false;
    return true;
  };
  function clampPlayTime(_this__u8e3s4, playTime) {
    _init_properties_VectorizedAnimationSpec_kt__qefgpy();
    // Inline function 'kotlin.Long.minus' call
    var other = _this__u8e3s4.df0();
    var tmp0 = subtract(playTime, fromInt(other));
    var tmp2 = new Long(0, 0);
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    var maximumValue = fromInt(_this__u8e3s4.cf0());
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_0 = compare(tmp0, tmp2) < 0 ? tmp2 : tmp0;
    return compare(this_0, maximumValue) > 0 ? maximumValue : this_0;
  }
  function getValueFromMillis(_this__u8e3s4, playTimeMillis, start, end, startVelocity) {
    _init_properties_VectorizedAnimationSpec_kt__qefgpy();
    return _this__u8e3s4.hee(multiply(playTimeMillis, new Long(1000000, 0)), start, end, startVelocity);
  }
  function createSpringAnimations$1($visibilityThreshold, $dampingRatio, $stiffness) {
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = $visibilityThreshold.mea();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = Array(tmp_1);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = new FloatSpringSpec($dampingRatio, $stiffness, $visibilityThreshold.nea(tmp_3));
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.df1_1 = tmp_2;
  }
  protoOf(createSpringAnimations$1).l1 = function (index) {
    return this.df1_1[index];
  };
  function createSpringAnimations$2($dampingRatio, $stiffness) {
    this.ef1_1 = new FloatSpringSpec($dampingRatio, $stiffness);
  }
  protoOf(createSpringAnimations$2).l1 = function (index) {
    return this.ef1_1;
  };
  var properties_initialized_VectorizedAnimationSpec_kt_jkmo58;
  function _init_properties_VectorizedAnimationSpec_kt__qefgpy() {
    if (!properties_initialized_VectorizedAnimationSpec_kt_jkmo58) {
      properties_initialized_VectorizedAnimationSpec_kt_jkmo58 = true;
      EmptyIntArray = new Int32Array(0);
      EmptyFloatArray = new Float32Array(0);
      var tmp = new Int32Array(2);
      var tmp_0 = new Float32Array(2);
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$0 = [new Float32Array(2), new Float32Array(2)];
      EmptyArcSpline = new ArcSpline(tmp, tmp_0, tmp$ret$0);
      androidx_compose_animation_core_VectorizedKeyframesSpec$stable = 8;
      androidx_compose_animation_core_VectorizedKeyframeSpecElementInfo$stable = 0;
      androidx_compose_animation_core_VectorizedSnapSpec$stable = 0;
      androidx_compose_animation_core_VectorizedInfiniteRepeatableSpec$stable = 8;
      androidx_compose_animation_core_VectorizedRepeatableSpec$stable = 8;
      androidx_compose_animation_core_Spring$stable = 0;
      androidx_compose_animation_core_VectorizedSpringSpec$stable = 8;
      androidx_compose_animation_core_VectorizedTweenSpec$stable = 8;
      androidx_compose_animation_core_VectorizedFloatAnimationSpec$stable = 8;
    }
  }
  var androidx_compose_animation_core_VectorizedMonoSplineKeyframesSpec$stable;
  function get_RectVisibilityThreshold() {
    _init_properties_VisibilityThresholds_kt__rvu6yi();
    return RectVisibilityThreshold;
  }
  var RectVisibilityThreshold;
  function get_VisibilityThresholdMap() {
    _init_properties_VisibilityThresholds_kt__rvu6yi();
    return VisibilityThresholdMap;
  }
  var VisibilityThresholdMap;
  function get_VisibilityThreshold(_this__u8e3s4) {
    _init_properties_VisibilityThresholds_kt__rvu6yi();
    // Inline function 'androidx.compose.ui.unit.dp' call
    return _Dp___init__impl__ms3zkb(0.4);
  }
  function get_VisibilityThreshold_0(_this__u8e3s4) {
    _init_properties_VisibilityThresholds_kt__rvu6yi();
    // Inline function 'androidx.compose.ui.geometry.Size' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits_0(1.0));
    var v2 = fromInt(toRawBits_0(1.0));
    var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Size___init__impl__aywn0g(tmp$ret$1);
  }
  function get_VisibilityThreshold_1(_this__u8e3s4) {
    _init_properties_VisibilityThresholds_kt__rvu6yi();
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits_0(1.0));
    var v2 = fromInt(toRawBits_0(1.0));
    var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Offset___init__impl__c168vi(tmp$ret$1);
  }
  function get_VisibilityThreshold_2(_this__u8e3s4) {
    _init_properties_VisibilityThresholds_kt__rvu6yi();
    return get_RectVisibilityThreshold();
  }
  function get_VisibilityThreshold_3(_this__u8e3s4) {
    _init_properties_VisibilityThresholds_kt__rvu6yi();
    return 1;
  }
  function get_VisibilityThreshold_4(_this__u8e3s4) {
    _init_properties_VisibilityThresholds_kt__rvu6yi();
    // Inline function 'androidx.compose.ui.unit.IntOffset' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(1), 32), bitwiseAnd(fromInt(1), new Long(-1, 0)));
    return _IntOffset___init__impl__rq8h7b(tmp$ret$1);
  }
  function get_VisibilityThreshold_5(_this__u8e3s4) {
    _init_properties_VisibilityThresholds_kt__rvu6yi();
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(1), 32), bitwiseAnd(fromInt(1), new Long(-1, 0)));
    return _IntSize___init__impl__emcjft(tmp$ret$1);
  }
  var properties_initialized_VisibilityThresholds_kt_k6rdp8;
  function _init_properties_VisibilityThresholds_kt__rvu6yi() {
    if (!properties_initialized_VisibilityThresholds_kt_k6rdp8) {
      properties_initialized_VisibilityThresholds_kt_k6rdp8 = true;
      RectVisibilityThreshold = new Rect(1.0, 1.0, 1.0, 1.0);
      VisibilityThresholdMap = mapOf([to(get_VectorConverter_1(IntCompanionObject_instance), 1.0), to(get_VectorConverter_2(Companion_getInstance_5()), 1.0), to(get_VectorConverter_3(Companion_getInstance_4()), 1.0), to(get_VectorConverter(FloatCompanionObject_instance), 0.01), to(get_VectorConverter_4(Companion_getInstance_3()), 1.0), to(get_VectorConverter_5(Companion_getInstance_1()), 1.0), to(get_VectorConverter_6(Companion_getInstance_2()), 1.0), to(get_VectorConverter_0(Companion_getInstance_0()), 0.4), to(get_VectorConverter_7(Companion_getInstance_6()), 0.4)]);
    }
  }
  function binarySearch(_this__u8e3s4, element, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? _this__u8e3s4.length : toIndex;
    rangeCheck(_this__u8e3s4.length, fromIndex, toIndex);
    var low = fromIndex;
    var high = toIndex - 1 | 0;
    while (low <= high) {
      var mid = (low + high | 0) >>> 1 | 0;
      var midVal = _this__u8e3s4[mid];
      var cmp = compareTo(midVal, element);
      if (cmp < 0)
        low = mid + 1 | 0;
      else if (cmp > 0)
        high = mid - 1 | 0;
      else
        return mid;
    }
    return -(low + 1 | 0) | 0;
  }
  function rangeCheck(size, fromIndex, toIndex) {
    if (fromIndex > toIndex)
      throw IllegalArgumentException_init_$Create$('fromIndex (' + fromIndex + ') is greater than toIndex (' + toIndex + ').');
    else if (fromIndex < 0)
      throw IndexOutOfBoundsException_init_$Create$('fromIndex (' + fromIndex + ') is less than zero.');
    else if (toIndex > size)
      throw IndexOutOfBoundsException_init_$Create$('toIndex (' + toIndex + ') is greater than size (' + size + ').');
  }
  var androidx_compose_animation_core_AtomicReference$stable;
  function AtomicReference(value) {
    this.hem_1 = atomic$ref$1(value);
  }
  protoOf(AtomicReference).f1i = function () {
    return this.hem_1.kotlinx$atomicfu$value;
  };
  protoOf(AtomicReference).w21 = function (expect, newValue) {
    return this.hem_1.atomicfu$compareAndSet(expect, newValue);
  };
  var androidx_compose_animation_core_internal_PlatformOptimizedCancellationException$stable;
  function PlatformOptimizedCancellationException(message) {
    message = message === VOID ? null : message;
    CancellationException_init_$Init$(message, this);
    captureStack(this, PlatformOptimizedCancellationException);
  }
  var thread;
  function getCurrentThread() {
    return Unit_instance;
  }
  //region block: post-declaration
  protoOf(TargetBasedAnimation).iee = isFinishedFromNanos;
  protoOf(DecayAnimation).iee = isFinishedFromNanos;
  protoOf(StartDelayVectorizedAnimationSpec).aee = getEndVelocity;
  protoOf(FloatTweenSpec).aej = getEndVelocity_0;
  protoOf(FloatTweenSpec).bej = vectorize;
  protoOf(FloatSpringSpec).bej = vectorize;
  protoOf(SegmentImpl).teq = isTransitioningTo;
  protoOf(VectorizedTweenSpec).kee = getDurationNanos;
  protoOf(VectorizedTweenSpec).fee = get_isInfinite;
  protoOf(VectorizedTweenSpec).aee = getEndVelocity;
  protoOf(VectorizedSnapSpec).kee = getDurationNanos;
  protoOf(VectorizedSnapSpec).fee = get_isInfinite;
  protoOf(VectorizedSnapSpec).aee = getEndVelocity;
  protoOf(VectorizedFloatAnimationSpec).fee = get_isInfinite;
  protoOf(VectorizedInfiniteRepeatableSpec).aee = getEndVelocity;
  protoOf(VectorizedKeyframesSpec).kee = getDurationNanos;
  protoOf(VectorizedKeyframesSpec).fee = get_isInfinite;
  protoOf(VectorizedKeyframesSpec).aee = getEndVelocity;
  //endregion
  //region block: init
  androidx_compose_animation_core_TargetBasedAnimation$stable = 8;
  androidx_compose_animation_core_DecayAnimation$stable = 0;
  androidx_compose_animation_core_AnimationConstants$stable = 0;
  androidx_compose_animation_core_TweenSpec$stable = 0;
  androidx_compose_animation_core_SpringSpec$stable = 0;
  androidx_compose_animation_core_ArcAnimationSpec$stable = 0;
  androidx_compose_animation_core_RepeatableSpec$stable = 0;
  androidx_compose_animation_core_InfiniteRepeatableSpec$stable = 8;
  androidx_compose_animation_core_SnapSpec$stable = 0;
  androidx_compose_animation_core_KeyframesSpecBaseConfig$stable = 8;
  androidx_compose_animation_core_KeyframeBaseEntity$stable = 8;
  androidx_compose_animation_core_KeyframesSpec_KeyframesSpecConfig$stable = 8;
  androidx_compose_animation_core_KeyframesSpec_KeyframeEntity$stable = 8;
  androidx_compose_animation_core_KeyframesSpec$stable = 0;
  androidx_compose_animation_core_KeyframesWithSplineSpec_KeyframesWithSplineSpecConfig$stable = 8;
  androidx_compose_animation_core_KeyframesWithSplineSpec$stable = 0;
  androidx_compose_animation_core_AnimationState$stable = 0;
  androidx_compose_animation_core_AnimationScope$stable = 8;
  androidx_compose_animation_core_AnimationVector$stable = 0;
  androidx_compose_animation_core_AnimationVector1D$stable = 8;
  androidx_compose_animation_core_AnimationVector2D$stable = 8;
  androidx_compose_animation_core_AnimationVector3D$stable = 8;
  androidx_compose_animation_core_AnimationVector4D$stable = 8;
  androidx_compose_animation_core_DeferredTargetAnimation$stable = 8;
  androidx_compose_animation_core_FloatSpringSpec$stable = 8;
  androidx_compose_animation_core_FloatTweenSpec$stable = 0;
  androidx_compose_animation_core_FloatExponentialDecaySpec$stable = 0;
  androidx_compose_animation_core_InfiniteTransition$stable = 8;
  androidx_compose_animation_core_MutationInterruptedException$stable = 8;
  androidx_compose_animation_core_MutatorMutex$stable = 0;
  androidx_compose_animation_core_MonoSpline$stable = 8;
  androidx_compose_animation_core_PathEasing$stable = 0;
  androidx_compose_animation_core_SpringSimulation$stable = 8;
  androidx_compose_animation_core_VectorizedMonoSplineKeyframesSpec$stable = 8;
  androidx_compose_animation_core_AtomicReference$stable = 8;
  androidx_compose_animation_core_internal_PlatformOptimizedCancellationException$stable = 8;
  thread = Unit_instance;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Animatable_0;
  _.$_$.b = Animatable;
  _.$_$.c = AnimationState_1;
  _.$_$.d = AnimationState_0;
  _.$_$.e = AnimationState;
  _.$_$.f = AnimationVector1D;
  _.$_$.g = AnimationVector2D;
  _.$_$.h = AnimationVector4D;
  _.$_$.i = CubicBezierEasing;
  _.$_$.j = get_FastOutLinearInEasing;
  _.$_$.k = get_FastOutSlowInEasing;
  _.$_$.l = FiniteAnimationSpec;
  _.$_$.m = get_LinearEasing;
  _.$_$.n = MutableTransitionState;
  _.$_$.o = SeekableTransitionState;
  _.$_$.p = SpringSpec;
  _.$_$.q = isTransitioningTo;
  _.$_$.r = Segment;
  _.$_$.s = TweenSpec;
  _.$_$.t = TwoWayConverter;
  _.$_$.u = get_VectorConverter_3;
  _.$_$.v = get_VectorConverter_0;
  _.$_$.w = get_VectorConverter_6;
  _.$_$.x = get_VectorConverter_2;
  _.$_$.y = get_VectorConverter;
  _.$_$.z = get_VisibilityThreshold_2;
  _.$_$.a1 = get_VisibilityThreshold_3;
  _.$_$.b1 = get_VisibilityThreshold_4;
  _.$_$.c1 = get_VisibilityThreshold_5;
  _.$_$.d1 = androidx_compose_animation_core_Animatable$stableprop_getter;
  _.$_$.e1 = androidx_compose_animation_core_InfiniteRepeatableSpec$stableprop_getter;
  _.$_$.f1 = androidx_compose_animation_core_InfiniteTransition$stableprop_getter;
  _.$_$.g1 = androidx_compose_animation_core_MutableTransitionState$stableprop_getter;
  _.$_$.h1 = androidx_compose_animation_core_SeekableTransitionState$stableprop_getter;
  _.$_$.i1 = animateDpAsState;
  _.$_$.j1 = animateFloatAsState;
  _.$_$.k1 = animateFloat;
  _.$_$.l1 = animateValueAsState;
  _.$_$.m1 = calculateTargetValue;
  _.$_$.n1 = copy_0;
  _.$_$.o1 = createChildTransitionInternal;
  _.$_$.p1 = createDeferredAnimation;
  _.$_$.q1 = createTransitionAnimation;
  _.$_$.r1 = exponentialDecay;
  _.$_$.s1 = generateDecayAnimationSpec;
  _.$_$.t1 = infiniteRepeatable;
  _.$_$.u1 = keyframes;
  _.$_$.v1 = rememberInfiniteTransition;
  _.$_$.w1 = rememberTransition;
  _.$_$.x1 = snap;
  _.$_$.y1 = spring;
  _.$_$.z1 = tween;
  _.$_$.a2 = updateTransition_0;
  _.$_$.b2 = updateTransition;
  _.$_$.c2 = animateDecay;
  _.$_$.d2 = animateTo;
  _.$_$.e2 = animate;
  //endregion
  return _;
}));

//# sourceMappingURL=compose-multiplatform-core-compose-animation-animation-core.js.map
